<template>
    <div class="cart_full_width">

        <Breadcrumb :breadcrumbs="breadcrumbs"></Breadcrumb>

        <section class="cart_page pt-0 card-page-mobile cart_page_vtwo cart_page_vthree">
            <div class="container-fluid">
                <div class="cart_head">
                    <div class="left_block">
                        <h2 class="heading2 d-md-flex align-items-center">
                            Shopping Cart
                        </h2>
                    </div>
                    <div class="right_block">
                        <button class="kitting-btn d-none"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="14"
                                viewBox="0 0 13 14" fill="none" class="__web-inspector-hide-shortcut__">
                                <path
                                    d="M12.48 3.13317L6.98 0.123791C6.83305 0.0425919 6.66789 0 6.5 0C6.33211 0 6.16695 0.0425919 6.02 0.123791L0.52 3.13442C0.36293 3.22036 0.231815 3.34689 0.140345 3.50081C0.0488751 3.65472 0.000406411 3.83037 0 4.00942V9.98692C0.000406411 10.166 0.0488751 10.3416 0.140345 10.4955C0.231815 10.6494 0.36293 10.776 0.52 10.8619L6.02 13.8725C6.16695 13.9537 6.33211 13.9963 6.5 13.9963C6.66789 13.9963 6.83305 13.9537 6.98 13.8725L12.48 10.8619C12.6371 10.776 12.7682 10.6494 12.8597 10.4955C12.9511 10.3416 12.9996 10.166 13 9.98692V4.01004C12.9999 3.83068 12.9516 3.65464 12.8601 3.50036C12.7686 3.34609 12.6373 3.21926 12.48 3.13317ZM6.5 0.998791L11.5212 3.74879L9.66063 4.76754L4.63875 2.01754L6.5 0.998791ZM6.5 6.49879L1.47875 3.74879L3.5975 2.58879L8.61875 5.33879L6.5 6.49879ZM1 4.62379L6 7.36004V12.7219L1 9.98754V4.62379ZM12 9.98504L7 12.7219V7.36254L9 6.26817V8.49879C9 8.6314 9.05268 8.75858 9.14645 8.85234C9.24021 8.94611 9.36739 8.99879 9.5 8.99879C9.63261 8.99879 9.75979 8.94611 9.85355 8.85234C9.94732 8.75858 10 8.6314 10 8.49879V5.72067L12 4.62379V9.98442V9.98504Z"
                                    fill="#1D6CB5" />
                            </svg>Kitting or Handling Request?</button>
                        <a @click="emptyAllCartItems" v-show="cart_items.length" class="ml-auto font_size_16"
                            v-tooltip="'Empty cart!'">
                            <!-- <img src="/maincss/images/delete.svg" alt=" " class="mr_8" /> -->
                            <svg class="mr_8" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M17.5 4.98356C14.725 4.70856 11.9333 4.56689 9.15 4.56689C7.5 4.56689 5.85 4.65023 4.2 4.81689L2.5 4.98356"
                                    stroke="#606060" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M7.08301 4.1415L7.26634 3.04984C7.39967 2.25817 7.49967 1.6665 8.90801 1.6665H11.0913C12.4997 1.6665 12.608 2.2915 12.733 3.05817L12.9163 4.1415"
                                    stroke="#606060" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M15.7087 7.6167L15.167 16.0084C15.0753 17.3167 15.0003 18.3334 12.6753 18.3334H7.32533C5.00033 18.3334 4.92533 17.3167 4.83366 16.0084L4.29199 7.6167"
                                    stroke="#606060" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M8.6084 13.75H11.3834" stroke="#606060" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.91699 10.4165H12.0837" stroke="#606060" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span class="emt_align1">Empty Cart</span>
                        </a>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="cart_table table-responsive cart_table_custom_class" :class="{
                            empty_cart_item: cart_items.length == 0,
                            cart_tbl_mobile: isMobile()
                        }">
                            <div class="cart_table_custom_overflow">
                                <table class="table cart_table">
                                    <!-- <thead class="table_header">
                                        <tr class="header_row">
                                            <th class="artwork">
                                                <span class="d-flex"
                                                    v-tooltip="'One time setup-fee will apply for same artwork'">
                                                    Artwork
                                                    <img class="ml-1" src="/maincss/images/information.svg" />
                                                </span>
                                            </th>

                                            <th scope="col">Item</th>
                                            <th scope="col">Product</th>
                                            <th scope="col">Color</th>
                                            <th scope="col" class="quantity">Quantity</th>
                                            <th scope="col" class="cost">Cost</th>
                                            <th scope="col" class="blank_last">&nbsp;</th>
                                        </tr>
                                    </thead> -->

                                    <tbody>
                                        <tr v-if="cart_items.length == 0">
                                            <td colspan="8" class="text-center padding-mobile">
                                                No item added yet.
                                            </td>
                                        </tr>
                                        <tr v-for="(item, key) in cart_items" :key="key">
                                            <td colspan="9" class="main_data">
                                                <table>
                                                    <thead class="outer_head">
                                                        <tr class="header_row">
                                                            <td class="item-image">
                                                                <div class="cart_image d-flex">
                                                                    <DisplayProductImage
                                                                        :whateverActivatesThisLink="false"
                                                                        :product="item.main_new_product"
                                                                        :designImage="item.design_image"
                                                                        :colorProductImage="item.main_new_product_image"
                                                                        :color="item.color_id"
                                                                        :classValue="'m-auto1'" />
                                                                    <a href="#" class="hover_search" data-toggle="modal"
                                                                        :data-target="'#imagepreview-' + item.id">
                                                                        <img src="/maincss/images/zoom.svg" alt=" " />
                                                                    </a>

                                                                </div>
                                                                <ul v-if="item.decoration_colors"
                                                                    class="standard_colors">
                                                                    <li v-for="(color, index) in item.decoration_colors"
                                                                        :style="'background-color:' + color.hex + ';'"
                                                                        :key="index" v-tooltip="{
                                                                            'content': color.name ? `${color.name}<br/>${color.hex}` : color.hex,
                                                                            'html': true
                                                                        }">
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                            <td class="title_mobile">
                                                                <span class="cart_icon_image">
                                                                    Item code : <span>{{
                                                                        item.main_new_product.product_number }}</span>
                                                                    <a v-if="item.name_and_number_json.length > 0"
                                                                        :id="'nameNumbers' + item.color_id"
                                                                        @click="openNameNumbersModal(item)"
                                                                        href="javascript:void(0);"
                                                                        class="d-flex align-items-center"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <img src="/maincss/images/path.png"
                                                                            class="ml_6 path cart_icon" />
                                                                    </a>
                                                                </span>
                                                                <small v-if="item.OrderBuild">{{ item.OrderBuild.name
                                                                }}</small>
                                                                <router-link v-if="item.t_shirt_24_hour"
                                                                    :to="{ path: '/24hourtshirts/' + item.main_new_product.id }">
                                                                    <div class="product-title_block">
                                                                        <p class="item_title">
                                                                            {{ item.main_new_product.name | capitalize
                                                                            }}
                                                                        </p>
                                                                        <p class="product_qty">Quantity :
                                                                            <span>50</span>
                                                                        </p>
                                                                    </div>
                                                                </router-link>
                                                                <router-link v-else
                                                                    :to="{ path: '/product-details-new/' + item.main_new_product.id }">
                                                                    <div class="product-title_block">
                                                                        <p class="item_title">
                                                                            {{ item.main_new_product.name | capitalize
                                                                            }}
                                                                        </p>
                                                                        <p class="product_qty">Quantity : <span>({{
                                                                            item.total_quantity
                                                                        }})</span></p>
                                                                    </div>

                                                                </router-link>
                                                                <div class="size_mobile quantity_custom_div">
                                                                    <div class="d-flex flex-wrap inner_size_table">
                                                                        <div class="product_count"
                                                                            v-for="(sizeItem, sizeIndex) in item.CartChildItems"
                                                                            :key="sizeIndex">
                                                                            <div class="count_item_heading">
                                                                                <h6 class="m-0">{{
                                                                                    sizeItem.main_new_sub_product.Size.size
                                                                                }}</h6>
                                                                            </div>
                                                                            <div class="count_item_price">
                                                                                <!-- Commented out + - buttons for size -->
                                                                                <!-- <button type="button"
                                                                                    class="qty-btn qty-minus"
                                                                                    @click="decrementQuantity($event, item, sizeItem)">
                                                                                    <svg width="16" height="16"
                                                                                        viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M3.5 8H12.5"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round" />
                                                                                    </svg>
                                                                                </button> -->
                                                                                <!-- Replaced qty-display with input field -->
                                                                                <input 
                                                                                    type="number" 
                                                                                    class="qty-display qty-input"
                                                                                    :value="getDisplayQuantity(sizeItem)"
                                                                                    @input="onSizeInputChange($event, item, sizeItem)"
                                                                                    @blur="onSizeInputBlur($event, item, sizeItem)"
                                                                                    :disabled="isBusy"
                                                                                    min="0"
                                                                                    style="width: 60px; text-align: center; padding: 5px; border: 1px solid #ddd; border-radius: 4px;"
                                                                                />
                                                                                <!-- <div class="qty-display">{{
                                                                                    getDisplayQuantity(sizeItem) }}
                                                                                </div> -->
                                                                                <!-- <button type="button"
                                                                                    class="qty-btn qty-plus"
                                                                                    @click="incrementQuantity($event, item, sizeItem)">
                                                                                    <svg width="16" height="16"
                                                                                        viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M8 3.5V12.5M3.5 8H12.5"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round" />
                                                                                    </svg>
                                                                                </button> -->
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    <!-- Commented out Update button - auto-update with debounce now -->
                                                                    <!-- <a v-if="item.show_update_button"
                                                                        href="javascript:void(0);"
                                                                        @click="updateCartItem(item)"
                                                                        class="btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header mt_10">
                                                                        Update
                                                                    </a> -->
                                                                </div>
                                                                <div class=" color_block"
                                                                    v-html="productColors(item.Color)"></div>
                                                                <small
                                                                    v-if="item.decoration && item.decoration.master_service && item.decoration.master_service.name">
                                                                    {{ item.decoration.master_service.name }}
                                                                </small>
                                                                <small v-else>{{ decoration_types[item.decoration_type]
                                                                }}
                                                                </small>
                                                                <small v-if="item.t_shirt_24_hour">24 hours
                                                                    T-Shirt</small>

                                                            </td>
                                                            <td class="price_data_block">
                                                                <div class="cost-breakdown">
                                                                    <div class="delete_block">
                                                                        <div></div>
                                                                        <a href="javascript:void(0);"
                                                                            @click="deleteCartItem(item.id)"
                                                                            class="delete-item-link">
                                                                            Delete Item
                                                                        </a>
                                                                    </div>


                                                                    <div class="cost-item"
                                                                        v-if="getBaseFeeTotal(item) > 0">
                                                                        <ToolTip :label="'Base Fee'"
                                                                            :title="'Base Fee Breakdown'"
                                                                            :base-price="item.subtotal_price"
                                                                            :base-unit-price="getBaseUnitPriceFromTiers(item)"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :services="getBaseFeeServices(item)"
                                                                            :color-size-combinations="getColorSizeCombinations(item)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getBaseFeeTotal(item)) }}
                                                                        </div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="item.decoration_type !== undefined && (item.decoration_type == 0 || item.decoration_type == 1 || item.decoration_type == 2) && getRunChargeTotalFromBreakdown(item) > 0">
                                                                        <ToolTip :label="'Run Charge'"
                                                                            :title="'Run Charge Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :services="getRunChargeServices(item)"
                                                                            :run-charge-breakdown="getRunChargeBreakdown(item)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getRunChargeTotalFromBreakdown(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <!-- Custom Color Fee for single items -->
                                                                    <div class="cost-item"
                                                                        v-if="(item.decoration_type == 0 || item.decoration_type == 1 || item.decoration_type == 2) && (getColorMixFeeData(item) || (getColorMixFeeServices(item) && getColorMixFeeServices(item).length > 0)) && getColorMixFeeTotal(item) > 0 && !isGroupedDecorationType0(item)">
                                                                        <ToolTip :label="'Custom Color Fee'"
                                                                            :title="'Custom Color Fee Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :services="getColorMixFeeServices(item)"
                                                                            :color-mix-fee-data="getColorMixFeeData(item)"
                                                                            :decoration-type="item.decoration_type"
                                                                            :master-service="item.decoration && item.decoration.master_service ? item.decoration.master_service : null"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getColorMixFeeTotal(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <!-- Combined Custom Color Fee for grouped items (show in parent item only, when collapsed) -->
                                                                    <div class="cost-item"
                                                                        v-if="isGroupedDecorationType0(item) && item.subItems && item.subItems.length > 0 && item.collapse && (getCombinedColorMixFeeData(item) || hasCombinedColorMixFeeServices(item)) && getCombinedColorMixFeeTotal(item) > 0">
                                                                        <ToolTip :label="'Custom Color Fee'"
                                                                            :title="'Custom Color Fee Breakdown'"
                                                                            :base-price="0" :quantity="0"
                                                                            :services="getCombinedColorMixFeeServices(item)"
                                                                            :color-mix-fee-data="getCombinedColorMixFeeData(item)"
                                                                            :decoration-type="item.decoration_type"
                                                                            :master-service="item.decoration && item.decoration.master_service ? item.decoration.master_service : null"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getCombinedColorMixFeeTotal(item))
                                                                        }}</div>
                                                                    </div>
                                                                    <!-- Combined Custom Color Fee for grouped items (show in parent item only, when expanded) -->
                                                                    <div class="cost-item"
                                                                        v-if="isGroupedDecorationType0(item) && item.subItems && item.subItems.length > 0 && !item.collapse && (getCombinedColorMixFeeData(item) || hasCombinedColorMixFeeServices(item)) && getCombinedColorMixFeeTotal(item) > 0">
                                                                        <ToolTip :label="'Custom Color Fee'"
                                                                            :title="'Custom Color Fee Breakdown'"
                                                                            :base-price="0" :quantity="0"
                                                                            :services="getCombinedColorMixFeeServices(item)"
                                                                            :color-mix-fee-data="getCombinedColorMixFeeData(item)"
                                                                            :decoration-type="item.decoration_type"
                                                                            :master-service="item.decoration && item.decoration.master_service ? item.decoration.master_service : null"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getCombinedColorMixFeeTotal(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="item.setup_fees_details && getSetupFeeTotal(item) > 0 && (item.decoration_type == 0 || item.decoration_type == 1 || item.decoration_type == 2)">
                                                                        <ToolTip :label="'Set Up Fees'"
                                                                            :title="'Setup Fee Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(item)"
                                                                            :services="getSetupFeeServices(item)"
                                                                            :setup-fee-details="item.setup_fees_details"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getSetupFeeTotal(item))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-separator"></div>
                                                                    <template
                                                                        v-if="isGroupedDecorationType0(item) && item.subItems && item.subItems.length > 0 && item.collapse">
                                                                        <div class="cost-separator"></div>
                                                                        <div class="cost-item cost-total"
                                                                            style="text-align: right;">
                                                                            <div class="cost-label"
                                                                                style="text-align: right;">
                                                                                <span>Group Sub Total</span>
                                                                            </div>
                                                                            <div class="cost-value"
                                                                                style="text-align: right;">{{
                                                                                    icPriceFormat(getGroupSubTotal(item)) }}
                                                                            </div>
                                                                        </div>
                                                                        <!-- Discount for grouped items (when collapsed) -->
                                                                        <div class="cost-item cost-total cost-disocunt-row"
                                                                            v-if="getItemDiscount(item) > 0"
                                                                            style="text-align: right;">
                                                                            <div class="cost-label"
                                                                                style="text-align: right;">
                                                                                <span>Discount</span>
                                                                            </div>
                                                                            <div class="cost-value discount-value">
                                                                                -{{ icPriceFormat(getItemDiscount(item)) }}
                                                                            </div>
                                                                        </div>
                                                                        <!-- Final Total after discount for grouped items (when collapsed) -->
                                                                        <div class="cost-item cost-total"
                                                                            v-if="getItemDiscount(item) > 0"
                                                                            style="text-align: right;">
                                                                            <div class="cost-label"
                                                                                style="text-align: right;">
                                                                                <span>Total</span>
                                                                            </div>
                                                                            <div class="cost-value"
                                                                                style="text-align: right;">
                                                                                {{ icPriceFormat(getGroupSubTotal(item) - getItemDiscount(item)) }}
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                    <template v-else>
                                                                        <!-- For grouped items when expanded, show only Item Sub Total (discount will show in last subItem) -->
                                                                        <template v-if="isGroupedDecorationType0(item) && item.subItems && item.subItems.length > 0 && !item.collapse">
                                                                            <div class="cost-item cost-total">
                                                                                <div class="cost-label">
                                                                                    <span>Item Sub Total</span>
                                                                                </div>
                                                                                <div class="cost-value">{{
                                                                                    icPriceFormat(getItemSubTotalForGroupedParent(item)) }}
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                        <!-- For single items, show Item Sub Total, Discount, and Total -->
                                                                        <template v-else>
                                                                            <div class="cost-item cost-total">
                                                                                <div class="cost-label">
                                                                                    <span>Item Sub Total</span>
                                                                                </div>
                                                                                <div class="cost-value">{{
                                                                                    icPriceFormat(getItemSubTotal(item)) }}
                                                                                </div>
                                                                            </div>
                                                                            <!-- Discount for single items -->
                                                                            <div class="cost-item cost-total cost-disocunt-row"
                                                                                v-if="getItemDiscount(item) > 0">
                                                                                <div class="cost-label">
                                                                                    <span>Discount</span>
                                                                                </div>
                                                                                <div class="cost-value discount-value">
                                                                                    -{{ icPriceFormat(getItemDiscount(item)) }}
                                                                                </div>
                                                                            </div>
                                                                            <!-- Final Total after discount for single items -->
                                                                            <div class="cost-item cost-total"
                                                                                v-if="getItemDiscount(item) > 0">
                                                                                <div class="cost-label">
                                                                                    <span>Total</span>
                                                                                </div>
                                                                                <div class="cost-value">
                                                                                    {{ icPriceFormat(getItemSubTotal(item) - getItemDiscount(item)) }}
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </template>
                                                                </div>
                                                            </td>

                                                            <!-- <td class="price">{{ icPriceFormat(item.total_price) }}</td> -->

                                                            <!-- <td class="mobile_rgt_50 delete_col">
                                                                <a data-original-title="null" class=" has-tooltip"
                                                                    @click="deleteCartItem(item.id)"
                                                                    v-tooltip="'Delete item!'">
                                                                    <img src="/maincss/images/trash.svg" alt=" ">
                                                                </a>
                                                            </td> -->
                                                            <div class="modal fade cart_preview"
                                                                :id="'imagepreview-' + item.id" data-backdrop="static"
                                                                data-keyboard="false" tabindex="-1"
                                                                aria-labelledby="staticBackdropLabel"
                                                                aria-hidden="true">
                                                                <div class="modal-dialog modal-dialog-centered cart_modal_s"
                                                                    style="max-width: 823px; width: 100%">
                                                                    <div class="modal-content">
                                                                        <div class="modal-header border-bottom-0 p-0">
                                                                            <button type="button" class="close"
                                                                                data-dismiss="modal" aria-label="Close">
                                                                                <img src="/maincss/images/cancel.svg" />
                                                                            </button>
                                                                        </div>
                                                                        <div v-if="item.design_images &&
                                                                            item.design_images.length > 0
                                                                        " class="modal-body pt-0">
                                                                            <div :class="'canvas_auto_preview_images ' +
                                                                                (item.design_images &&
                                                                                    item.design_images.length > 0
                                                                                    ? 'new_canvas_images' +
                                                                                    item.design_images.length
                                                                                    : '')
                                                                                "
                                                                                style="display: flex; margin-top: 20px">
                                                                                <div class="mx-auto preview-image"
                                                                                    style="padding-left: 10px"
                                                                                    v-for="(design_img, index) in item.design_images"
                                                                                    :key="index">
                                                                                    <h4>
                                                                                        {{
                                                                                            (design_img.label) ? design_img.label.replace(
                                                                                                /(?:^|\s|-)\S/g,
                                                                                                (x) => x.toUpperCase()
                                                                                            ) : ''
                                                                                        }}
                                                                                    </h4>
                                                                                    <DisplayProductImage
                                                                                        :product="item.main_new_product"
                                                                                        :classValue="'m-auto'"
                                                                                        :designImage="design_img.url"
                                                                                        :color="item.color_id"
                                                                                        :backgroundColorHex="design_img.label ? (((design_img.label.replace(
                                                                                            /(?:^|\s|-)\S/g,
                                                                                            (x) => x.toUpperCase()
                                                                                        ) == 'Left') || (design_img.label.replace(
                                                                                            /(?:^|\s|-)\S/g,
                                                                                            (x) => x.toUpperCase()
                                                                                        ) == 'Right')) ? item.Color.hex : '') : ''"
                                                                                        :whateverActivatesThisLink="false" />
                                                                                    <!-- <h3>{{ item.main_new_product.name | capitalize }}</h3> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-else class="modal-body pt-0">
                                                                            <div class="canvas_auto_preview_images new_canvas_images1"
                                                                                style="display: flex; margin-top: 20px">
                                                                                <div class="mx-auto preview-image"
                                                                                    style="padding-left: 10px">
                                                                                    <DisplayProductImage
                                                                                        :whateverActivatesThisLink="false"
                                                                                        :product="item.main_new_product"
                                                                                        :designImage="item.design_image"
                                                                                        :colorProductImage="item.main_new_product_image"
                                                                                        :color="item.color_id"
                                                                                        :classValue="'m-auto'" />
                                                                                    <!-- <h3>{{ item.main_new_product.name | capitalize }}</h3> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- <td class="accordion_action">
                                                                <span v-if="item.subItems && (item.subItems.length > 0)"
                                                                    data-toggle="collapse"
                                                                    :href="`#subItemsModal${item.id}`" role="button"
                                                                    aria-expanded="true" aria-controls="collapseExample"
                                                                    @click="item.collapse = !item.collapse; $forceUpdate();">
                                                                    <a href="javascript:void(0);"
                                                                        v-if="item.collapse"><img
                                                                            src="/maincss/images/plus-ic.svg"
                                                                            alt=""></a>
                                                                    <a href="javascript:void(0);" v-else><img
                                                                            src="/maincss/images/minus-ic.svg"
                                                                            alt=""></a>
                                                                </span>
                                                            </td> -->

                                                        </tr>
                                                    </thead>
                                                    <tbody class="collapse inner_tbody show"
                                                        :id="`subItemsModal${item.id}`">
                                                        <tr v-for="(subItem, subItemIndex) in item.subItems"
                                                            :key="subItemIndex">
                                                            <td class="item-image">
                                                                <div class="cart_image d-flex">
                                                                    <DisplayProductImage
                                                                        :whateverActivatesThisLink="false"
                                                                        :product="subItem.main_new_product"
                                                                        :designImage="subItem.design_image"
                                                                        :colorProductImage="subItem.main_new_product_image"
                                                                        :color="subItem.color_id"
                                                                        :classValue="'m-auto1'" />
                                                                    <a href="#" class="hover_search" data-toggle="modal"
                                                                        :data-target="'#imagepreview-' + subItem.id">
                                                                        <img src="/maincss/images/zoom.svg" alt=" " />
                                                                    </a>

                                                                </div>
                                                                <router-link v-if="subItem.t_shirt_24_hour"
                                                                    class="product_items_no_custom"
                                                                    :to="{ path: '/24hourtshirts/' + subItem.main_new_product.id }">
                                                                    <p class="text-center mt_14 mb_0">
                                                                        {{ subItem.main_new_product.product_number }}
                                                                    </p>
                                                                </router-link>
                                                                <ul v-if="subItem.decoration_colors && subItem.decoration_colors.length > 0"
                                                                    class="standard_colors">
                                                                    <li v-for="(color, index) in subItem.decoration_colors"
                                                                        :style="'background-color:' + color.hex + ';'"
                                                                        :key="index" v-tooltip="{
                                                                            'content': color.name ? `${color.name}<br/>${color.hex}` : color.hex,
                                                                            'html': true
                                                                        }">
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                            <td class="title_mobile">
                                                                <span class="cart_icon_image">
                                                                    Item code :
                                                                    <span>{{ subItem.main_new_product.product_number
                                                                    }}</span>
                                                                    <a v-if="subItem.name_and_number_json.length > 0"
                                                                        :id="'nameNumbers' + subItem.color_id"
                                                                        @click="openNameNumbersModal(subItem)"
                                                                        href="javascript:void(0);"
                                                                        class="d-flex align-items-center"
                                                                        aria-haspopup="true" aria-expanded="false">
                                                                        <img src="/maincss/images/path.png"
                                                                            class="ml_6 path cart_icon" />
                                                                    </a>
                                                                </span>
                                                                <router-link v-if="subItem.t_shirt_24_hour"
                                                                    :to="{ path: '/24hourtshirts/' + subItem.main_new_product.id }">
                                                                    <div class="product-title_block">
                                                                        <p class="item_title">
                                                                            {{ subItem.main_new_product.name |
                                                                                capitalize }}
                                                                        </p>
                                                                        <p class="product_qty">Quantity : <span>({{
                                                                            subItem.total_quantity
                                                                        }})</span></p>
                                                                    </div>
                                                                </router-link>
                                                                <router-link v-else
                                                                    :to="{ path: '/product-details-new/' + subItem.main_new_product.id }">
                                                                    <div class="product-title_block">
                                                                        <p class="item_title">
                                                                            {{ subItem.main_new_product.name |
                                                                                capitalize }}
                                                                        </p>
                                                                        <p class="product_qty">Quantity : <span>({{
                                                                            subItem.total_quantity
                                                                        }})</span></p>
                                                                    </div>
                                                                </router-link>

                                                                <div class="size_mobile quantity_custom_div">
                                                                    <div class="d-flex flex-wrap inner_size_table">
                                                                        <div class="product_count"
                                                                            v-for="(sizeItem, subItemSizeIndex) in subItem.CartChildItems"
                                                                            :key="subItemSizeIndex">
                                                                            <div class="count_item_heading">
                                                                                <h6 class="m-0">{{
                                                                                    sizeItem.main_new_sub_product.Size.size
                                                                                }}</h6>
                                                                            </div>
                                                                            <div class="count_item_price">
                                                                                <!-- Commented out + - buttons for size -->
                                                                                <!-- <button type="button"
                                                                                    class="qty-btn qty-minus"
                                                                                    @click="decrementQuantity($event, subItem, sizeItem)">
                                                                                    <svg width="16" height="16"
                                                                                        viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M3.5 8H12.5"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round" />
                                                                                    </svg>
                                                                                </button> -->
                                                                                <!-- Replaced qty-display with input field -->
                                                                                <input 
                                                                                    type="number" 
                                                                                    class="qty-display qty-input"
                                                                                    :value="getDisplayQuantity(sizeItem)"
                                                                                    @input="onSizeInputChange($event, subItem, sizeItem)"
                                                                                    @blur="onSizeInputBlur($event, subItem, sizeItem)"
                                                                                    :disabled="isBusy"
                                                                                    min="0"
                                                                                    style="width: 60px; text-align: center; padding: 5px; border: 1px solid #ddd; border-radius: 4px;"
                                                                                />
                                                                                <!-- <div class="qty-display">{{
                                                                                    getDisplayQuantity(sizeItem) }}
                                                                                </div> -->
                                                                                <!-- <button type="button"
                                                                                    class="qty-btn qty-plus"
                                                                                    @click="incrementQuantity($event, subItem, sizeItem)">
                                                                                    <svg width="16" height="16"
                                                                                        viewBox="0 0 16 16" fill="none">
                                                                                        <path d="M8 3.5V12.5M3.5 8H12.5"
                                                                                            stroke="currentColor"
                                                                                            stroke-width="1.5"
                                                                                            stroke-linecap="round" />
                                                                                    </svg>
                                                                                </button> -->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!-- Commented out Update button - auto-update with debounce now -->
                                                                    <!-- <a v-if="subItem.show_update_button"
                                                                        href="javascript:void(0);"
                                                                        @click="updateCartItem(subItem)"
                                                                        class="btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header mt_10">
                                                                        Update
                                                                    </a> -->
                                                                </div>
                                                                <div class="color_mobile">
                                                                    <div class="color_block"
                                                                        v-html="productColors(subItem.Color)"></div>
                                                                </div>
                                                                <small
                                                                    v-if="subItem.decoration && subItem.decoration.master_service && subItem.decoration.master_service.name">
                                                                    {{ subItem.decoration.master_service.name }}
                                                                </small>
                                                                <small v-else>{{
                                                                    decoration_types[subItem.decoration_type] }}
                                                                </small>
                                                            </td>


                                                            <td class="price_data_block">
                                                                <div class="cost-breakdown">
                                                                    <div class="delete_block">
                                                                        <div></div>
                                                                        <a href="javascript:void(0);"
                                                                            @click="deleteCartItem(subItem.id)"
                                                                            class="delete-item-link">
                                                                            Delete Item
                                                                        </a>
                                                                    </div>
                                                                    <div class="cost-item"
                                                                        v-if="getBaseFeeTotal(subItem) > 0">
                                                                        <ToolTip :label="'Base Fee'"
                                                                            :title="'Base Fee Breakdown'"
                                                                            :base-price="subItem.subtotal_price"
                                                                            :base-unit-price="getBaseUnitPriceFromTiers(subItem)"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :services="getBaseFeeServices(subItem)"
                                                                            :color-size-combinations="getColorSizeCombinations(subItem)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getBaseFeeTotal(subItem)) }}
                                                                        </div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="subItem.decoration_type !== undefined && (subItem.decoration_type == 0 || subItem.decoration_type == 1 || subItem.decoration_type == 2) && getRunChargeTotalFromBreakdown(subItem) > 0">
                                                                        <ToolTip :label="'Run Charge'"
                                                                            :title="'Run Charge Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :services="getRunChargeServices(subItem)"
                                                                            :run-charge-breakdown="getRunChargeBreakdown(subItem)"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getRunChargeTotalFromBreakdown(subItem))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="(subItem.decoration_type == 0 || subItem.decoration_type == 1 || subItem.decoration_type == 2) && (getColorMixFeeData(subItem) || (getColorMixFeeServices(subItem) && getColorMixFeeServices(subItem).length > 0)) && getColorMixFeeTotal(subItem) > 0 && !isGroupedDecorationType0(item)">
                                                                        <ToolTip :label="'Custom Color Fee'"
                                                                            :title="'Custom Color Fee Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :services="getColorMixFeeServices(subItem)"
                                                                            :color-mix-fee-data="getColorMixFeeData(subItem)"
                                                                            :decoration-type="subItem.decoration_type"
                                                                            :master-service="subItem.decoration && subItem.decoration.master_service ? subItem.decoration.master_service : null"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getColorMixFeeTotal(subItem))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-item"
                                                                        v-if="subItem.setup_fees_details && getSetupFeeTotal(subItem) > 0 && (subItem.decoration_type == 0 || subItem.decoration_type == 1 || subItem.decoration_type == 2)">
                                                                        <ToolTip :label="'Set Up Fees'"
                                                                            :title="'Setup Fee Breakdown'"
                                                                            :base-price="0"
                                                                            :quantity="getTotalItemQuantity(subItem)"
                                                                            :services="getSetupFeeServices(subItem)"
                                                                            :setup-fee-details="subItem.setup_fees_details"
                                                                            :format-price="icPriceFormat" />
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getSetupFeeTotal(subItem))
                                                                        }}</div>
                                                                    </div>

                                                                    <div class="cost-separator"></div>

                                                                    <div class="cost-item cost-total">
                                                                        <div class="cost-label">
                                                                            <span>Item Sub Total</span>
                                                                        </div>
                                                                        <div class="cost-value">{{
                                                                            icPriceFormat(getItemSubTotal(subItem,
                                                                                item)) }}</div>
                                                                    </div>

                                                                    <!-- Group Sub Total for grouped items (show only on last subItem when expanded, custom color fee already shown in parent) -->
                                                                    <template
                                                                        v-if="isGroupedDecorationType0(item) && subItemIndex === item.subItems.length - 1 && !item.collapse">
                                                                        <div class="cost-separator"></div>
                                                                        <div class="cost-item cost-total"
                                                                            style="text-align: right;">
                                                                            <div class="cost-label"
                                                                                style="text-align: right;">
                                                                                <span>Group Sub Total</span>
                                                                            </div>
                                                                            <div class="cost-value"
                                                                                style="text-align: right;">{{
                                                                                    icPriceFormat(getGroupSubTotal(item)) }}
                                                                            </div>
                                                                        </div>
                                                                        <!-- Discount for grouped items (when expanded) -->
                                                                        <div class="cost-item cost-total cost-disocunt-row"
                                                                            v-if="getItemDiscount(item) > 0"
                                                                            style="text-align: right;">
                                                                            <div class="cost-label"
                                                                                style="text-align: right;">
                                                                                <span>Discount</span>
                                                                            </div>
                                                                            <div class="cost-value discount-value">
                                                                                -{{ icPriceFormat(getItemDiscount(item)) }}
                                                                            </div>
                                                                        </div>
                                                                        <!-- Final Total after discount for grouped items (when expanded) -->
                                                                        <div class="cost-item cost-total"
                                                                            v-if="getItemDiscount(item) > 0"
                                                                            style="text-align: right;">
                                                                            <div class="cost-label"
                                                                                style="text-align: right;">
                                                                                <span>Total</span>
                                                                            </div>
                                                                            <div class="cost-value"
                                                                                style="text-align: right;">
                                                                                {{ icPriceFormat(getGroupSubTotal(item) - getItemDiscount(item)) }}
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </td>
                                                            <!-- <td class="price"></td> -->

                                                            <div class="modal fade cart_preview"
                                                                :id="'imagepreview-' + subItem.id"
                                                                data-backdrop="static" data-keyboard="false"
                                                                tabindex="-1" aria-labelledby="staticBackdropLabel"
                                                                aria-hidden="true">
                                                                <div class="modal-dialog modal-dialog-centered cart_modal_s"
                                                                    style="max-width: 823px; width: 100%">
                                                                    <div class="modal-content">
                                                                        <div class="modal-header border-bottom-0 p-0">
                                                                            <button type="button" class="close"
                                                                                data-dismiss="modal" aria-label="Close">
                                                                                <img src="/maincss/images/cancel.svg" />
                                                                            </button>
                                                                        </div>
                                                                        <div v-if="subItem.design_images &&
                                                                            subItem.design_images.length > 0
                                                                        " class="modal-body pt-0">
                                                                            <div :class="'canvas_auto_preview_images ' +
                                                                                (subItem.design_images &&
                                                                                    subItem.design_images.length > 0
                                                                                    ? 'new_canvas_images' +
                                                                                    subItem.design_images.length
                                                                                    : '')
                                                                                "
                                                                                style="display: flex; margin-top: 20px">
                                                                                <div class="mx-auto preview-image"
                                                                                    style="padding-left: 10px" v-for="(
design_img, index
                                            ) in subItem.design_images" :key="index">
                                                                                    <h4>
                                                                                        {{
                                                                                            (design_img.label) ? design_img.label.replace(
                                                                                                /(?:^|\s|-)\S/g,
                                                                                                (x) => x.toUpperCase()
                                                                                            ) : ''
                                                                                        }}
                                                                                    </h4>
                                                                                    <DisplayProductImage
                                                                                        :product="subItem.main_new_product"
                                                                                        :classValue="'m-auto'"
                                                                                        :designImage="design_img.url"
                                                                                        :color="subItem.color_id"
                                                                                        :backgroundColorHex="design_img.label ? (((design_img.label.replace(
                                                                                            /(?:^|\s|-)\S/g,
                                                                                            (x) => x.toUpperCase()
                                                                                        ) == 'Left') || (design_img.label.replace(
                                                                                            /(?:^|\s|-)\S/g,
                                                                                            (x) => x.toUpperCase()
                                                                                        ) == 'Right')) ? subItem.Color.hex : '') : ''"
                                                                                        :whateverActivatesThisLink="false" />
                                                                                    <!-- <h3>{{ item.main_new_product.name | capitalize }}</h3> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-else class="modal-body pt-0">
                                                                            <div class="canvas_auto_preview_images new_canvas_images1"
                                                                                style="display: flex; margin-top: 20px">
                                                                                <div class="mx-auto preview-image"
                                                                                    style="padding-left: 10px">
                                                                                    <DisplayProductImage
                                                                                        :whateverActivatesThisLink="false"
                                                                                        :product="subItem.main_new_product"
                                                                                        :designImage="subItem.design_image"
                                                                                        :colorProductImage="subItem.product_image"
                                                                                        :color="subItem.color_id"
                                                                                        :classValue="'m-auto'" />
                                                                                    <!-- <h3>{{ item.product.name | capitalize }}</h3> -->
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </tr>

                                                    </tbody>
                                                    <tr class="total-block d-none">
                                                        <td class="on_way">
                                                            <img v-if="haveRushFee(item)"
                                                                src="/maincss/images/on-way.svg" alt=" " class="mr_8" />
                                                        </td>
                                                        <td></td>
                                                        <td></td>
                                                        <td colspan="2" class="fee_data">
                                                            <div v-if="item.sp_setup_fee && item.build_id">
                                                                Per Color Setup Fee ( {{ item.sp_decoration_colors_count
                                                                }} * {{ icPriceFormat(item.per_color_setup_cost) }} ):
                                                                <span> {{ icPriceFormat(item.sp_setup_fee) }}</span>
                                                            </div>
                                                            <div v-if="item.emb_setup_fee && item.build_id">
                                                                Digitizing Fee:
                                                                <span> {{ icPriceFormat(item.emb_setup_fee) }}</span>
                                                            </div>
                                                            <div class="d-flex align-items-center"
                                                                v-if="item.sp_imprint_locations && item.sp_imprint_locations.length && (item.sp_decoration_colors_count > 0) && item.build_id">
                                                                Screen Print Color Fee
                                                                <div class="more_color_link dropdown">
                                                                    <a href="#" id="dropdownMenuButton551"
                                                                        data-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                        class="dropdown-toggle d-flex align-items-center">
                                                                        <img src="/maincss/images/information.svg"
                                                                            class="ml_6">
                                                                    </a>
                                                                    <div aria-labelledby="dropdownMenuButton"
                                                                        class="dropdown-menu">
                                                                        <h4
                                                                            class="font_size_16 text_primary_blue py_2 px_20">
                                                                            Imprint locations & colors
                                                                            <span class="cross_ic"><img
                                                                                    src="/maincss/images/cross.svg"></span>
                                                                        </h4>
                                                                        <div class="scroll">
                                                                            <div v-for="(location, key) in item.sp_imprint_locations"
                                                                                :key="key">
                                                                                <div v-if="location.no_of_color"
                                                                                    class="dropdown-item d-flex align-items-center">
                                                                                    <p class="font-weight-bold">
                                                                                        Imprint Location: {{
                                                                                            location.location }}
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-if="location.total_decoration_fee">
                                                                                        {{
                                                                                            icPriceFormat(location.total_decoration_fee)
                                                                                        }}
                                                                                    </p>
                                                                                </div>

                                                                                <div v-for="(colors, color_key) in location.colors"
                                                                                    :key="color_key"
                                                                                    class="dropdown-item d-flex align-items-center">
                                                                                    <p v-if="colors.color"
                                                                                        class="font-weight-bold w-25">
                                                                                        Color {{ color_key + 1 }} -
                                                                                        {{ colors.color.color_name }}:
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-if="(colors.color.color_id == 0) && colors.color.non_standard_fee">
                                                                                        {{
                                                                                            icPriceFormat(colors.color.non_standard_fee)
                                                                                        }}
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-else-if="colors.total_decor_upcharge">
                                                                                        {{
                                                                                            icPriceFormat(colors.total_decor_upcharge)
                                                                                        }}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>:
                                                                <span> {{ icPriceFormat(item.sp_decoration_colors_price)
                                                                }}</span>
                                                            </div>
                                                            <div class="d-flex align-items-center"
                                                                v-if="item.emb_imprint_locations && item.emb_imprint_locations.length && (item.emb_decoration_colors_count > 0) && item.build_id">
                                                                Embroidery Color Fee
                                                                <div class="more_color_link dropdown">
                                                                    <a href="#" id="dropdownMenuButton551"
                                                                        data-toggle="dropdown" aria-haspopup="true"
                                                                        aria-expanded="false"
                                                                        class="dropdown-toggle d-flex align-items-center">
                                                                        <img src="/maincss/images/information.svg"
                                                                            class="ml_6">
                                                                    </a>
                                                                    <div aria-labelledby="dropdownMenuButton"
                                                                        class="dropdown-menu">
                                                                        <h4
                                                                            class="font_size_16 text_primary_blue py_2 px_20">
                                                                            Embroidery locations & colors
                                                                            <span class="cross_ic"><img
                                                                                    src="/maincss/images/cross.svg"></span>
                                                                        </h4>
                                                                        <div class="scroll">
                                                                            <div v-for="(location, key) in item.emb_imprint_locations"
                                                                                :key="key">
                                                                                <div v-if="location.no_of_color"
                                                                                    class="dropdown-item d-flex align-items-center">
                                                                                    <p class="font-weight-bold">
                                                                                        Embroidery Location: {{
                                                                                            location.location }}
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-if="location.total_decoration_fee">
                                                                                        {{
                                                                                            icPriceFormat(location.total_decoration_fee)
                                                                                        }}
                                                                                    </p>
                                                                                </div>

                                                                                <div v-for="(colors, color_key) in location.colors"
                                                                                    :key="color_key"
                                                                                    class="dropdown-item d-flex align-items-center">
                                                                                    <p v-if="colors.color"
                                                                                        class="font-weight-bold w-25">
                                                                                        Color {{ color_key + 1 }} -
                                                                                        {{ colors.color.color_name }}:
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-if="(colors.color.color_id == 0) && colors.color.non_standard_fee">
                                                                                        {{
                                                                                            icPriceFormat(colors.color.non_standard_fee)
                                                                                        }}
                                                                                    </p>
                                                                                    <p class="ml-auto"
                                                                                        v-else-if="colors.total_decor_upcharge">
                                                                                        {{
                                                                                            icPriceFormat(colors.total_decor_upcharge)
                                                                                        }}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>:
                                                                <span> {{
                                                                    icPriceFormat(item.emb_decoration_colors_price)
                                                                }}</span>
                                                            </div>
                                                        </td>
                                                        <td colspan="4" class="fee_data">
                                                            {{ item.build_id ? 'Build' : '' }} Sub Total: <span>{{
                                                                icPriceFormat(item.build_total_price) }}</span>
                                                        </td>
                                                    </tr>

                                                </table>

                                            </td>

                                        </tr>

                                    </tbody>
                                    <tr class="build-total-block d-none" v-if="cart_items.length > 0">
                                        <td colspan="1"></td>
                                        <td colspan="3"></td>
                                        <td class="total-fee-block" colspan="4">
                                            <p v-if="total_design_fee > 0">
                                                <span>Design Fee : </span>
                                                <span class="fee_amount">{{ icPriceFormat(total_design_fee) }}</span>
                                            </p>
                                            <p v-if="false">
                                                <span>
                                                    <img src="/maincss/images/on-way.svg" alt="on-way" class="mr_8" />
                                                    Rush Fee : </span>
                                                <span class="fee_amount">$0.00</span>
                                            </p>
                                            <p v-if="total_non_standard_fees_sp > 0">
                                                <span class="d-flex align-items-center">
                                                    Custom Ink Mix Fee ( {{ total_non_standard_colors_sp.length }} * {{
                                                        icPriceFormat(non_standard_fees['sp']) }} )<ul
                                                        v-if="total_non_standard_colors_sp.length > 0"
                                                        class="standard_colors">
                                                        <div class="more_color_link dropdown">
                                                            <a href="#" id="dropdownMenuButton551"
                                                                data-toggle="dropdown" aria-haspopup="true"
                                                                aria-expanded="false"
                                                                class="dropdown-toggle d-flex align-items-center">
                                                                <img src="/maincss/images/information.svg" class="ml_6">
                                                            </a>
                                                            <div aria-labelledby="dropdownMenuButton"
                                                                class="dropdown-menu">
                                                                <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                                                    Custom Ink Mix Colors
                                                                    <span class="cross_ic"><img
                                                                            src="/maincss/images/cross.svg"></span>
                                                                </h4>
                                                                <div class="dropdown-item d-flex align-items-center">
                                                                    <!-- eslint-disable -->
                                                                    <p class="mb-0">
                                                                    <ul>
                                                                        <li class="w-15"
                                                                            v-for="(color, index) in total_non_standard_colors_sp"
                                                                            :style="'background-color:' + color + ';'"
                                                                            :key="index" v-tooltip="color">
                                                                        </li>
                                                                    </ul>
                                            </p>
                                            <!-- eslint-enable -->
                            </div>
                        </div>
                    </div>
                    </ul>:
                    </span>



                    <span class="fee_amount">{{ icPriceFormat(total_non_standard_fees_sp) }}

                    </span>

                    </p>
                    <p v-if="total_non_standard_fees_emb > 0">
                        <span class="d-flex align-items-center">
                            Custom Thread Mix Fee ( {{ total_non_standard_colors_emb.length }} * {{
                                icPriceFormat(non_standard_fees['emb']) }} ) <ul
                                v-if="total_non_standard_colors_emb.length > 0" class="standard_colors">
                                <div class="more_color_link dropdown">
                                    <a href="#" id="dropdownMenuButton551" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false" class="dropdown-toggle d-flex align-items-center">
                                        <!-- <span class="fee_amount">{{ icPriceFormat(total_non_standard_fees_sp) }}</span>  -->
                                        <img src="/maincss/images/information.svg" class="ml_6">
                                    </a>
                                    <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                                        <h4 class="font_size_16 text_primary_blue py_2 px_20">
                                            Custom Ink Mix Colors
                                            <span class="cross_ic"><img src="/maincss/images/cross.svg"></span>
                                        </h4>
                                        <div class="dropdown-item d-flex align-items-center">
                                            <p class="mb-0">
                                            <ul>
                                                <li class="w-15" v-for="(color, index) in total_non_standard_colors_emb"
                                                    :style="'background-color:' + color + ';'" :key="index"
                                                    v-tooltip="color">
                                                </li>
                                            </ul>
                    </p>
                </div>
            </div>
    </div>
    </ul>:
    </span>



    <span class="fee_amount">{{ icPriceFormat(total_non_standard_fees_emb) }}

    </span>

    </p>
    <p v-if="cart_items.length > 0"><span>Total :</span> <span class="fee_amount">{{ icPriceFormat(grand_total) }}</span> </p>
    </td>
    </tr>
    </table>
    </div>
    </div>
    </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div :class="cart_items.length == 0
                ? 'cart_buttons d-flex flex-wrap mt_28 align-items-center logout_cart_empty '
                : 'cart_buttons d-flex flex-wrap mt_28 align-items-start justify-content-between'
                ">
                <a href="/product-list/apparel/28" class="btn btn_continue_shopping bg_primary_blue text_white">
                    CONTINUE SHOPPING
                </a>

                <div class="cart-summary-section">
                    <div class="cart-totals">
                        <!-- <div class="cart-total-row">
                            <span class="total-label">Sub Total</span>
                            <span class="total-value">{{ icPriceFormat(cart_subtotal) }}</span>
                        </div> -->
                        <!-- <div class="cart-total-row">
                            <span class="total-label">Sales Tax</span>
                            <span class="total-value">{{ icPriceFormat(sales_tax) }}</span>
                        </div> -->
                        <div class="cart-total-row grand-total-row" v-if="cart_items.length > 0">
                            <span class="total-label">Grand Total:</span>
                            <span class="total-value">{{ icPriceFormat(grand_total) }}</span>
                        </div>
                    </div>

                    <div class="checkout-button-wrapper">
                        <a v-if="cart_items.length > 0 && isAuthenticatedClient" @click="checkout()"
                            class="btn btn_checkout bg_primary_orange text_white">
                            CHECK OUT
                        </a>

                        <a href="#" data-toggle="modal" data-target="#login" data-path="/checkout/v3"
                            v-if="cart_items.length > 0 && !isAuthenticatedClient"
                            class="login-cart btn btn_checkout bg_primary_orange text_white">
                            <span>CHECK OUT</span>
                        </a>
                    </div>
                </div>

                <!-- :href="isError==true ? '#':'/checkout'" -->

            </div>
            <div class="preloader" v-show="isBusy">
                <div class="preloader-body">
                    <svg width="40" height="40" viewBox="0 0 40 40">
                        <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
    </div>
    </section>
    <LoginModal />



    <!-- NAME & NUMBERS MODAL -->
    <div class="modal fade name_number_popup" id="nameNumbersModal" aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title fs-5" id="exampleModalToggleLabel">Name & Numbers</h3>
                    <div class="close_modal">
                        <a href="#" class="popup-close art_poup_close" id="popup-close" data-dismiss="modal"
                            ref="popupclose">
                            <span aria-hidden="true" v-tooltip="'Close'">&times;</span>
                        </a>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="d-flex flex-row">
                        <div class="text-center" v-if="name_and_number_json.front.length > 0">
                            <h5>Front Location</h5>

                            <div class="scroll">
                                <div>
                                    <div class="col-md-12">
                                        <div class="mt_10 d-flex flex-wrap justify-content-left color_checkbox ">
                                            <div class="table-responsive">
                                                <table class="name-number-data mt-0">
                                                    <thead class="data-head">
                                                        <tr class="cart-data-col">
                                                            <th class="data-heading">
                                                                Number
                                                            </th>
                                                            <th class="data-heading">Size</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="data-body">
                                                        <tr v-for="(namesAndNumber, key) in name_and_number_json.front"
                                                            :key="key" class="cart-data-col">
                                                            <td>
                                                                {{ namesAndNumber.number }}
                                                            </td>
                                                            <td>{{ namesAndNumber.size }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" v-if="name_and_number_json.back.length > 0">
                            <h5>Back Location</h5>
                            <div class="scroll">
                                <div>
                                    <div class="col-md-12">
                                        <div class="mt_10 d-flex flex-wrap justify-content-left color_checkbox ">
                                            <div class="table-responsive">
                                                <table v-if="name_and_number_json.back.length > 0"
                                                    class="name-number-data mt-0">
                                                    <thead class="data-head">
                                                        <tr class="cart-data-col">
                                                            <th v-if="selected_name_number.back.name"
                                                                class="data-heading">
                                                                Name
                                                            </th>
                                                            <th v-if="selected_name_number.back.number"
                                                                class="data-heading">
                                                                Number
                                                            </th>
                                                            <th class="data-heading">Size</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="data-body">
                                                        <tr v-for="(namesAndNumber, key) in name_and_number_json.back"
                                                            :key="key" class="cart-data-col">
                                                            <td v-if="selected_name_number.back.name">
                                                                {{ namesAndNumber.name || '-' }}
                                                            </td>
                                                            <td v-if="selected_name_number.back.number">
                                                                {{ namesAndNumber.number || '-' }}
                                                            </td>
                                                            <td>{{ namesAndNumber.size }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_DECORATION_METHODS } from "@/store/actions.type";
import ApiService from "@/common/api.service";
import DisplayProductImage from "@/components/DisplayProductImageNew";
import LoginModal from "@/components/frontend/LoginModal";
import Breadcrumb from "@/components/Breadcrumb";
import ToolTip from "./components/ToolTip.vue";

export default {
    name: "shopping-cart",
    data() {
        return {
            isBusy: false,
            cart_items: [],
            total_design_fee: 0,
            retail_price: 0,
            decoration_price_template_values: [],
            decoration_price_template_values_for_imprint: [],
            decoration_price_template_location2: [],
            max_cart_count: 2000,
            isError: false,
            breadcrumbs: [],
            total_non_standard_fees_sp: 0,
            total_non_standard_fees_emb: 0,
            total_cart_items_count: 0,
            total_non_standard_colors_sp: [],
            total_non_standard_colors_emb: [],
            colors_limit: 6,
            decoration_types: {},
            name_and_number_json: { front: [], back: [] },
            vendor_data: null,
            vendors_list: [],
            non_standard_fees: { sp: 0, emb: 0 },
            nonStandardColorObj: {
                color_id: 0,
                color_name: "Mix Color",
                color_pms: "Non Standard",
                non_standard_fee: 0,
                decor_upcharge: 0,
                color_value: "#GGGGGG",
                swatches: "",
                category: "Non Standard",
                shades: []
            },
            sizeUpdateTimers: {} // Store debounce timers for size updates
        };
    },
    computed: {
        ...mapGetters([
            "isAuthenticatedClient",
            "currentUserClient",
            "getAdminOption",
            "adminOptions",
            "decorationMethods",
            "printTemplates",
            "embroideryTemplates"
        ]),
        tag() {
            return this.$route.params.tag;
        },
        cart_subtotal() {
            // Calculate subtotal before tax using getItemSubTotal for accurate calculation
            let subtotal = 0;
            this.cart_items.forEach((item) => {
                // For grouped decoration type 0 items, use group subtotal instead of individual subtotals
                if (
                    this.isGroupedDecorationType0(item) &&
                    item.subItems &&
                    item.subItems.length > 0
                ) {
                    // Use group subtotal which includes all items + combined custom color fee
                    const groupSubTotal = this.getGroupSubTotal(item);
                    // Subtract discount (discount is calculated on Group Sub Total for grouped items)
                    const discount = this.getItemDiscount(item);
                    subtotal += groupSubTotal - discount;
                } else {
                    // Add main item subtotal
                    const itemSubTotal = this.getItemSubTotal(item);
                    // Subtract discount for single items
                    const discount = this.getItemDiscount(item);
                    subtotal += itemSubTotal - discount;

                    // Add all sub-items subtotals (only if not grouped)
                    if (item.subItems && item.subItems.length > 0) {
                        item.subItems.forEach((subItem) => {
                            // SubItems don't have discount (discount is only on parent for grouped items)
                            subtotal += this.getItemSubTotal(subItem);
                        });
                    }
                }
            });
            return subtotal;
        },
        sales_tax() {
            // Calculate sales tax (you can adjust the tax rate as needed)
            // For now, returning 0. You can add tax calculation logic here
            return 0;
        },
        grand_total() {
            // Calculate grand total from cart_subtotal + sales_tax
            // Note: Non-standard fees (custom color fees) are already included in cart_subtotal via getItemSubTotal -> getColorMixFeeTotal
            // So we don't need to add them again here to avoid double-counting
            return this.cart_subtotal + this.sales_tax;
        }
    },
    watch: {
        decorationMethods() {
            this.decorationMethods.filter((method) => {
                this.decoration_types[method.id] = method.name;
            });
        }
    },
    components: { DisplayProductImage, LoginModal, Breadcrumb, ToolTip },
    beforeMount() {
        this.$store.dispatch(FETCH_DECORATION_METHODS);
        this.getVendorsList();
    },
    mounted() {
        this.breadcrumbs = [{ name: "Cart" }];
        document.body.classList.remove("bg_primary_light_white");
        this.isBusy = true;

        setTimeout(() => {
            let non_standard_fees_sp_obj = this.adminOptions.find(
                (option) => option.option_key == "non_standard_color_fees"
            );
            let non_standard_fees_emb_obj = this.adminOptions.find(
                (option) => option.option_key == "non_standard_color_fees_emb"
            );

            if (
                non_standard_fees_sp_obj &&
                non_standard_fees_sp_obj.option_value
            ) {
                this.non_standard_fees["sp"] = parseFloat(
                    non_standard_fees_sp_obj.option_value
                );
            }

            if (
                non_standard_fees_emb_obj &&
                non_standard_fees_emb_obj.option_value
            ) {
                this.non_standard_fees["emb"] = parseFloat(
                    non_standard_fees_emb_obj.option_value
                );
            }
        }, 500);

        if (this.currentUserClient.id === undefined) {
            setTimeout(() => {
                this.getCart();
            }, 3000);
        } else {
            this.getCart();
        }
    },
    methods: {
        getCart() {
            if (!this.currentUserClient.id) {
                this.isBusy = false;
                return;
            }
            this.isBusy = true;
            ApiService.get("/cart-new")
                .then(({ data }) => {
                if (data.success == false) {
                        this.$toast.error(data.error, {
                            position: "top-right",
                            queue: true
                        });
                    this.isBusy = false;
                    return false;
                }

                    this.total_non_standard_fees_sp =
                        data.total_non_standard_fees_sp;
                    this.total_non_standard_fees_emb =
                        data.total_non_standard_fees_emb;
                    this.total_non_standard_colors_sp =
                        data.total_non_standard_colors_sp;
                    this.total_non_standard_colors_emb =
                        data.total_non_standard_colors_emb;

                this.max_cart_count = parseInt(data.max_cart_count);

                let cart_items = [];
                let front_art_url;
                this.total_cart_items_count = data.cart_items.length;

                data.cart_items.forEach((item) => {
                        item.name_and_number_json = item.name_and_number_json
                            ? JSON.parse(item.name_and_number_json)
                            : [];
                        item.name_and_number_json =
                            item.name_and_number_json.filter(
                                (nn) => nn.name != "" || nn.number
                            );
                    this.total_design_fee += parseFloat(item.design_fee);
                        item.design_images = item.design_image
                            ? JSON.parse(item.design_image)
                            : [];

                    if (item.design_images.length > 0) {
                            item.design_image = JSON.parse(
                                item.design_image
                            )[0]["url"];
                    }

                        item.front_art_url = "";

                    if (item.design_images.length > 0) {
                            if (
                                front_art_url !=
                                item.design_images[0].design_image
                            ) {
                                item.front_art_url =
                                    item.design_images[0].design_image;
                            front_art_url = item.front_art_url;
                        }
                    }

                        item.non_standard_colors = item.non_standard_colors
                            ? JSON.parse(item.non_standard_colors)
                            : [];
                        item.decoration_colors = item.decoration_colors
                            ? JSON.parse(item.decoration_colors)
                            : [];
                        item.item_prices = item.item_prices
                            ? JSON.parse(item.item_prices)
                            : [];
                        item.location_decoration_colors =
                            item.location_decoration_colors
                                ? JSON.parse(item.location_decoration_colors)
                                : [];
                        item.imprint_locations = item.imprint_locations
                            ? JSON.parse(item.imprint_locations)
                            : [];

                    // Parse decoration and setup_fees_details if they are strings
                    if (item.decoration) {
                            item.decoration =
                                typeof item.decoration === "string"
                                    ? JSON.parse(item.decoration)
                                    : item.decoration;
                    }
                    if (item.setup_fees_details) {
                            item.setup_fees_details =
                                typeof item.setup_fees_details === "string"
                                    ? JSON.parse(item.setup_fees_details)
                                    : item.setup_fees_details;
                        }

                        item.decoration_template_data =
                            this.getDecorationTemplateData(
                                item.decoration_type,
                                item.decoration_price_template
                            );
                        if (
                            item.decoration_type == 1 &&
                            item.decoration_template_data
                        ) {
                            item.per_color_setup_cost = parseFloat(
                                item.decoration_template_data
                                    .per_color_setup_cost || 0
                            );
                    }

                    // Update global prices
                    if (
                            item.decoration_type ==
                                item.main_new_product.decoration_type &&
                            item.decoration_price_template ==
                                item.main_new_product.decoration_price_template
                        ) {
                            if (
                                item.main_new_product.decoration_price_type ==
                                "global_price"
                            ) {
                                if (
                                    item.decoration_type == 1 &&
                                    item.decoration_template_data
                                ) {
                                    item.price_decoration_bulk = JSON.stringify(
                                        {
                                            print_location1:
                                                item.decoration_template_data
                                                    .PrintLocation1Templates,
                                            print_location2:
                                                item.decoration_template_data
                                                    .PrintLocation2Templates
                                        }
                                    );
                                } else if (
                                    item.decoration_type == 2 &&
                                    item.decoration_template_data
                                ) {
                                    item.price_decoration_bulk = JSON.stringify(
                                        item.decoration_template_data
                                            .EmbroideryQuantities
                                    );
                            } else if (item.decoration_type == 0) {
                                // No decoration, no price_decoration_bulk needed
                                item.price_decoration_bulk = null;
                            }
                            } else if (
                                item.main_new_product.decoration_price_type ==
                                "custom_price"
                            ) {
                                item.price_decoration_bulk =
                                    item.main_new_product.price_decoration_bulk;
                        }
                    }

                    item.subItems = [];

                    if (item.build_id) {
                            let itemIndex = cart_items.findIndex((element) =>
                                element.front_art_url.includes(front_art_url)
                            );
                            if (itemIndex >= 0 && cart_items[itemIndex]) {
                            cart_items[itemIndex].subItems.push(item);
                        } else {
                            cart_items.push(item);
                        }
                    } else {
                        // Group by item_id AND service for visual grouping
                        // Same product with same service shows together, different services show separately
                        // But calculations will be per-item (each subItem has its own calculation)
                            let itemIndex = cart_items.findIndex((element) => {
                            // Basic matching: item_id, decoration_type, decoration_price_template
                                if (
                                    element.item_id != item.item_id ||
                                    element.decoration_type !=
                                        item.decoration_type ||
                                    element.decoration_price_template !=
                                        item.decoration_price_template
                                ) {
                                return false;
                            }

                            // For decoration type 0, also check master_service.id to identify the service
                            if (item.decoration_type == 0) {
                                let elementDecoration = element.decoration;
                                let itemDecoration = item.decoration;

                                // Parse if string
                                    if (typeof elementDecoration === "string") {
                                    try {
                                            elementDecoration =
                                                JSON.parse(elementDecoration);
                                    } catch (e) {
                                        elementDecoration = {};
                                    }
                                }
                                    if (typeof itemDecoration === "string") {
                                    try {
                                            itemDecoration =
                                                JSON.parse(itemDecoration);
                                    } catch (e) {
                                        itemDecoration = {};
                                    }
                                }

                                    const elementServiceId =
                                        elementDecoration.master_service &&
                                        elementDecoration.master_service.id
                                            ? elementDecoration.master_service
                                                  .id
                                    : null;
                                    const itemServiceId =
                                        itemDecoration.master_service &&
                                        itemDecoration.master_service.id
                                    ? itemDecoration.master_service.id
                                    : null;

                                // If both have service IDs, they must match
                                    if (
                                        elementServiceId !== null &&
                                        itemServiceId !== null
                                    ) {
                                        return (
                                            elementServiceId == itemServiceId
                                        );
                                }

                                // If one has ID and other doesn't, they're different services
                                    if (
                                        (elementServiceId !== null) !==
                                        (itemServiceId !== null)
                                    ) {
                                    return false;
                                }

                                // If neither has ID, fall back to basic matching (already matched above)
                                return true;
                            }

                            // For other decoration types, basic matching is sufficient
                            return true;
                        });

                            if (itemIndex >= 0 && cart_items[itemIndex]) {
                            cart_items[itemIndex].subItems.push(item);
                        } else {
                            cart_items.push(item);
                        }
                    }
                });

                this.markFirstTemplateProduct(cart_items);
                this.calculatePricing(cart_items);
                this.cart_items = cart_items;
                this.isBusy = false;
                })
                .catch(() => {
                this.isBusy = false;
            });
        },

        updateCartItem(cart_item) {
            // Store original quantities before applying temp quantities (for rollback if validation fails)
            const originalQuantities = new Map();
            cart_item.CartChildItems.forEach((childItem) => {
                originalQuantities.set(childItem.id, childItem.quantity);
            });
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            originalQuantities.set(
                                childItem.id,
                                childItem.quantity
                            );
                        });
                    }
                });
            }

            // First, apply temporary quantities to actual quantities
            cart_item.CartChildItems.forEach((childItem) => {
                if (
                    childItem.tempQuantity !== undefined &&
                    childItem.tempQuantity !== null
                ) {
                    childItem.quantity = childItem.tempQuantity;
                }
            });

            // Also update subItems if they exist
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            if (
                                childItem.tempQuantity !== undefined &&
                                childItem.tempQuantity !== null
                            ) {
                                childItem.quantity = childItem.tempQuantity;
                            }
                        });
                    }
                });
            }

            if (!this.validateMinQuantity(cart_item)) {
                // Revert quantities to original values if validation fails
                cart_item.CartChildItems.forEach((childItem) => {
                    if (originalQuantities.has(childItem.id)) {
                        childItem.quantity = originalQuantities.get(
                            childItem.id
                        );
                    }
                });
                if (cart_item.subItems && cart_item.subItems.length > 0) {
                    cart_item.subItems.forEach((subItem) => {
                        if (subItem.CartChildItems) {
                            subItem.CartChildItems.forEach((childItem) => {
                                if (originalQuantities.has(childItem.id)) {
                                    childItem.quantity = originalQuantities.get(
                                        childItem.id
                                    );
                                }
                            });
                        }
                    });
                }
                // Clear tempQuantity so display shows original values
                this.revertTempQuantities(cart_item);
                return;
            }

            this.isBusy = true;
            this.calculatePricing(this.cart_items);

            let params = [];
            let child_items = [];
            cart_item.CartChildItems.forEach((childItem) => {
                child_items.push({
                    id: childItem.id,
                    sub_product_id: childItem.sub_product_id,
                    case_price: childItem.case_price,
                    markup_price: childItem.markup_price,
                    markup_percentage: childItem.markup_percentage,
                    ink_price: childItem.ink_price,
                    single_location_price: childItem.single_location_price,
                    quantity: childItem.quantity || 0,
                    discount: childItem.discount || 0,
                    unit_price: childItem.unit_price || 0,
                    total_price: childItem.total_price || 0
                });
            });
            params.push({
                cart_id: cart_item.id,
                child_items: child_items,
                total_quantity: cart_item.total_quantity
            });

            // Store original quantities for rollback if API fails
            const originalQuantitiesForApi = new Map();
            cart_item.CartChildItems.forEach((childItem) => {
                originalQuantitiesForApi.set(
                    childItem.id,
                    originalQuantities.get(childItem.id)
                );
            });
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            originalQuantitiesForApi.set(
                                childItem.id,
                                originalQuantities.get(childItem.id)
                            );
                        });
                    }
                });
            }

            ApiService.post("/update-cart", params)
                .then(({ data }) => {
                if (!data.success) {
                        this.$toast.error(data.error, {
                            position: "top-right",
                            queue: true
                        });
                    // Revert quantities to original values if API call fails
                        cart_item.CartChildItems.forEach((childItem) => {
                        if (originalQuantitiesForApi.has(childItem.id)) {
                                childItem.quantity =
                                    originalQuantitiesForApi.get(childItem.id);
                            }
                        });
                        if (
                            cart_item.subItems &&
                            cart_item.subItems.length > 0
                        ) {
                            cart_item.subItems.forEach((subItem) => {
                            if (subItem.CartChildItems) {
                                    subItem.CartChildItems.forEach(
                                        (childItem) => {
                                            if (
                                                originalQuantitiesForApi.has(
                                                    childItem.id
                                                )
                                            ) {
                                                childItem.quantity =
                                                    originalQuantitiesForApi.get(
                                                        childItem.id
                                                    );
                                            }
                                        }
                                    );
                            }
                        });
                    }
                    // Clear tempQuantity so display shows original values
                    this.revertTempQuantities(cart_item);
                    this.isBusy = false;
                    return;
                }
                // Clear tempQuantity after successful update
                this.clearTempQuantities(cart_item);
                this.$root.$emit("update-cart");
                this.$toast.success("Quantity updated successfully.", {
                    position: "top-right",
                    queue: true
                });
                cart_item.show_update_button = false;
                this.isBusy = false;
                })
                .catch(() => {
                // Revert quantities to original values if API call fails
                    cart_item.CartChildItems.forEach((childItem) => {
                    if (originalQuantitiesForApi.has(childItem.id)) {
                            childItem.quantity = originalQuantitiesForApi.get(
                                childItem.id
                            );
                    }
                });
                if (cart_item.subItems && cart_item.subItems.length > 0) {
                        cart_item.subItems.forEach((subItem) => {
                        if (subItem.CartChildItems) {
                                subItem.CartChildItems.forEach((childItem) => {
                                    if (
                                        originalQuantitiesForApi.has(
                                            childItem.id
                                        )
                                    ) {
                                        childItem.quantity =
                                            originalQuantitiesForApi.get(
                                                childItem.id
                                            );
                                }
                            });
                        }
                    });
                }
                // Clear tempQuantity so display shows original values
                this.revertTempQuantities(cart_item);
                    this.$toast.error(
                        "Something went wrong. Please contact admininstrator",
                        {
                    position: "top-right",
                    queue: true
                        }
                    );
                this.isBusy = false;
            });
        },

        // Clear temporary quantities after successful update
        clearTempQuantities(cart_item) {
            cart_item.CartChildItems.forEach((childItem) => {
                childItem.tempQuantity = undefined;
            });
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            childItem.tempQuantity = undefined;
                        });
                    }
                });
            }
        },

        // Revert temporary quantities to original values
        revertTempQuantities(cart_item) {
            cart_item.CartChildItems.forEach((childItem) => {
                if (
                    childItem.tempQuantity !== undefined &&
                    childItem.tempQuantity !== null
                ) {
                    childItem.tempQuantity = undefined;
                }
            });
            if (cart_item.subItems && cart_item.subItems.length > 0) {
                cart_item.subItems.forEach((subItem) => {
                    if (subItem.CartChildItems) {
                        subItem.CartChildItems.forEach((childItem) => {
                            if (
                                childItem.tempQuantity !== undefined &&
                                childItem.tempQuantity !== null
                            ) {
                                childItem.tempQuantity = undefined;
                            }
                        });
                    }
                });
            }
        },

        emptyAllCartItems() {
            var _this = this;
            localStorage.removeItem("cart");
            localStorage.setItem("cartNotEmpty", false);
            _this.cart_items = [];

            if (_this.currentUserClient.id) {
                _this.isBusy = true;
                ApiService.post("/empty-cart")
                    .then(() => {
                        _this.$toast.error("Your Cart has been empty.", {
                            position: "top-right",
                            queue: true
                        });
                        _this.getCart();
                        _this.$root.$emit("update-cart");
                        _this.isBusy = false;
                    })
                    .catch((response) => {
                        console.log(response);
                        _this.isBusy = false;
                    });
            } else {
                _this.$root.$emit("update-cart");
                _this.$toast.error("Your Cart has been empty.", {
                    position: "top-right",
                    queue: true
                });
            }
        },

        deleteCartItem(cart_id) {
            this.isBusy = true;
            ApiService.post("/remove-cart", { cart_id: cart_id })
                .then(() => {
                    this.$toast.success(
                        "Item has been removed from the cart.",
                        {
                    position: "top-right",
                    queue: true
                        }
                    );
                this.$root.$emit("update-cart");
                this.getCart();
                this.isBusy = false;
            })
                .catch(() => {
                    this.isBusy = false;
                });
        },

        checkout() {
            let product_names = this.cart_items
                .filter((item) => item.main_new_product.status == "Disabled")
                .map((item) => item.main_new_product.name);

            if (product_names && product_names.length > 0) {
                let str = "Item";
                if (product_names.length > 1) {
                    str = "Items";
                }
                this.$toast.error(
                    `${str} ${product_names.join(
                        ","
                    )} is no longer available, please remove it from cart`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            let error = false;
            let no_quantity_error = false;
            let minimum_quantity = 0;
            this.cart_items.forEach((cart_item) => {
                minimum_quantity = this.getMinQuantity(cart_item);
                if (cart_item.build_total_quantity < minimum_quantity) {
                    error = true;
                    return;
                }
                let is_quantity_exist = cart_item.CartChildItems.find(
                    (cartChildItem) => parseInt(cartChildItem.quantity) > 0
                );
                if (!is_quantity_exist) {
                    no_quantity_error = true;
                    return;
                }
                if (cart_item.subItems) {
                    cart_item.subItems.forEach((subItem) => {
                        let is_quantity_exist = subItem.CartChildItems.find(
                            (cartChildItem) =>
                                parseInt(cartChildItem.quantity) > 0
                        );
                        if (!is_quantity_exist) {
                            no_quantity_error = true;
                            return;
                        }
                    });
                }
            });

            if (no_quantity_error == true) {
                this.$toast.error(
                    `Every Item should have atleast single quantity is required`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            if (error == true) {
                this.$toast.error(
                    `Quantity should be greater than ${minimum_quantity}`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            this.$router.push({ path: "/checkout/v3" });
        },

        onChangeQuantity(event, cartItem, size) {
            this.$set(cartItem, "show_update_button", true);
            const value = parseInt(event.target.value) || 0;
            console.log(
                event.target.value,
                this.max_cart_count,
                value > this.max_cart_count
            );
            if (value > this.max_cart_count) {
                event.target.value =
                    size.tempQuantity !== undefined &&
                    size.tempQuantity !== null
                        ? size.tempQuantity
                        : size.quantity || 0;
                this.$toast.error(
                    `Quantity should not be greater than ${this.max_cart_count}`,
                    { position: "top-right", queue: true }
                );
                return;
            }

            // Store in tempQuantity instead of directly updating quantity (use $set for reactivity)
            this.$set(size, "tempQuantity", value);
        },

        incrementQuantity(event, cartItem, size) {
            try {
                this.$set(cartItem, "show_update_button", true);
                // Use tempQuantity if available, otherwise use original quantity
                const currentValue =
                    parseInt(
                        size.tempQuantity !== undefined &&
                            size.tempQuantity !== null
                            ? size.tempQuantity
                            : size.quantity
                    ) || 0;
                const newValue = currentValue + 1;

                if (newValue > this.max_cart_count) {
                    this.$toast.error(
                        `Quantity should not be greater than ${this.max_cart_count}`,
                        { position: "top-right", queue: true }
                    );
                    return;
                }

                // Store in tempQuantity instead of directly updating quantity (use $set for reactivity)
                this.$set(size, "tempQuantity", newValue);
            } catch (error) {
                console.error("Error in incrementQuantity:", error);
            }
        },

        decrementQuantity(event, cartItem, size) {
            try {
                this.$set(cartItem, "show_update_button", true);
                // Use tempQuantity if available, otherwise use original quantity
                const currentValue =
                    parseInt(
                        size.tempQuantity !== undefined &&
                            size.tempQuantity !== null
                            ? size.tempQuantity
                            : size.quantity
                    ) || 0;
                const newValue = Math.max(0, currentValue - 1);

                // Store in tempQuantity instead of directly updating quantity (use $set for reactivity)
                this.$set(size, "tempQuantity", newValue);
            } catch (error) {
                console.error("Error in decrementQuantity:", error);
            }
        },

        // Get display quantity (tempQuantity if available, otherwise original quantity)
        getDisplayQuantity(sizeItem) {
            if (
                sizeItem.tempQuantity !== undefined &&
                sizeItem.tempQuantity !== null
            ) {
                return sizeItem.tempQuantity;
            }
            return sizeItem.quantity || 0;
        },

        // Handle size input change - only update display, no validation
        onSizeInputChange(event, cartItem, sizeItem) {
            const inputValue = event.target.value;
            let value = inputValue === "" ? 0 : parseInt(inputValue);
            if (isNaN(value)) {
                value = 0;
            }
            // Only update display during typing - no validation, no update
            this.$set(sizeItem, "tempQuantity", value);
        },

        // Handle size input blur - validation and update happens here
        onSizeInputBlur(event, cartItem, sizeItem) {
            const inputValue = event.target.value;
            const inputElement = event.target;

            // Store last valid quantity if not already stored
            if (sizeItem.lastValidQuantity === undefined) {
                sizeItem.lastValidQuantity = sizeItem.quantity || 0;
            }

            // If input is empty, check if setting to 0 would keep total above minimum
            if (
                inputValue === "" ||
                inputValue === null ||
                inputValue === undefined
            ) {
                // Calculate what total would be if we set this to 0
                const getItemTotalQuantityWithZero = (
                    item,
                    isEditingThisItem
                ) => {
                    let total = 0;
                    if (item.CartChildItems && item.CartChildItems.length > 0) {
                        item.CartChildItems.forEach((childItem) => {
                            if (
                                isEditingThisItem &&
                                childItem.id === sizeItem.id
                            ) {
                                total += 0; // Setting to 0
                            } else {
                                const qty =
                                    childItem.tempQuantity !== undefined &&
                                    childItem.tempQuantity !== null
                                        ? childItem.tempQuantity
                                        : childItem.quantity || 0;
                                total += qty;
                            }
                        });
                    }
                    return total;
                };

                let newGroupQuantityWithZero = 0;
                this.cart_items.forEach((item) => {
                    if (
                        this.isSameProduct(
                            item,
                            cartItem.item_id,
                            cartItem.decoration_type,
                            cartItem.decoration_price_template,
                            cartItem.build_id
                        )
                    ) {
                        newGroupQuantityWithZero +=
                            getItemTotalQuantityWithZero(
                                item,
                                item.id === cartItem.id
                            );
                    }
                    if (item.subItems && item.subItems.length > 0) {
                        item.subItems.forEach((subItem) => {
                            if (
                                this.isSameProduct(
                                    subItem,
                                    cartItem.item_id,
                                    cartItem.decoration_type,
                                    cartItem.decoration_price_template,
                                    cartItem.build_id
                                )
                            ) {
                                newGroupQuantityWithZero +=
                                    getItemTotalQuantityWithZero(
                                        subItem,
                                        subItem.id === cartItem.id
                                    );
                            }
                        });
                    }
                });

                const minimum_quantity = this.getMinQuantity(cartItem);

                // If setting to 0 would keep total above minimum, set to 0
                if (
                    minimum_quantity === 0 ||
                    newGroupQuantityWithZero >= minimum_quantity
                ) {
                    this.$set(sizeItem, "tempQuantity", 0);
                    sizeItem.lastValidQuantity = 0;
                    this.$nextTick(() => {
                        inputElement.value = 0;
                    });
                    // Proceed with update
                    this.isBusy = true;
                    this.updateCartItem(cartItem);
                    return;
                } else {
                    // If setting to 0 would make total below minimum, revert to last valid
                    this.$toast.error(
                        `Quantity should be greater than or equal to ${minimum_quantity}`,
                        {
                            position: "top-right",
                            queue: true,
                            timeout: 3000
                        }
                    );
                    const lastValid = sizeItem.lastValidQuantity || 0;
                    this.$set(sizeItem, "tempQuantity", lastValid);
                    this.$nextTick(() => {
                        inputElement.value = lastValid;
                    });
                    return;
                }
            }

            let finalValue = parseInt(inputValue);
            if (isNaN(finalValue)) {
                finalValue = 0;
            }

            // Validate negative values
            if (finalValue < 0) {
                const lastValid = sizeItem.lastValidQuantity || 0;
                this.$set(sizeItem, "tempQuantity", lastValid);
                this.$nextTick(() => {
                    inputElement.value = lastValid;
                });
                return;
            }

            // Check minimum quantity validation - calculate final group quantity
            const getItemTotalQuantityWithTemp = (item, isEditingThisItem) => {
                let total = 0;
                if (item.CartChildItems && item.CartChildItems.length > 0) {
                    item.CartChildItems.forEach((childItem) => {
                        if (isEditingThisItem && childItem.id === sizeItem.id) {
                            total += finalValue;
                        } else {
                            const qty =
                                childItem.tempQuantity !== undefined &&
                                childItem.tempQuantity !== null
                                    ? childItem.tempQuantity
                                    : childItem.quantity || 0;
                            total += qty;
                        }
                    });
                }
                return total;
            };

            // Calculate total quantity for this cart item (sum of all sizes)
            const cartItemTotalQuantity = getItemTotalQuantityWithTemp(
                cartItem,
                true
            );

            // Check if cart item total quantity exceeds max
            if (cartItemTotalQuantity > this.max_cart_count) {
                this.$toast.error(
                    `Total quantity for this item should not be greater than ${this.max_cart_count}`,
                    { position: "top-right", queue: true }
                );
                const lastValid = sizeItem.lastValidQuantity || 0;
                this.$set(sizeItem, "tempQuantity", lastValid);
                this.$nextTick(() => {
                    inputElement.value = lastValid;
                });
                return;
            }

            let newGroupQuantity = 0;
            this.cart_items.forEach((item) => {
                if (
                    this.isSameProduct(
                        item,
                        cartItem.item_id,
                        cartItem.decoration_type,
                        cartItem.decoration_price_template,
                        cartItem.build_id
                    )
                ) {
                    newGroupQuantity += getItemTotalQuantityWithTemp(
                        item,
                        item.id === cartItem.id
                    );
                }
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        if (
                            this.isSameProduct(
                                subItem,
                                cartItem.item_id,
                                cartItem.decoration_type,
                                cartItem.decoration_price_template,
                                cartItem.build_id
                            )
                        ) {
                            newGroupQuantity += getItemTotalQuantityWithTemp(
                                subItem,
                                subItem.id === cartItem.id
                            );
                        }
                    });
                }
            });

            // Check if other sizes in the group are being edited (have tempQuantity)
            let hasOtherPendingChanges = false;
            this.cart_items.forEach((item) => {
                if (
                    this.isSameProduct(
                        item,
                        cartItem.item_id,
                        cartItem.decoration_type,
                        cartItem.decoration_price_template,
                        cartItem.build_id
                    )
                ) {
                    if (item.CartChildItems) {
                        item.CartChildItems.forEach((childItem) => {
                            if (
                                childItem.id !== sizeItem.id &&
                                childItem.tempQuantity !== undefined &&
                                childItem.tempQuantity !== null &&
                                childItem.tempQuantity !== childItem.quantity
                            ) {
                                hasOtherPendingChanges = true;
                            }
                        });
                    }
                }
                if (item.subItems && item.subItems.length > 0) {
                    item.subItems.forEach((subItem) => {
                        if (
                            this.isSameProduct(
                                subItem,
                                cartItem.item_id,
                                cartItem.decoration_type,
                                cartItem.decoration_price_template,
                                cartItem.build_id
                            )
                        ) {
                            if (subItem.CartChildItems) {
                                subItem.CartChildItems.forEach((childItem) => {
                                    if (
                                        childItem.id !== sizeItem.id &&
                                        childItem.tempQuantity !== undefined &&
                                        childItem.tempQuantity !== null &&
                                        childItem.tempQuantity !==
                                            childItem.quantity
                                    ) {
                                        hasOtherPendingChanges = true;
                                    }
                                });
                            }
                        }
                    });
                }
            });

            const minimum_quantity = this.getMinQuantity(cartItem);

            // Only validate minimum if no other sizes are being edited
            if (
                minimum_quantity > 0 &&
                newGroupQuantity < minimum_quantity &&
                !hasOtherPendingChanges
            ) {
                this.$toast.error(
                    `Quantity should be greater than or equal to ${minimum_quantity}`,
                    {
                        position: "top-right",
                        queue: true,
                        timeout: 3000
                    }
                );
                const lastValid = sizeItem.lastValidQuantity || 0;
                this.$set(sizeItem, "tempQuantity", lastValid);
                this.$nextTick(() => {
                    inputElement.value = lastValid;
                });
                return;
            }

            // All validations passed - update lastValidQuantity and proceed with update
            sizeItem.lastValidQuantity = finalValue;
            this.isBusy = true;
            this.updateCartItem(cartItem);
        },

        getDecorationPrice(
            product,
            total_quantity,
            colorIndex = 0,
            locationIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;

            // Decoration type 0 means no decoration, return 0
            if (product.decoration_type == 0) {
                return 0;
            }

            // let total_quantity = this.getTotalBuildQuantity();

            if (product.decoration_type == 1) {
                if (!product.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data;

                if (!additional) {
                    decoration_data = JSON.parse(
                        product.price_decoration_bulk
                    ).print_location1;
                } else {
                    decoration_data = JSON.parse(
                        product.price_decoration_bulk
                    ).print_location2;
                }

                if (decoration_data) {
                    for (const [index, element] of Object.entries(
                        decoration_data
                    )) {
                        if (element.quantity <= total_quantity || index == 0) {
                            qty_wise_color_price =
                                element[`colour${colorIndex + 1}`];
                        }
                    }
                }
            } else if (product.decoration_type == 2) {
                if (!product.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data = JSON.parse(product.price_decoration_bulk);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity1 <= total_quantity || index == 0) {
                        if (locationIndex > 0) {
                            qty_wise_color_price =
                                element[`location${locationIndex + 1}`];
                        } else {
                            qty_wise_color_price = element["cost"];
                        }
                    }
                }
            }

            return parseFloat(qty_wise_color_price || 0);
        },

        getDecorationDiscount(product, total_quantity, additional = false) {
            let discount = 0;

            // Decoration type 0 means no decoration, return 0
            if (product.decoration_type == 0) {
                return 0;
            }

            if (product.decoration_type == 1) {
                if (!product.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data;

                if (!additional) {
                    decoration_data = JSON.parse(
                        product.price_decoration_bulk
                    ).print_location1;
                } else {
                    decoration_data = JSON.parse(
                        product.price_decoration_bulk
                    ).print_location2;
                }

                if (decoration_data) {
                    for (const [index, element] of Object.entries(
                        decoration_data
                    )) {
                        if (element.quantity <= total_quantity || index == 0) {
                            discount = element["discount"];
                        }
                    }
                }
            } else if (product.decoration_type == 2) {
                if (!product.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data = JSON.parse(product.price_decoration_bulk);
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity1 <= total_quantity || index == 0) {
                        discount = element["discount"];
                    }
                }
            }

            return parseFloat(discount || 0);
        },

        getTotalItemQuantity(cartItem) {
            let total_quantity = 0;
            cartItem.CartChildItems.forEach((childItem) => {
                total_quantity += parseInt(childItem.quantity || 0);
            });
            return total_quantity;
        },

        isSameProduct(
            cartItem,
            productId,
            decoration_type,
            decoration_price_template,
            build_id = null
        ) {
            if (build_id) {
                return cartItem.build_id == build_id;
            } else {
                const sameProduct = cartItem.item_id == productId;
                const sameDecorationMethod =
                    cartItem.decoration_type == decoration_type;
                const sameDecorationPriceTemplate =
                    cartItem.decoration_price_template ==
                    decoration_price_template;

                return (
                    sameProduct &&
                    sameDecorationMethod &&
                    sameDecorationPriceTemplate & !cartItem.build_id
                );
            }
        },

        getGroupQuantity(
            cart_items,
            product_id,
            decoration_type,
            decoration_price_template,
            build_id
        ) {
            let total_quantity = 0;
            cart_items.forEach((cartItem) => {
                if (
                    this.isSameProduct(
                        cartItem,
                        product_id,
                        decoration_type,
                        decoration_price_template,
                        build_id
                    )
                ) {
                    total_quantity += this.getTotalItemQuantity(cartItem);
                }
                cartItem.subItems.forEach((subItem) => {
                    if (
                        this.isSameProduct(
                            subItem,
                            product_id,
                            decoration_type,
                            decoration_price_template,
                            build_id
                        )
                    ) {
                        total_quantity += this.getTotalItemQuantity(subItem);
                    }
                });
            });

            return total_quantity;
        },

        // For sku grouping we have  item level fees if we have different template products
        // So in this case we have to show fees for first item of same template product
        // So we are marking some flag for first item
        markFirstTemplateProduct(cartItems) {
            let temp_arr = [];
            let existedData;
            cartItems.forEach((cartItem) => {
                if (cartItem.build_id) {
                    cartItem.first_item = true;
                } else if (!cartItem.build_id) {
                    if (
                        this.isSameProduct(
                            cartItem,
                            cartItem.item_id,
                            cartItem.decoration_type,
                            cartItem.decoration_price_template
                        )
                    ) {
                        existedData = temp_arr.find(
                            (d) =>
                                d.product_id == cartItem.item_id &&
                                d.decoration_type == cartItem.decoration_type &&
                                d.decoration_price_template ==
                                    cartItem.decoration_price_template
                        );
                        if (!existedData) {
                            temp_arr.push({
                                product_id: cartItem.item_id,
                                decoration_type: cartItem.decoration_type,
                                decoration_price_template:
                                    cartItem.decoration_price_template
                            });
                            cartItem.first_item = true;
                        }
                    }
                    cartItem.subItems.forEach((subItem) => {
                        if (
                            this.isSameProduct(
                                subItem,
                                subItem.item_id,
                                subItem.decoration_type,
                                subItem.decoration_price_template
                            )
                        ) {
                            existedData = temp_arr.find(
                                (d) =>
                                    d.product_id == subItem.item_id &&
                                    d.decoration_type ==
                                        subItem.decoration_type &&
                                    d.decoration_price_template ==
                                        subItem.decoration_price_template
                            );
                            if (!existedData) {
                                temp_arr.push({
                                    product_id: subItem.item_id,
                                    decoration_type: subItem.decoration_type,
                                    decoration_price_template:
                                        subItem.decoration_price_template
                                });
                                subItem.first_item = true;
                            }
                        }
                    });
                }
            });
        },

        calculateCartItemPricing(cartItems, cartItem, decoration_color_price) {
            cartItem.total_price = 0;
            cartItem.subtotal_price = 0;
            cartItem.total_quantity = 0;
            cartItem.sp_imprint_locations = [];
            cartItem.emb_imprint_locations = [];
            cartItem.sp_decoration_colors_count = 0;
            cartItem.emb_decoration_colors_count = 0;
            cartItem.sp_decoration_colors_price = 0;
            cartItem.emb_decoration_colors_price = 0;
            cartItem.sp_setup_fee = 0;
            cartItem.emb_setup_fee = 0;
            cartItem.total_location_decoration_colors = 0;

            const quantity = this.getGroupQuantity(
                cartItems,
                cartItem.item_id,
                cartItem.decoration_type,
                cartItem.decoration_price_template,
                cartItem.build_id
            );
            if (cartItem.first_item) {
                cartItem.total_location_decoration_colors =
                    this.prepareLocationDecorationColors(
                        cartItems,
                        cartItem.item_id,
                        cartItem.decoration_type,
                        cartItem.decoration_price_template,
                        cartItem.build_id
                    );
                this.prepareLocations(
                    cartItem,
                    cartItem.total_location_decoration_colors
                );
                this.calculateDecorationColorsPricing(
                    quantity,
                    cartItem,
                    cartItem.main_new_product
                );
                const decorationTemplateData = this.getDecorationTemplateData(
                    cartItem.decoration_type,
                    cartItem.decoration_price_template
                );
                if (cartItem.decoration_type == 1) {
                    cartItem.sp_setup_fee =
                        parseFloat(
                            decorationTemplateData &&
                                decorationTemplateData.per_color_setup_cost
                                ? decorationTemplateData.per_color_setup_cost
                                : 0
                        ) * cartItem.sp_decoration_colors_count;
                } else if (cartItem.decoration_type == 2) {
                    cartItem.emb_setup_fee = parseFloat(
                        decorationTemplateData &&
                            decorationTemplateData.machine_fee
                            ? decorationTemplateData.machine_fee
                            : 0
                    );
                } else if (cartItem.decoration_type == 0) {
                    // No decoration, no setup fees
                    cartItem.sp_setup_fee = 0;
                    cartItem.emb_setup_fee = 0;
                }
            }

            // Updating dark/light prices if its global price
            let color_category_price = 0;
            if (
                cartItem.decoration_type ==
                    cartItem.main_new_product.decoration_type &&
                cartItem.decoration_price_template ==
                    cartItem.main_new_product.decoration_price_template
            ) {
                if (
                    cartItem.main_new_product.decoration_price_type ==
                    "global_price"
                ) {
                    if (cartItem.decoration_template_data) {
                        if (cartItem.Color.category == "Dark") {
                            color_category_price =
                                cartItem.decoration_template_data.price_dark ||
                                0;
                        } else if (cartItem.Color.category == "Light") {
                            color_category_price =
                                cartItem.decoration_template_data.price_light ||
                                0;
                        }
                    }
                } else if (
                    cartItem.main_new_product.decoration_price_type ==
                    "custom_price"
                ) {
                    if (cartItem.Color.category == "Dark") {
                        color_category_price =
                            cartItem.main_new_product
                                .price_color_category_dark || 0;
                    } else if (cartItem.Color.category == "Light") {
                        color_category_price =
                            cartItem.main_new_product
                                .price_color_category_light || 0;
                    }
                }
            }

            cartItem.CartChildItems.forEach((childItem) => {
                childItem.single_location_price = parseFloat(
                    decoration_color_price
                );
                childItem.decoration_discount_percentage =
                    this.getDecorationDiscount(cartItem, quantity);
                if (childItem.decoration_discount_percentage) {
                    childItem.decoration_discount_value =
                        (this.icPriceFormat(childItem.case_price, true) *
                            childItem.decoration_discount_percentage) /
                        100;
                }
                childItem.ink_price = color_category_price;

                childItem.unit_price = this.getRetailPrice({
                    base_price: parseFloat(childItem.case_price),
                    markup_price: parseFloat(childItem.markup_price),
                    single_location_price: parseFloat(
                        childItem.single_location_price || 0
                    ),
                    color_category_price: childItem.ink_price,
                    decoration_discount_percentage:
                        childItem.decoration_discount_percentage
                });
                childItem.total_price =
                    this.icPriceFormat(childItem.unit_price, true) *
                    parseInt(childItem.quantity);
                cartItem.subtotal_price += parseFloat(childItem.total_price);
                cartItem.total_quantity += parseInt(childItem.quantity);
            });
            cartItem.total_price =
                parseFloat(cartItem.subtotal_price) +
                parseFloat(cartItem.item_prices.front_number_fees || 0) +
                parseFloat(cartItem.item_prices.back_name_fees || 0) +
                parseFloat(cartItem.item_prices.back_number_fees || 0) +
                parseFloat(
                    cartItem.item_prices.front_number_decor_up_fees || 0
                ) +
                parseFloat(cartItem.item_prices.back_name_decor_up_fees || 0) +
                parseFloat(cartItem.item_prices.back_number_decor_up_fees || 0);

            if (cartItem.first_item && !cartItem.build_id) {
                cartItem.total_price += this.getAdditionalFees(cartItem);
            }
        },

        prepareLocationDecorationColors(
            cart_items,
            product_id,
            decoration_type,
            decoration_price_template,
            build_id
        ) {
            let total_location_decoration_colors = {
                front: [],
                back: [],
                left: [],
                right: []
            };
            cart_items.forEach((cartItem) => {
                if (
                    this.isSameProduct(
                        cartItem,
                        product_id,
                        decoration_type,
                        decoration_price_template,
                        build_id
                    )
                ) {
                    total_location_decoration_colors =
                        cartItem.location_decoration_colors;
                }
                cartItem.subItems.forEach((subItem) => {
                    if (
                        this.isSameProduct(
                            subItem,
                            product_id,
                            decoration_type,
                            decoration_price_template,
                            build_id
                        )
                    ) {
                        total_location_decoration_colors.front = [
                            ...new Set(
                                total_location_decoration_colors.front.concat(
                                    subItem.location_decoration_colors.front
                                )
                            )
                        ];
                        total_location_decoration_colors.back = [
                            ...new Set(
                                total_location_decoration_colors.back.concat(
                                    subItem.location_decoration_colors.back
                                )
                            )
                        ];
                        total_location_decoration_colors.left = [
                            ...new Set(
                                total_location_decoration_colors.left.concat(
                                    subItem.location_decoration_colors.left
                                )
                            )
                        ];
                        total_location_decoration_colors.right = [
                            ...new Set(
                                total_location_decoration_colors.right.concat(
                                    subItem.location_decoration_colors.right
                                )
                            )
                        ];
                    }
                });
            });
            return total_location_decoration_colors;
        },

        // This function calculate prices for all cart items 
        calculatePricing(cart_items) {
            try {
                let quantity = 0;
                cart_items.forEach((cartItem) => {
                    quantity = this.getGroupQuantity(
                        cart_items,
                        cartItem.item_id,
                        cartItem.decoration_type,
                        cartItem.decoration_price_template,
                        cartItem.build_id
                    );
                    this.calculateCartItemPricing(
                        cart_items,
                        cartItem,
                        this.getDecorationPrice(cartItem, quantity)
                    );

                    // Calculate build_total_price using getItemSubTotal for accurate calculation
                    // Note: getItemSubTotal already includes all fees (base fee, run charge, setup fee, custom color fee, name/number fees)
                    // So we don't need to add getAdditionalFees separately as it would cause double-counting
                    cartItem.build_total_price = this.getItemSubTotal(cartItem);

                    // Calculate subtotals for sub-items
                    cartItem.subItems.forEach((subItem) => {
                        quantity = this.getGroupQuantity(
                            cart_items,
                            subItem.item_id,
                            subItem.decoration_type,
                            subItem.decoration_price_template,
                            cartItem.build_id
                        );
                        this.calculateCartItemPricing(
                            cart_items,
                            subItem,
                            this.getDecorationPrice(subItem, quantity)
                        );
                        // Add sub-item subtotal to main item's build_total_price
                        cartItem.build_total_price +=
                            this.getItemSubTotal(subItem);
                    });
                });
                // Note: grand_total is now a computed property that automatically calculates from cart_subtotal
            } catch (error) {
                console.log(error);
            }
        },

        getAdditionalFees(cart_item) {
            // Use setup fee total from setup_fees_details if available, otherwise fallback to sp_setup_fee + emb_setup_fee
            let setupFeeTotal = 0;
            if (cart_item.setup_fees_details) {
                setupFeeTotal = this.getSetupFeeTotal(cart_item);
            } else {
                setupFeeTotal =
                    parseFloat(cart_item.sp_setup_fee || 0) +
                    parseFloat(cart_item.emb_setup_fee || 0);
            }

            // For decoration type 0, use run charge from breakdown
            let runCharge = 0;
            if (cart_item.decoration_type == 0) {
                runCharge = this.getRunChargeTotalFromBreakdown(cart_item);
            } else {
                runCharge =
                    parseFloat(cart_item.sp_decoration_colors_price || 0) +
                    parseFloat(cart_item.emb_decoration_colors_price || 0);
            }

            return runCharge + setupFeeTotal;
        },

        getMinQuantity(cart_item) {
            let price_decoration_bulk = null;

            // Parse price_decoration_bulk if it's a string
            if (cart_item.price_decoration_bulk) {
                if (typeof cart_item.price_decoration_bulk === "string") {
                    try {
                        price_decoration_bulk = JSON.parse(
                            cart_item.price_decoration_bulk
                        );
                    } catch (e) {
                        console.error(
                            "Error parsing price_decoration_bulk:",
                            e
                        );
                        price_decoration_bulk = null;
                    }
                } else {
                    price_decoration_bulk = cart_item.price_decoration_bulk;
                }
            }

            // If price_decoration_bulk is not available, try to get from main_new_product
            if (
                !price_decoration_bulk &&
                cart_item.main_new_product &&
                cart_item.main_new_product.price_decoration_bulk
            ) {
                if (
                    typeof cart_item.main_new_product.price_decoration_bulk ===
                    "string"
                ) {
                    try {
                        price_decoration_bulk = JSON.parse(
                            cart_item.main_new_product.price_decoration_bulk
                        );
                    } catch (e) {
                        console.error(
                            "Error parsing main_new_product.price_decoration_bulk:",
                            e
                        );
                    }
                } else {
                    price_decoration_bulk =
                        cart_item.main_new_product.price_decoration_bulk;
                }
            }

            let minimum_quantity = 0;

            // Simple logic: Get first tier quantity from price_decoration_bulk
            if (price_decoration_bulk) {
                // If it's an array, get first element's quantity
                if (
                    Array.isArray(price_decoration_bulk) &&
                    price_decoration_bulk.length > 0
                ) {
                    minimum_quantity =
                        price_decoration_bulk[0].quantity ||
                        price_decoration_bulk[0].quantity1 ||
                        0;
                }
                // If it's an object with print_location1 (decoration_type 1)
                else if (
                    price_decoration_bulk.print_location1 &&
                    Array.isArray(price_decoration_bulk.print_location1) &&
                    price_decoration_bulk.print_location1.length > 0
                ) {
                    minimum_quantity =
                        price_decoration_bulk.print_location1[0].quantity || 0;
                }
            }

            return minimum_quantity;
        },

        validateMinQuantity(cart_item) {
            let minimum_quantity = this.getMinQuantity(cart_item);

            let total_quantity = this.getGroupQuantity(
                this.cart_items,
                cart_item.item_id,
                cart_item.decoration_type,
                cart_item.decoration_price_template,
                cart_item.build_id
            );
            if (total_quantity < minimum_quantity) {
                this.$toast.error(
                    `Quantity should be greater than ${minimum_quantity}`,
                    { position: "top-right", queue: true }
                );
                return false;
            }
            return true;
        },

        productColors(child_items) {
            if (child_items.length == 0) {
                return;
            }
            let color = child_items;
            let style = color.swatches
                ? "background-image:url(" + color.swatches + ")"
                : " background-color:" + color.hex;
            let html =
                `<a href="javascript:void(0)" class="color_circle mr_16 bg_secondary_black " style="` +
                style +
                `"></a><p>` +
                this.converToCamel(color.name) +
                `</p>`;
            return html;
        },

        converToCamel(text) {
            return text.replace(
                /(^\w|\s\w)(\S*)/g,
                (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
            );
        },

        haveRushFee(item) {
            if (item.t_shirt_24_hour) {
                return true;
            }
            let child_item = item.subItems.find(
                (subitem) => subitem.t_shirt_24_hour
            );
            if (child_item) {
                return true;
            }

            return false;
        },

        getRetailPrice(prices) {
            let item_price = 0;
            if (prices.base_price) {
                item_price += parseFloat(prices.base_price);
            }

            if (prices.markup_price) {
                item_price += parseFloat(prices.markup_price);
            }

            if (prices.single_location_price) {
                item_price += parseFloat(prices.single_location_price);
            }

            if (prices.color_category_price) {
                item_price += parseFloat(prices.color_category_price);
            }

            if (prices.decoration_discount_percentage) {
                let decoration_discount_value =
                    (this.icPriceFormat(item_price, true) *
                        parseFloat(prices.decoration_discount_percentage)) /
                    100;
                item_price -= parseFloat(decoration_discount_value);
            }

            return item_price;
        },

        openNameNumbersModal(cartItem) {
            this.name_and_number_json = { front: [], back: [] };
            this.selected_name_number =
                cartItem.item_prices.selected_name_number;
            if (cartItem.item_prices.selected_name_number) {
                if (cartItem.item_prices.selected_name_number.front.number) {
                    this.name_and_number_json["front"] =
                        cartItem.name_and_number_json.filter((nn) => nn.number);
                }
                if (
                    cartItem.item_prices.selected_name_number.back.name ||
                    cartItem.item_prices.selected_name_number.back.number
                ) {
                    this.name_and_number_json["back"] =
                        cartItem.name_and_number_json.filter(
                            (nn) => nn.name != "" || nn.number
                        );
                }
            }
            /* eslint-disable */
            $("#nameNumbersModal").modal("show");
            /* eslint-enable */
        },

        prepareLocations(cartData, decorationColors) {
            // Decoration type 0 - PCNA: prepare imprint_locations for run charge calculation
            if (cartData.decoration_type == 0) {
                cartData.sp_imprint_locations = [];
                cartData.emb_imprint_locations = [];

                // For decoration type 0, we still need imprint_locations for run charge
                // The imprint_locations should already be set from the cart data
                // Just ensure it's an array
                if (
                    !cartData.imprint_locations ||
                    !Array.isArray(cartData.imprint_locations)
                ) {
                    cartData.imprint_locations = [];
                }
                return;
            }

            const non_standard_color_obj = JSON.parse(
                JSON.stringify(this.nonStandardColorObj)
            );
            /* eslint-disable */
            let no_of_colors = 0;
            /* eslint-enable */
            let colors_type = "";
            if (cartData.decoration_type == 1) {
                colors_type = "ink";
                non_standard_color_obj.non_standard_fee =
                    this.non_standard_fees["sp"];
            } else if (cartData.decoration_type == 2) {
                colors_type = "thread";
                non_standard_color_obj.non_standard_fee =
                    this.non_standard_fees["emb"];
            }
            let vendor_colors_list = this.getVendorData(
                cartData.main_new_product.default_decorator_id,
                colors_type
            );

            if (
                !cartData.imprint_locations ||
                !Array.isArray(cartData.imprint_locations)
            ) {
                cartData.imprint_locations = [];
            }

            cartData.imprint_locations.forEach((location) => {
                location.colors = [];
                location.no_of_color = 0;
                if (decorationColors[location.location.toLowerCase()]) {
                    decorationColors[location.location.toLowerCase()].forEach(
                        (colorHex) => {
                            let vendorColor = vendor_colors_list.find(
                                (vendColor) =>
                                    vendColor.color_value.toLowerCase() ==
                                    colorHex.toLowerCase()
                            );
                        location.colors.push({
                            color: vendorColor || non_standard_color_obj,
                            total_decor_upcharge: 0
                        });
                        }
                    );

                    location.no_of_color =
                        decorationColors[
                            location.location.toLowerCase()
                        ].length;
                }
                location.price = 0;
                location.total_decoration_fee = 0;
                location.total_price = 0;
                if (location.no_of_color) {
                    no_of_colors += parseInt(location.no_of_color || 0);
                }

                if (cartData.decoration_type == 1) {
                    cartData.sp_imprint_locations.push(location);
                    cartData.sp_decoration_colors_count += parseInt(
                        location.no_of_color || 0
                    );
                } else if (cartData.decoration_type == 2) {
                    cartData.emb_imprint_locations.push(location);
                    cartData.emb_decoration_colors_count += parseInt(
                        location.no_of_color || 0
                    );
                }
            });
        },

        calculateDecorationColorsPricing(total_quantity, cartData) {
            // Decoration type 0 means no decoration, set prices to 0
            if (cartData.decoration_type == 0) {
                cartData.sp_decoration_colors_price = 0;
                cartData.emb_decoration_colors_price = 0;
                return;
            }

            let imprint_locations_price = 0;
            let initialLocationIndex = 0;
            /* eslint-disable */
            let total_location_fee = 0;
            /* eslint-enable */
            if (cartData.decoration_type == 1) {
                if (
                    !cartData.sp_imprint_locations ||
                    !Array.isArray(cartData.sp_imprint_locations)
                ) {
                    cartData.sp_imprint_locations = [];
                }
                cartData.sp_imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        let no_of_colors = parseInt(location.no_of_color) || 0;
                        if (initialLocationIndex == 0 && no_of_colors == 1) {
                            location.decoration_fee = 0;
                            location.total_decoration_fee = 0;
                        } else {
                            let decoration_price = this.getDecorationPrice(
                                cartData,
                                total_quantity,
                                no_of_colors - 1,
                                undefined,
                                initialLocationIndex > 0
                            );
                            let color1_decoration_price =
                                this.getDecorationPrice(
                                    cartData,
                                    total_quantity,
                                    0,
                                    undefined,
                                    initialLocationIndex > 0
                                );
                            location.decoration_fee =
                                parseFloat(decoration_price);
                            if (
                                initialLocationIndex == 0 &&
                                location.decoration_fee > 0
                            ) {
                                location.decoration_fee =
                                    parseFloat(location.decoration_fee) -
                                    parseFloat(color1_decoration_price);
                            }
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_quantity;
                        }

                        if (location.colors && Array.isArray(location.colors)) {
                            location.colors.forEach((color) => {
                                if (color.color) {
                                    color.total_decor_upcharge =
                                        parseFloat(
                                            color.color.decor_upcharge || 0
                                        ) * total_quantity;
                                    total_location_fee += parseFloat(
                                        color.total_decor_upcharge
                                    );
                                    imprint_locations_price += parseFloat(
                                        color.total_decor_upcharge
                                    );
                                }
                            });
                        }
                        imprint_locations_price +=
                            location.total_decoration_fee;
                        initialLocationIndex++;
                    }
                });
                cartData.sp_decoration_colors_price = imprint_locations_price;
            } else if (cartData.decoration_type == 2) {
                if (
                    !cartData.emb_imprint_locations ||
                    !Array.isArray(cartData.emb_imprint_locations)
                ) {
                    cartData.emb_imprint_locations = [];
                }
                cartData.emb_imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        let no_of_colors = parseInt(location.no_of_color) || 0;
                        if (initialLocationIndex == 0) {
                            location.decoration_fee = 0;
                            location.total_decoration_fee = 0;
                        } else {
                            let decoration_price = 0;
                            if (no_of_colors > 0) {
                                decoration_price = this.getDecorationPrice(
                                    cartData,
                                    total_quantity,
                                    0,
                                    initialLocationIndex
                                );
                            }
                            location.decoration_fee =
                                parseFloat(decoration_price);
                            location.total_decoration_fee =
                                parseFloat(location.decoration_fee) *
                                total_quantity;
                        }

                        if (location.colors && Array.isArray(location.colors)) {
                            location.colors.forEach((color) => {
                                if (color.color) {
                                    color.total_decor_upcharge =
                                        parseFloat(
                                            color.color.decor_upcharge || 0
                                        ) * total_quantity;
                                    total_location_fee += parseFloat(
                                        color.total_decor_upcharge
                                    );
                                    imprint_locations_price += parseFloat(
                                        color.total_decor_upcharge
                                    );
                                }
                            });
                        }
                        imprint_locations_price +=
                            location.total_decoration_fee;
                        initialLocationIndex++;
                    }
                });
                cartData.emb_decoration_colors_price = imprint_locations_price;
            }

            return imprint_locations_price;
        },

        getVendorsList() {
            return new Promise((resolve, reject) => {
                ApiService.get(`/vendors`)
                    .then(({ data }) => {
                    if (data.error) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                        return;
                    }
                    this.vendors_list = data.vendors;
                    resolve(data.vendors);
                })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        getVendorData(vendor_id, colors_type) {
            let vendor_data = this.vendors_list.find(
                (vendor) => vendor.id == vendor_id
            );
            let colors_json = vendor_data.vendor_colors
                ? JSON.parse(vendor_data.vendor_colors)
                : {};
            return colors_json[`color_data_for_${colors_type}`];
        },

        getDecorationMethod(item) {
            if (item.DecorationMethod) {
                return item.DecorationMethod.name;
            }

            return "";
        },

        getDecorationTemplateData(decorationType, decorationTemplateId) {
            // Decoration type 0 means no decoration, return null
            if (decorationType == 0) {
                return null;
            }

            let decorationTemplate;

            if (decorationType == 1) {
                decorationTemplate = this.printTemplates.find(
                    (temp) => temp.id == decorationTemplateId
                );
            } else if (decorationType == 2) {
                decorationTemplate = this.embroideryTemplates.find(
                    (temp) => temp.id == decorationTemplateId
                );
            }

            return decorationTemplate;
        },

        showDecorationTemplateName(decorationType, decorationTemplateId) {
            let template_name = "";
            let decorationTemplate;
            if (decorationType == 1) {
                decorationTemplate = this.printTemplates.find(
                    (temp) => temp.id == decorationTemplateId
                );
            } else if (decorationType == 2) {
                decorationTemplate = this.embroideryTemplates.find(
                    (temp) => temp.id == decorationTemplateId
                );
            }
            if (decorationTemplate) {
                template_name = decorationTemplate.name;
            }

            return template_name;
        },

        // Function not required
        calcPrices(parent_product, parent) {
            // console.log('calcPrices', parent, parent_product)
            let total_quantity = this.getGroupTotalQuantity(
                parent,
                parent_product
            );

            let color_category_price = 0;
            if (parent_product.Color.category == "Dark") {
                color_category_price =
                    parent_product.product.price_color_category_dark;
                parent_product.total_dark_category_fee =
                    parseInt(parent_product.total_quantity) *
                    parseFloat(color_category_price);
            } else if (parent_product.Color.category == "Light") {
                color_category_price =
                    parent_product.product.price_color_category_light;
                parent_product.total_light_category_fee =
                    parseInt(parent_product.total_quantity) *
                    parseFloat(color_category_price);
            }

            let qty_wise_color_price = this.getDecorationColorPrice(
                parent_product,
                total_quantity
            );

            if (parent_product.build_id) {
                if (parent == "parent") {
                    parent_product.total_quantity = 0;
                    parent_product.total_price = 0;
                    parent_product.subtotal_price = 0;
                    // parent_product.total_imprint_locations_price = 0;
                    parent_product.CartChildItems.forEach((item) => {
                        item.ink_price = parseFloat(color_category_price);
                        item.single_location_price =
                            parseFloat(qty_wise_color_price);
                        item.unit_price =
                            parseFloat(item.case_price) +
                            parseFloat(item.markup_price) +
                            parseFloat(color_category_price) +
                            parseFloat(item.single_location_price);
                        item.total_price =
                            this.icPriceFormat(item.unit_price, true) *
                            parseInt(item.quantity);
                        parent_product.total_quantity += parseInt(
                            item.quantity
                        );
                        parent_product.total_price += parseFloat(
                            item.total_price
                        );
                        parent_product.subtotal_price += parseFloat(
                            item.total_price
                        );
                    });

                    this.calcAdditionalFees(
                        parent,
                        parent_product,
                        total_quantity
                    );

                    // TOTAL BUILD 
                    parent_product.build_total_price = parseFloat(
                        parent_product.total_price
                    );
                    parent_product.build_total_quantity =
                        parent_product.total_quantity;
                    parent_product.subItems.forEach((subItem) => {
                        subItem.total_quantity = 0;
                        subItem.total_price = 0;
                        subItem.subtotal_price = 0;
                        subItem.CartChildItems.forEach((item) => {
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(item.markup_price) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            subItem.total_quantity += parseInt(item.quantity);
                            subItem.total_price += parseFloat(item.total_price);
                            subItem.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });

                        this.calcAdditionalFees(
                            parent_product,
                            subItem,
                            total_quantity
                        );

                        parent_product.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent_product.build_total_quantity +=
                            subItem.total_quantity;
                    });
                } else {
                    parent.total_quantity = 0;
                    parent.total_price = 0;
                    parent.subtotal_price = 0;
                    // parent.total_imprint_locations_price = 0;
                    parent.CartChildItems.forEach((item) => {
                        item.single_location_price =
                            parseFloat(qty_wise_color_price);
                        item.unit_price =
                            parseFloat(item.case_price) +
                            parseFloat(item.markup_price) +
                            parseFloat(color_category_price) +
                            parseFloat(item.single_location_price);
                        item.total_price =
                            this.icPriceFormat(item.unit_price, true) *
                            parseInt(item.quantity);
                        parent.total_quantity += parseInt(item.quantity);
                        parent.total_price += parseFloat(item.total_price);
                        parent.subtotal_price += parseFloat(item.total_price);
                    });

                    this.calcAdditionalFees(parent, parent, total_quantity);

                    parent.build_total_price = parseFloat(parent.total_price);
                    parent.build_total_quantity = parent.total_quantity;
                    parent.subItems.forEach((subItem) => {
                        subItem.total_quantity = 0;
                        subItem.total_price = 0;
                        subItem.subtotal_price = 0;
                        subItem.CartChildItems.forEach((item) => {
                            if (parent_product.id == subItem.id) {
                                item.ink_price =
                                    parseFloat(color_category_price);
                            }
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(item.markup_price) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            subItem.total_quantity += parseInt(item.quantity);
                            subItem.total_price += parseFloat(item.total_price);
                            subItem.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });

                        this.calcAdditionalFees(
                            parent,
                            subItem,
                            total_quantity
                        );

                        parent.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent.build_total_quantity += subItem.total_quantity;
                    });
                }
            } else if (parent_product.artwork) {
                let artwork = parent_product.artwork;
                parent_product.total_quantity = 0;
                parent_product.total_price = 0;
                parent_product.subtotal_price = 0;
                if (parent == "parent") {
                    parent_product.CartChildItems.forEach((item) => {
                        item.ink_price = parseFloat(color_category_price);
                        item.single_location_price =
                            parseFloat(qty_wise_color_price);
                        // console.log(item.case_price, item.markup_price, item.ink_price,item.single_location_price )
                        item.unit_price =
                            parseFloat(item.case_price) +
                            parseFloat(item.markup_price) +
                            parseFloat(item.ink_price) +
                            parseFloat(item.single_location_price);
                        item.total_price =
                            this.icPriceFormat(item.unit_price, true) *
                            parseInt(item.quantity);
                        parent_product.total_quantity += parseInt(
                            item.quantity
                        );
                        parent_product.total_price += parseFloat(
                            item.total_price
                        );
                        parent_product.subtotal_price += parseFloat(
                            item.total_price
                        );
                    });

                    this.calcAdditionalFees(
                        parent,
                        parent_product,
                        total_quantity
                    );

                    // TOTAL BUILD 
                    parent_product.build_total_price = parseFloat(
                        parent_product.total_price
                    );
                    parent_product.build_total_quantity =
                        parent_product.total_quantity;

                    parent_product.subItems.forEach((subItem) => {
                        if (subItem.artwork == artwork) {
                            subItem.total_quantity = 0;
                            subItem.total_price = 0;
                            subItem.subtotal_price = 0;
                            subItem.CartChildItems.forEach((item) => {
                                item.single_location_price =
                                    parseFloat(qty_wise_color_price);
                                item.unit_price =
                                    parseFloat(item.case_price) +
                                    parseFloat(item.markup_price) +
                                    parseFloat(item.ink_price) +
                                    parseFloat(item.single_location_price);
                                item.total_price =
                                    this.icPriceFormat(item.unit_price, true) *
                                    parseInt(item.quantity);
                                subItem.total_quantity += parseInt(
                                    item.quantity
                                );
                                subItem.total_price += parseFloat(
                                    item.total_price
                                );
                                subItem.subtotal_price += parseFloat(
                                    item.total_price
                                );
                            });

                            this.calcAdditionalFees(
                                parent_product,
                                subItem,
                                total_quantity
                            );

                            // TOTAL BUILD 
                        }
                        parent_product.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent_product.build_total_quantity +=
                            subItem.total_quantity;
                    });
                } else {
                    if (parent.artwork == artwork) {
                        parent.total_quantity = 0;
                        parent.total_price = 0;
                        parent.subtotal_price = 0;
                        parent.CartChildItems.forEach((item) => {
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(item.markup_price) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            parent.total_quantity += parseInt(item.quantity);
                            parent.total_price += parseFloat(item.total_price);
                            parent.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });

                        this.calcAdditionalFees(parent, parent, total_quantity);

                        // TOTAL BUILD 
                    }
                    parent.build_total_price = parseFloat(parent.total_price);
                    parent.build_total_quantity = parent.total_quantity;
                    parent.subItems.forEach((subItem) => {
                        if (subItem.artwork == artwork) {
                            subItem.total_quantity = 0;
                            subItem.total_price = 0;
                            subItem.subtotal_price = 0;
                            subItem.CartChildItems.forEach((item) => {
                                if (parent_product.id == subItem.id) {
                                    item.ink_price =
                                        parseFloat(color_category_price);
                                }
                                item.single_location_price =
                                    parseFloat(qty_wise_color_price);
                                item.unit_price =
                                    parseFloat(item.case_price) +
                                    parseFloat(item.markup_price) +
                                    parseFloat(item.ink_price) +
                                    parseFloat(item.single_location_price);
                                item.total_price =
                                    this.icPriceFormat(item.unit_price, true) *
                                    parseInt(item.quantity);
                                subItem.total_quantity += parseInt(
                                    item.quantity
                                );
                                subItem.total_price += parseFloat(
                                    item.total_price
                                );
                                subItem.subtotal_price += parseFloat(
                                    item.total_price
                                );
                            });

                            this.calcAdditionalFees(
                                parent,
                                subItem,
                                total_quantity
                            );
                        }
                        // TOTAL BUILD 
                        parent.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent.build_total_quantity += subItem.total_quantity;
                    });
                }
            } else {
                parent_product.total_quantity = 0;
                parent_product.total_price = 0;
                parent_product.subtotal_price = 0;
                if (parent == "parent") {
                    if (!parent_product.artwork && !parent_product.build_id) {
                        parent_product.CartChildItems.forEach((item) => {
                            item.ink_price = parseFloat(color_category_price);
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(item.markup_price) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            parent_product.total_quantity += parseInt(
                                item.quantity
                            );
                            parent_product.total_price += parseFloat(
                                item.total_price
                            );
                            parent_product.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });
                    }

                    this.calcAdditionalFees(
                        parent,
                        parent_product,
                        total_quantity
                    );

                    // TOTAL BUILD 
                    parent_product.build_total_price = parseFloat(
                        parent_product.total_price
                    );
                    parent_product.build_total_quantity =
                        parent_product.total_quantity;

                    parent_product.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            subItem.total_quantity = 0;
                            subItem.total_price = 0;
                            subItem.subtotal_price = 0;
                            subItem.CartChildItems.forEach((item) => {
                                item.single_location_price =
                                    parseFloat(qty_wise_color_price);
                                item.unit_price =
                                    parseFloat(item.case_price) +
                                    parseFloat(item.markup_price) +
                                    parseFloat(item.ink_price) +
                                    parseFloat(item.single_location_price);
                                item.total_price =
                                    this.icPriceFormat(item.unit_price, true) *
                                    parseInt(item.quantity);
                                subItem.total_quantity += parseInt(
                                    item.quantity
                                );
                                subItem.total_price += parseFloat(
                                    item.total_price
                                );
                                subItem.subtotal_price += parseFloat(
                                    item.total_price
                                );
                            });

                            this.calcAdditionalFees(
                                parent_product,
                                subItem,
                                total_quantity
                            );
                        }
                        parent_product.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent_product.build_total_quantity +=
                            subItem.total_quantity;
                    });
                } else {
                    if (!parent.artwork && !parent.build_id) {
                        parent.total_quantity = 0;
                        parent.total_price = 0;
                        parent.subtotal_price = 0;
                        parent.CartChildItems.forEach((item) => {
                            item.single_location_price =
                                parseFloat(qty_wise_color_price);
                            item.unit_price =
                                parseFloat(item.case_price) +
                                parseFloat(item.markup_price) +
                                parseFloat(item.ink_price) +
                                parseFloat(item.single_location_price);
                            item.total_price =
                                this.icPriceFormat(item.unit_price, true) *
                                parseInt(item.quantity);
                            parent.total_quantity += parseInt(item.quantity);
                            parent.total_price += parseFloat(item.total_price);
                            parent.subtotal_price += parseFloat(
                                item.total_price
                            );
                        });

                        this.calcAdditionalFees(parent, parent, total_quantity);

                        // TOTAL BUILD 
                    }
                    parent.build_total_price = parseFloat(parent.total_price);
                    parent.build_total_quantity = parent.total_quantity;
                    parent.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            subItem.total_quantity = 0;
                            subItem.total_price = 0;
                            subItem.subtotal_price = 0;
                            subItem.CartChildItems.forEach((item) => {
                                if (parent_product.id == subItem.id) {
                                    item.ink_price =
                                        parseFloat(color_category_price);
                                }
                                item.single_location_price =
                                    parseFloat(qty_wise_color_price);
                                item.unit_price =
                                    parseFloat(item.case_price) +
                                    parseFloat(item.markup_price) +
                                    parseFloat(item.ink_price) +
                                    parseFloat(item.single_location_price);
                                item.total_price =
                                    this.icPriceFormat(item.unit_price, true) *
                                    parseInt(item.quantity);
                                subItem.total_quantity += parseInt(
                                    item.quantity
                                );
                                subItem.total_price += parseFloat(
                                    item.total_price
                                );
                                subItem.subtotal_price += parseFloat(
                                    item.total_price
                                );
                            });

                            this.calcAdditionalFees(
                                parent,
                                subItem,
                                total_quantity
                            );
                        }
                        // TOTAL BUILD 
                        parent.build_total_price += parseFloat(
                            subItem.total_price
                        );
                        parent.build_total_quantity += subItem.total_quantity;
                    });
                }
            }

            // Note: grand_total is now a computed property that automatically calculates from cart_subtotal
            // No need to manually set it here

            return qty_wise_color_price;
        },

        // Function not required
        getDecorationColorPrice(
            parent_product,
            total_quantity,
            colorIndex = undefined,
            additional = false
        ) {
            let qty_wise_color_price = 0;

            // Decoration type 0 means no decoration, return 0
            if (parent_product.decoration_type == 0) {
                return 0;
            }

            if (colorIndex == 0) {
                return qty_wise_color_price;
            }

            if (colorIndex == undefined) {
                colorIndex = 0;
            }
            if (parent_product.decoration_type == 1) {
                if (!parent_product.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data;

                if (!additional) {
                    decoration_data = JSON.parse(
                        parent_product.price_decoration_bulk
                    ).print_location1;
                } else {
                    decoration_data = JSON.parse(
                        parent_product.price_decoration_bulk
                    ).print_location2;
                }

                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity <= total_quantity || index == 0) {
                        qty_wise_color_price =
                            element[`colour${colorIndex + 1}`];
                    }
                }
            } else if (parent_product.decoration_type == 2) {
                if (!parent_product.price_decoration_bulk) {
                    return 0;
                }
                let decoration_data = JSON.parse(
                    parent_product.price_decoration_bulk
                );
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (index == 0) {
                        if (element.quantity1 > total_quantity) {
                            qty_wise_color_price = parseFloat(element.cost);
                            break;
                        }
                    }
                    if (element.quantity1 <= total_quantity) {
                        if (element.quantity2 >= total_quantity) {
                            qty_wise_color_price = parseFloat(element.cost);
                            break;
                        }
                    }
                }
            } else if (parent_product.decoration_type == 3) {
                let decoration_data = JSON.parse(
                    parent_product.price_decoration_bulk
                );
                for (const [index, element] of Object.entries(
                    decoration_data
                )) {
                    if (element.quantity <= total_quantity || index == 0) {
                        qty_wise_color_price = parseFloat(element.cost);
                    }
                }
            }
            return qty_wise_color_price;
        },

        // Function not required
        calcAdditionalFees(parent, cart_item) {
            // IMPRINT LOCATIONS
            cart_item.imprint_locations_price = this.calcImprintLocationFees(
                parent,
                cart_item
            );

            // NAME NUMBER FEES
            cart_item.name_number_fees = this.calcNameNumberFees(cart_item);

            // NON STANDARD FEES
            // cart_item.non_standard_fees = this.calcNonStandardFees(cart_item);

            // console.log('cart_item ===> ', cart_item)
            // TOTAL PRICE
            cart_item.total_price +=
                parseFloat(cart_item.design_fee) +
                parseFloat(cart_item.setup_fee) +
                parseFloat(cart_item.imprint_locations_price) +
                parseFloat(cart_item.name_number_fees);
            // parseFloat(cart_item.non_standard_fees);
        },

        // Function not required
        calcImprintLocationFees(parent, cart_item) {
            let total_build_quantity = this.getGroupTotalQuantity(
                parent,
                cart_item
            );
            // console.log('total_build_quantity',total_build_quantity);
            let imprint_locations_price = 0;
            let highest_price_location_index = this.getHighestPriceLocation(
                cart_item.imprint_locations
            );

            cart_item.imprint_locations.forEach((location, locationIndex) => {
                location.colors.forEach((imprint_color, colorIndex) => {
                    let qty_wise_color_price = 0;
                    if (highest_price_location_index == locationIndex) {
                        qty_wise_color_price = this.getDecorationColorPrice(
                            cart_item,
                            total_build_quantity,
                            colorIndex
                        );
                    } else {
                        qty_wise_color_price = this.getDecorationColorPrice(
                            cart_item,
                            total_build_quantity,
                            colorIndex,
                            true
                        );
                    }
                    if (
                        highest_price_location_index == locationIndex &&
                        colorIndex == 0
                    ) {
                        qty_wise_color_price = 0;
                    }
                    // console.log('qty_wise_color_price',qty_wise_color_price);
                    imprint_color.cost_cost =
                        qty_wise_color_price *
                        parseInt(cart_item.total_quantity);
                    if (
                        imprint_color.color &&
                        imprint_color.color.decor_upcharge !== undefined &&
                        imprint_color.color.decor_upcharge !== null
                    ) {
                        imprint_color.decor_upcharge.color_cost =
                            parseFloat(
                                imprint_color.color.decor_upcharge || 0
                            ) * parseInt(cart_item.total_quantity);
                        imprint_locations_price =
                            parseFloat(imprint_color.cost_cost || 0) +
                            parseFloat(
                                imprint_color.decor_upcharge.color_cost || 0
                            );
                    } else if (imprint_color.color && imprint_color.cost_cost) {
                        imprint_locations_price = parseFloat(
                            imprint_color.cost_cost || 0
                        );
                    }
                });
            });
            return imprint_locations_price;
        },

        // Function not required but usefull
        calcNameNumberFees(cart_item) {
            let name_fees_obj = this.getAdminOption("name_fees");
            let name_fees = 0;
            if (name_fees_obj) {
                name_fees = parseFloat(name_fees_obj.option_value || 0);
            }

            let number_fees_obj = this.getAdminOption("number_fees");
            let number_fees = 0;
            if (number_fees_obj) {
                number_fees = parseFloat(number_fees_obj.option_value || 0);
            }

            let name_and_number_json = cart_item.name_and_number_json;

            let total_name_number_fees = 0;
            name_and_number_json.forEach((nameNumber) => {
                if (nameNumber.name) {
                    total_name_number_fees += parseFloat(name_fees);
                }
                if (nameNumber.number) {
                    total_name_number_fees += parseFloat(number_fees);
                    /* eslint-disable */
                    if (front_number) {
                        total_name_number_fees += parseFloat(number_fees);
                    }
                    /* eslint-enable */
                }
            });

            return total_name_number_fees;
        },

        // Function not required
        calcNonStandardFees(cart_item) {
            let non_standard_fees_obj = this.getAdminOption(
                "non_standard_color_fees"
            );
            let non_standard_fees = 0;
            if (non_standard_fees_obj) {
                non_standard_fees = parseFloat(
                    non_standard_fees_obj.option_value || 0
                );
            }

            // let non_standard_colors = cart_item.non_standard_colors
            //     ? JSON.parse(cart_item.non_standard_colors)
            //     : []

            return (
                cart_item.non_standard_colors.length *
                non_standard_fees *
                cart_item.total_quantity
            );
        },

        // Function not required
        getHighestPriceLocation(imprint_locations) {
            let location_index = -1;
            let highest_location_price = 0;
            imprint_locations.forEach((location, i) => {
                if (location.is_selected) {
                    let location_price = 0;
                    location.colors.forEach((color) => {
                        if (color.color) {
                            location_price += parseFloat(
                                color.color.decor_upcharge || 0
                            );
                        }
                    });

                    if (highest_location_price < location_price) {
                        location_index = i;
                        highest_location_price = location_price;
                    }
                }
            });

            if (highest_location_price == 0) {
                location_index = imprint_locations.findIndex(
                    (loc) => loc.is_selected
                );
            }

            return location_index;
        },

        // Function not required
        getGroupItemIds(parent, cart_item) {
            let cartItemIds = [];
            if (cart_item.build_id) {
                if (parent == "parent") {
                    cartItemIds.push(cart_item.id);
                    cart_item.subItems.forEach((subItem) => {
                        cartItemIds.push(subItem.id);
                    });
                } else {
                    cartItemIds.push(parent.id);
                    parent.subItems.forEach((subItem) => {
                        cartItemIds.push(subItem.id);
                    });
                }
            } else if (cart_item.artwork) {
                if (parent == "parent") {
                    if (cart_item.artwork) {
                        cartItemIds.push(cart_item.id);

                        cart_item.subItems.forEach((subItem) => {
                            if (subItem.artwork == cart_item.artwork) {
                                cartItemIds.push(subItem.id);
                            }
                        });
                    }
                } else {
                    if (cart_item.artwork) {
                        if (parent.artwork == cart_item.artwork) {
                            cartItemIds.push(parent.id);
                        }

                        parent.subItems.forEach((subItem) => {
                            if (subItem.artwork == cart_item.artwork) {
                                cartItemIds.push(subItem.id);
                            }
                        });
                    }
                }
            } else {
                if (parent == "parent") {
                    if (!cart_item.artwork && !cart_item.build_id) {
                        cartItemIds.push(cart_item.id);
                    }

                    cart_item.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            cartItemIds.push(subItem.id);
                        }
                    });
                } else {
                    if (!parent.artwork && !parent.build_id) {
                        cartItemIds.push(parent.id);
                    }

                    parent.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            cartItemIds.push(subItem.id);
                        }
                    });
                }
            }
            return cartItemIds;
        },

        // Function not required
        updateCartOld(cart_item, parent) {
            try {
                let no_quantity_error = false;
                this.cart_items.forEach((cart_item) => {
                    let is_quantity_exist = cart_item.CartChildItems.find(
                        (cartChildItem) => parseInt(cartChildItem.quantity) > 0
                    );
                    if (!is_quantity_exist) {
                        no_quantity_error = true;
                        return;
                    }
                    if (cart_item.subItems) {
                        cart_item.subItems.forEach((subItem) => {
                            let is_quantity_exist = subItem.CartChildItems.find(
                                (cartChildItem) =>
                                    parseInt(cartChildItem.quantity) > 0
                            );
                            if (!is_quantity_exist) {
                                no_quantity_error = true;
                                return;
                            }
                        });
                    }
                });

                if (no_quantity_error == true) {
                    this.$toast.error(
                        `Every Item should have atleast single quantity is required`,
                        { position: "top-right", queue: true }
                    );
                    return;
                }

                if (!this.validateMinQuantity(parent, cart_item)) {
                    return;
                }

                cart_item.total_quantity = 0;
                cart_item.CartChildItems.forEach((childItem) => {
                    if (childItem.quantity > 0) {
                        cart_item.total_quantity += parseInt(
                            childItem.quantity || 0
                        );
                    }
                });

                // UPDATE PRICES
                this.grand_total -= cart_item["total_price"];
                cart_item["total_price"] = 0;

                this.calcPrices(cart_item, parent);

                this.grand_total += this.total_non_standard_fees_sp;

                let item;
                if (parent == "parent") {
                    item = cart_item;
                } else {
                    item = parent;
                }

                const cartItemIds = this.getGroupItemIds(parent, cart_item);

                // PARENT ITEM
                let params = [];
                if (cartItemIds.includes(item.id)) {
                    let child_items = [];
                    item.CartChildItems.forEach((childItem) => {
                        child_items.push({
                            id: childItem.id,
                            sub_product_id: childItem.sub_product_id,
                            case_price: childItem.case_price,
                            markup_price: childItem.markup_price,
                            markup_percentage: childItem.markup_percentage,
                            ink_price: childItem.ink_price,
                            single_location_price:
                                childItem.single_location_price,
                            quantity: childItem.quantity || 0,
                            discount: childItem.discount || 0,
                            unit_price: childItem.unit_price || 0,
                            total_price: childItem.total_price || 0
                        });
                    });
                    params.push({
                        cart_id: item.id,
                        child_items: child_items,
                        total_dark_category_fee: item.total_dark_category_fee,
                        total_light_category_fee: item.total_light_category_fee,
                        name_number_fees: item.name_number_fees,
                        non_standard_fees: item.non_standard_fees,
                        imprint_locations_price: item.imprint_locations_price,
                        imprint_locations: item.imprint_locations,
                        total_quantity: item.total_quantity,
                        subtotal_price: item.subtotal_price,
                        total_price: item.total_price
                    });
                }

                // PARENT SUB ITEMS
                item.subItems.forEach((subItem) => {
                    if (cartItemIds.includes(subItem.id)) {
                        let child_items = [];
                        subItem.CartChildItems.forEach((childItem) => {
                            child_items.push({
                                id: childItem.id,
                                sub_product_id: childItem.sub_product_id,
                                case_price: childItem.case_price,
                                markup_price: childItem.markup_price,
                                markup_percentage: childItem.markup_percentage,
                                ink_price: childItem.ink_price,
                                single_location_price:
                                    childItem.single_location_price,
                                quantity: childItem.quantity || 0,
                                discount: childItem.discount || 0,
                                unit_price: childItem.unit_price || 0,
                                total_price: childItem.total_price || 0
                            });
                        });

                        params.push({
                            cart_id: subItem.id,
                            child_items: child_items,
                            total_dark_category_fee:
                                subItem.total_dark_category_fee,
                            total_light_category_fee:
                                subItem.total_light_category_fee,
                            name_number_fees: subItem.name_number_fees,
                            non_standard_fees: subItem.non_standard_fees,
                            imprint_locations_price:
                                subItem.imprint_locations_price,
                            imprint_locations: subItem.imprint_locations,
                            total_quantity: subItem.total_quantity,
                            subtotal_price: subItem.subtotal_price,
                            total_price: subItem.total_price
                        });
                    }
                });

                if (this.currentUserClient) {
                    this.isBusy = true;
                    ApiService.post("/update-cart", params)
                        .then(() => {
                        this.$root.$emit("update-cart");
                            this.$toast.success(
                                "Quantity updated successfully.",
                                {
                            position: "top-right",
                            queue: true
                                }
                            );
                        cart_item.show_update_button = false;
                        this.isBusy = false;
                        })
                        .catch((response) => {
                            console.log(response);
                        this.$toast.error("something went wrong.", {
                            position: "top-right",
                            queue: true
                        });
                    });
                }
            } catch (error) {
                console.log(error);
                if (error && error.message) {
                    this.$toast.error(error.message, {
                        position: "top-right",
                        queue: true
                    });
                }
            }
        },

        // Function not required
        getItemTotalQuantity(cartItem) {
            let total_quantity = 0;
            cartItem.CartChildItems.forEach((childItem) => {
                total_quantity += parseInt(childItem.quantity || 0);
            });
            return total_quantity;
        },

        // Function not required
        getGroupTotalQuantity(parent, cart_item) {
            let total_quantity = 0;
            if (cart_item.build_id) {
                if (parent == "parent") {
                    total_quantity += this.getItemTotalQuantity(cart_item);
                    cart_item.subItems.forEach((subItem) => {
                        total_quantity += this.getItemTotalQuantity(subItem);
                    });
                } else {
                    total_quantity += this.getItemTotalQuantity(parent);
                    parent.subItems.forEach((subItem) => {
                        total_quantity += this.getItemTotalQuantity(subItem);
                    });
                }
            } else if (cart_item.artwork) {
                if (parent == "parent") {
                    if (cart_item.artwork) {
                        total_quantity += this.getItemTotalQuantity(cart_item);

                        cart_item.subItems.forEach((subItem) => {
                            if (subItem.artwork == cart_item.artwork) {
                                total_quantity +=
                                    this.getItemTotalQuantity(subItem);
                            }
                        });
                    }
                } else {
                    if (cart_item.artwork) {
                        if (parent.artwork == cart_item.artwork) {
                            total_quantity += this.getItemTotalQuantity(parent);
                        }

                        parent.subItems.forEach((subItem) => {
                            if (subItem.artwork == cart_item.artwork) {
                                total_quantity +=
                                    this.getItemTotalQuantity(subItem);
                            }
                        });
                    }
                }
            } else {
                if (parent == "parent") {
                    if (!cart_item.artwork && !cart_item.build_id) {
                        total_quantity += this.getItemTotalQuantity(cart_item);
                    }

                    cart_item.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            total_quantity +=
                                this.getItemTotalQuantity(subItem);
                        }
                    });
                } else {
                    if (!parent.artwork && !parent.build_id) {
                        total_quantity += this.getItemTotalQuantity(parent);
                    }

                    parent.subItems.forEach((subItem) => {
                        if (!subItem.artwork && !subItem.build_id) {
                            total_quantity +=
                                this.getItemTotalQuantity(subItem);
                        }
                    });
                }
            }
            return total_quantity;
        },

        // Get Base Fee services (rollup_fee_id = 1)
        getBaseFeeServices(item) {
            if (
                !item.decoration ||
                !item.decoration.other_services_list ||
                !Array.isArray(item.decoration.other_services_list)
            ) {
                return [];
            }
            return item.decoration.other_services_list.filter((service) => {
                return (
                    service.rollup_fee_id === 1 || service.rollup_fee_id === "1"
                );
            });
        },
        // Get color-size combinations from cart item
        getColorSizeCombinations(item) {
            if (
                !item ||
                !item.CartChildItems ||
                !Array.isArray(item.CartChildItems)
            ) {
                return [];
            }

            const combinations = [];
            
            // Group CartChildItems by color_id
            const colorGroups = {};
            item.CartChildItems.forEach((childItem) => {
                const mainProduct = childItem.main_new_sub_product;
                const colorObj = mainProduct && mainProduct.Color;
                const colorId =
                    childItem.color_id ||
                    (colorObj && colorObj.id) ||
                    (colorObj && colorObj.color_id);
                if (!colorId) return;
                
                if (!colorGroups[colorId]) {
                    colorGroups[colorId] = {
                        color_id: colorId,
                        color_name:
                            (colorObj && colorObj.name) ||
                            (colorObj && colorObj.color_name) ||
                            "Color",
                        color_value:
                            (colorObj && colorObj.color_value) ||
                            (colorObj && colorObj.hex) ||
                            (colorObj && colorObj.hash) ||
                            "#cccccc",
                        sizes: []
                    };
                }
                
                // Extract size information
                const sizeObj = mainProduct && mainProduct.Size;
                if (sizeObj) {
                    let sizeAbbr = "N/A";
                    if (sizeObj.size_name) {
                        sizeAbbr = sizeObj.size_name;
                    } else if (sizeObj.size) {
                        const sizeParts = sizeObj.size.trim().split(/\s+/);
                        sizeAbbr = sizeParts[sizeParts.length - 1];
                    } else if (sizeObj.name) {
                        const nameParts = sizeObj.name.trim().split(/\s+/);
                        sizeAbbr = nameParts[nameParts.length - 1];
                    }
                    
                    const quantity = parseInt(childItem.quantity) || 0;
                    if (quantity > 0) {
                        // For decoration type 0 (PCNA), use price from decoration bulk based on total quantity
                        // This matches how PCNAPriceBreakdown works - same unit price for all color-size combinations
                        let calculatedUnitPrice = 0;
                        
                        if (
                            item.decoration_type === 0 ||
                            item.decoration_type === "0"
                        ) {
                            // PCNA: Get unit price from decoration bulk tiers based on total quantity
                            calculatedUnitPrice =
                                this.getBaseUnitPriceFromTiers(item);
                        } else if (
                            item.decoration_type == 1 ||
                            item.decoration_type == 2
                        ) {
                            // Decoration type 1 (Screen Print) and 2 (Embroidery)
                            // Each color-size combination should have its own unit price
                            // Apply same logic as getBaseUnitPriceFromTiers but per childItem
                            try {
                                // Get base price and markup from current childItem (each can be different)
                                const basePrice = parseFloat(
                                    childItem.case_price || 0
                                );
                                const markupPrice = parseFloat(
                                    childItem.markup_price || 0
                                );
                                
                                // Get single location price from decoration tiers based on total quantity
                                const bulkData =
                                    typeof item.price_decoration_bulk ===
                                    "string"
                                    ? JSON.parse(item.price_decoration_bulk)
                                    : item.price_decoration_bulk;
                                
                                let singleLocationPrice = 0;
                                const totalQuantity =
                                    this.getTotalItemQuantity(item);
                                
                                if (item.decoration_type == 1) {
                                    // Screen Print: get from print_location1
                                    if (bulkData && bulkData.print_location1) {
                                        const location1Data =
                                            bulkData.print_location1;
                                        for (const [
                                            index,
                                            element
                                        ] of Object.entries(location1Data)) {
                                            if (
                                                element.quantity <=
                                                    totalQuantity ||
                                                index == 0
                                            ) {
                                                singleLocationPrice =
                                                    parseFloat(
                                                        element.colour1 || 0
                                                    );
                                            }
                                        }
                                    }
                                } else if (item.decoration_type == 2) {
                                    // Embroidery: get from array
                                    if (bulkData && Array.isArray(bulkData)) {
                                        for (const [
                                            index,
                                            element
                                        ] of Object.entries(bulkData)) {
                                            if (
                                                element.quantity1 <=
                                                    totalQuantity ||
                                                index == 0
                                            ) {
                                                singleLocationPrice =
                                                    parseFloat(
                                                        element.cost || 0
                                                    );
                                            }
                                        }
                                    }
                                }
                                
                                // Get color category price (dark/light fee) from decoration for this specific color
                                // Try multiple possible property names for color category
                                let colorCategory = null;
                                if (colorObj) {
                                    colorCategory =
                                        colorObj.category ||
                                        colorObj.color_category ||
                                        (colorObj.Color &&
                                            colorObj.Color.category) ||
                                        (mainProduct &&
                                            mainProduct.Color &&
                                            mainProduct.Color.category);
                                }
                                
                                let colorCategoryPrice = 0;
                                if (item.decoration && colorCategory) {
                                    if (
                                        colorCategory === "Dark" ||
                                        colorCategory === "dark"
                                    ) {
                                        colorCategoryPrice = parseFloat(
                                            item.decoration.price_dark || 0
                                        );
                                    } else if (
                                        colorCategory === "Light" ||
                                        colorCategory === "light"
                                    ) {
                                        colorCategoryPrice = parseFloat(
                                            item.decoration.price_light || 0
                                        );
                                    }
                                }
                                
                                // Get decoration discount percentage
                                const decorationDiscount =
                                    this.getDecorationDiscount(
                                        item,
                                        totalQuantity,
                                        false
                                    );
                                
                                // Calculate unit price: base + markup + single location + color category
                                calculatedUnitPrice =
                                    basePrice +
                                    markupPrice +
                                    singleLocationPrice +
                                    colorCategoryPrice;
                                
                                // Apply decoration discount
                                if (decorationDiscount > 0) {
                                    const discountValue =
                                        (this.icPriceFormat(
                                            calculatedUnitPrice,
                                            true
                                        ) *
                                            decorationDiscount) /
                                        100;
                                    calculatedUnitPrice -= discountValue;
                                }
                            } catch (e) {
                                console.error(
                                    "Error calculating unit price for decoration type " +
                                        item.decoration_type +
                                        ":",
                                    e
                                );
                                // Fallback: use full unit_price
                                calculatedUnitPrice = parseFloat(
                                    childItem.unit_price || 0
                                );
                                if (calculatedUnitPrice === 0) {
                                    calculatedUnitPrice =
                                        parseFloat(childItem.total_price || 0) /
                                        quantity;
                                }
                            }
                        } else {
                            // For other decoration types, use full unit_price
                            calculatedUnitPrice = parseFloat(
                                childItem.unit_price || 0
                            );
                            if (calculatedUnitPrice === 0) {
                                calculatedUnitPrice =
                                    parseFloat(childItem.total_price || 0) /
                                    quantity;
                            }
                        }
                        
                        colorGroups[colorId].sizes.push({
                            size: sizeAbbr,
                            quantity: quantity,
                            cost: calculatedUnitPrice, // Unit price calculated same as getBaseUnitPriceFromTiers
                            total_cost: calculatedUnitPrice * quantity
                        });
                    }
                }
            });
            
            // Convert grouped data to combinations array
            Object.values(colorGroups).forEach((colorGroup) => {
                colorGroup.sizes.forEach((size) => {
                    // Ensure color value has # prefix
                    let colorValue = colorGroup.color_value || "";
                    if (colorValue && !colorValue.startsWith("#")) {
                        colorValue = "#" + colorValue;
                    }
                    if (!colorValue) {
                        colorValue = "#cccccc";
                    }
                    
                    combinations.push({
                        color_id: colorGroup.color_id,
                        color_name: colorGroup.color_name,
                        color_value: colorValue,
                        hex: colorValue,
                        size: size.size,
                        quantity: size.quantity,
                        cost: size.cost,
                        total_cost: size.total_cost
                    });
                });
            });
            
            return combinations;
        },

        // Get Base Unit Price from price_decoration_bulk tiers based on quantity
        // IMPORTANT: This should use item-specific quantity, NOT grouped quantity
        getBaseUnitPriceFromTiers(item) {
            // Use item-specific quantity, not grouped quantity
            const quantity = this.getTotalItemQuantity(item);
            let unitPrice = 0;

            // Decoration type 0 - get from decoration.price_decoration_bulk
            if (item.decoration_type == 0) {
                try {
                    // Check if decoration.price_decoration_bulk exists
                    const decorationBulk =
                        item.decoration && item.decoration.price_decoration_bulk
                            ? typeof item.decoration.price_decoration_bulk ===
                              "string"
                                ? JSON.parse(
                                      item.decoration.price_decoration_bulk
                                  )
                                : item.decoration.price_decoration_bulk
                        : null;

                    if (decorationBulk) {
                        // For decoration type 0, price_decoration_bulk is typically an array
                        if (Array.isArray(decorationBulk)) {
                            for (const [index, element] of Object.entries(
                                decorationBulk
                            )) {
                                if (
                                    element.quantity <= quantity ||
                                    index == 0
                                ) {
                                    unitPrice = parseFloat(
                                        element.retail_cost || element.cost || 0
                                    );
                                }
                            }
                        }
                    }
                } catch (e) {
                    console.error(
                        "Error parsing decoration.price_decoration_bulk for type 0:",
                        e
                    );
                    return quantity > 0
                        ? parseFloat(item.subtotal_price || 0) / quantity
                        : 0;
                }

                return (
                    unitPrice ||
                    (quantity > 0
                        ? parseFloat(item.subtotal_price || 0) / quantity
                        : 0)
                );
            }

            // Decoration type 1 - Screen Print
            if (item.decoration_type == 1) {
                try {
                    // Get base price and markup from CartChildItems (use first item or average)
                    let basePrice = 0;
                    let markupPrice = 0;
                    if (item.CartChildItems && item.CartChildItems.length > 0) {
                        const firstChild = item.CartChildItems[0];
                        basePrice = parseFloat(firstChild.case_price || 0);
                        markupPrice = parseFloat(firstChild.markup_price || 0);
                    }

                    // Get single location price from decoration tiers
                    const bulkData =
                        typeof item.price_decoration_bulk === "string"
                        ? JSON.parse(item.price_decoration_bulk)
                        : item.price_decoration_bulk;

                    let singleLocationPrice = 0;
                    if (bulkData && bulkData.print_location1) {
                        const location1Data = bulkData.print_location1;
                        for (const [index, element] of Object.entries(
                            location1Data
                        )) {
                            if (element.quantity <= quantity || index == 0) {
                                singleLocationPrice = parseFloat(
                                    element.colour1 || 0
                                );
                            }
                        }
                    }

                    // Get color category price (dark/light fee) from decoration
                    let colorCategoryPrice = 0;
                    if (item.decoration) {
                        if (item.Color && item.Color.category === "Dark") {
                            colorCategoryPrice = parseFloat(
                                item.decoration.price_dark || 0
                            );
                        } else if (
                            item.Color &&
                            item.Color.category === "Light"
                        ) {
                            colorCategoryPrice = parseFloat(
                                item.decoration.price_light || 0
                            );
                        }
                    }

                    // Get decoration discount percentage
                    // IMPORTANT: For per-item calculation, use item-specific quantity, NOT grouped quantity
                    // Grouped quantity is only used for tier pricing in calculatePricing, but here we want per-item display
                    const decorationDiscount = this.getDecorationDiscount(
                        item,
                        quantity,
                        false
                    );

                    // Calculate unit price: base + markup + single location + color category
                    unitPrice =
                        basePrice +
                        markupPrice +
                        singleLocationPrice +
                        colorCategoryPrice;
                    // Apply decoration discount
                    if (decorationDiscount > 0) {
                        const discountValue =
                            (this.icPriceFormat(unitPrice, true) *
                                decorationDiscount) /
                            100;
                        unitPrice -= discountValue;
                    }
                } catch (e) {
                    console.error(
                        "Error parsing price_decoration_bulk for type 1:",
                        e
                    );
                    return quantity > 0
                        ? parseFloat(item.subtotal_price || 0) / quantity
                        : 0;
                }
            }
            // Decoration type 2 - Embroidery
            else if (item.decoration_type == 2) {
                try {
                    // Get base price and markup from CartChildItems (use first item or average)
                    let basePrice = 0;
                    let markupPrice = 0;
                    if (item.CartChildItems && item.CartChildItems.length > 0) {
                        const firstChild = item.CartChildItems[0];
                        basePrice = parseFloat(firstChild.case_price || 0);
                        markupPrice = parseFloat(firstChild.markup_price || 0);
                    }

                    // Get single location price from decoration tiers
                    const bulkData =
                        typeof item.price_decoration_bulk === "string"
                        ? JSON.parse(item.price_decoration_bulk)
                        : item.price_decoration_bulk;

                    let singleLocationPrice = 0;
                    if (bulkData && Array.isArray(bulkData)) {
                        for (const [index, element] of Object.entries(
                            bulkData
                        )) {
                            if (element.quantity1 <= quantity || index == 0) {
                                singleLocationPrice = parseFloat(
                                    element.cost || 0
                                );
                            }
                        }
                    }

                    // Get color category price (dark/light fee) from decoration
                    let colorCategoryPrice = 0;
                    if (item.decoration) {
                        if (item.Color && item.Color.category === "Dark") {
                            colorCategoryPrice = parseFloat(
                                item.decoration.price_dark || 0
                            );
                        } else if (
                            item.Color &&
                            item.Color.category === "Light"
                        ) {
                            colorCategoryPrice = parseFloat(
                                item.decoration.price_light || 0
                            );
                        }
                    }

                    // Get decoration discount percentage
                    // IMPORTANT: For per-item calculation, use item-specific quantity, NOT grouped quantity
                    // Grouped quantity is only used for tier pricing in calculatePricing, but here we want per-item display
                    const decorationDiscount = this.getDecorationDiscount(
                        item,
                        quantity,
                        false
                    );

                    // Calculate unit price: base + markup + single location + color category
                    unitPrice =
                        basePrice +
                        markupPrice +
                        singleLocationPrice +
                        colorCategoryPrice;

                    // Apply decoration discount
                    if (decorationDiscount > 0) {
                        const discountValue =
                            (this.icPriceFormat(unitPrice, true) *
                                decorationDiscount) /
                            100;
                        unitPrice -= discountValue;
                    }
                } catch (e) {
                    console.error(
                        "Error parsing price_decoration_bulk for type 2:",
                        e
                    );
                    return quantity > 0
                        ? parseFloat(item.subtotal_price || 0) / quantity
                        : 0;
                }
            }

            return (
                unitPrice ||
                (quantity > 0
                    ? parseFloat(item.subtotal_price || 0) / quantity
                    : 0)
            );
        },

        // Get Base Fee Total (base price from tiers + all services)
        // IMPORTANT: This should be per-item, NOT grouped
        getBaseFeeTotal(item) {
            // Use item-specific quantity, not grouped quantity
            const quantity = this.getTotalItemQuantity(item);

            // If color-size combinations exist, calculate from them (for decoration type 1 and 2)
            const colorSizeCombinations = this.getColorSizeCombinations(item);
            if (colorSizeCombinations && colorSizeCombinations.length > 0) {
                let total = 0;
                
                // Sum up all color-size combination totals
                colorSizeCombinations.forEach((combination) => {
                    const cost = parseFloat(combination.cost || 0);
                    const qty = parseInt(combination.quantity || 0);
                    total += cost * qty;
                });
                
                // Get included services (show_service = false) unit price
                let includedServicesUnitPrice = 0;
                const baseFeeServices = this.getBaseFeeServices(item);
                if (baseFeeServices && baseFeeServices.length > 0) {
                    baseFeeServices.forEach((service) => {
                        if (!service.show_service) {
                            // Included services: add unit price directly
                            const serviceUnitPrice = parseFloat(
                                service.retail_cost || service.net_cost || 0
                            );
                            includedServicesUnitPrice += serviceUnitPrice;
                        }
                    });
                }
                
                // Add included services total: unit price × quantity
                total += includedServicesUnitPrice * quantity;
                
                // Add other services (show_service = true)
                if (baseFeeServices && baseFeeServices.length > 0) {
                    baseFeeServices.forEach((service) => {
                        if (service.show_service) {
                            const servicePrice =
                                service.retail_cost || service.net_cost || 0;
                            if (service.fee_structure === "Per Item") {
                                total += parseFloat(servicePrice) * quantity;
                            } else {
                                total += parseFloat(servicePrice);
                            }
                        }
                    });
                }
                
                return parseFloat(total.toFixed(2));
            }
            
            // Fallback: Calculate from tier-based unit price (for decoration type 0 or when no combinations)
            const baseUnitPrice = this.getBaseUnitPriceFromTiers(item);
            
            // Get included services (show_service = false) unit price
            let includedServicesUnitPrice = 0;
            const baseFeeServices = this.getBaseFeeServices(item);
            if (baseFeeServices && baseFeeServices.length > 0) {
                baseFeeServices.forEach((service) => {
                    if (!service.show_service) {
                        // Included services: add unit price directly
                        const serviceUnitPrice = parseFloat(
                            service.retail_cost || service.net_cost || 0
                        );
                        includedServicesUnitPrice += serviceUnitPrice;
                    }
                });
            }
            
            // Calculate total: (baseUnitPrice + includedServicesUnitPrice) × quantity
            const totalUnitPrice = baseUnitPrice + includedServicesUnitPrice;
            let total = totalUnitPrice * quantity;

            // Add other services (show_service = true)
            if (baseFeeServices && baseFeeServices.length > 0) {
                baseFeeServices.forEach((service) => {
                    if (service.show_service) {
                        const servicePrice =
                            service.retail_cost || service.net_cost || 0;
                        if (service.fee_structure === "Per Item") {
                            total += parseFloat(servicePrice) * quantity;
                        } else {
                            total += parseFloat(servicePrice);
                        }
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },

        // Get Setup Fee services (rollup_fee_id = 2)
        getSetupFeeServices(item) {
            if (
                !item.decoration ||
                !item.decoration.other_services_list ||
                !Array.isArray(item.decoration.other_services_list)
            ) {
                return [];
            }
            return item.decoration.other_services_list.filter((service) => {
                const rollupService = service.rollup_service || {};
                const serviceFeeId = rollupService.rollup_fee_id !== undefined && rollupService.rollup_fee_id !== null
                    ? rollupService.rollup_fee_id
                    : service.rollup_fee_id !== undefined && service.rollup_fee_id !== null
                    ? service.rollup_fee_id
                    : null;
                return serviceFeeId === 2 || serviceFeeId === "2";
            });
        },

        // Get Run Charge services (if any)
        getRunChargeServices(item) {
            if (!item.decoration || !item.decoration.other_services_list || !Array.isArray(item.decoration.other_services_list)) {
                return [];
            }
            return item.decoration.other_services_list.filter(service => {
                const rollupService = service.rollup_service || {};
                const serviceFeeId = rollupService.rollup_fee_id !== undefined && rollupService.rollup_fee_id !== null
                    ? rollupService.rollup_fee_id
                    : service.rollup_fee_id !== undefined && service.rollup_fee_id !== null
                    ? service.rollup_fee_id
                    : null;
                return serviceFeeId === 12 || serviceFeeId === "12";
            });
        },
        getColorMixFeeServices(item) {
            if (!item.decoration || !item.decoration.other_services_list || !Array.isArray(item.decoration.other_services_list)) {
                return [];
            }
            return item.decoration.other_services_list.filter(service => {
                const rollupService = service.rollup_service || {};
                const serviceFeeId = rollupService.rollup_fee_id !== undefined && rollupService.rollup_fee_id !== null
                    ? rollupService.rollup_fee_id
                    : service.rollup_fee_id !== undefined && service.rollup_fee_id !== null
                    ? service.rollup_fee_id
                    : null;
                return serviceFeeId === 13 || serviceFeeId === "13";
            });
        },

        // Helper method to check if location is full color
        // Returns true only if is_full_color is true AND actual color count > 1
        isLocationFullColor(location) {
            // Check if full color flag is set
            const hasFullColorFlag =
                location.is_full_color === true ||
                location.no_of_color === "full_color" ||
                location.no_of_color === "Full color";
            
            if (!hasFullColorFlag) {
                return false;
            }
            
            // Get actual color count
            let actualColorCount = 0;
            
            // First, try to get count from colors array (most accurate)
            if (location.colors && Array.isArray(location.colors)) {
                // Count non-empty colors (colors that have a color object)
                actualColorCount = location.colors.filter((colorObj) => {
                    return (
                        colorObj &&
                        colorObj.color &&
                        (colorObj.color.color_id !== undefined ||
                        colorObj.color.color_value || 
                            colorObj.color.hex)
                    );
                }).length;
            }
            
            // If colors array count is 0 or not available, check no_of_color
            if (actualColorCount === 0) {
                const noOfColors = parseInt(location.no_of_color || 0);
                if (
                    noOfColors > 0 &&
                    noOfColors !== "full_color" &&
                    noOfColors !== "Full color"
                ) {
                    actualColorCount = noOfColors;
                }
            }
            
            // Only return true if full color flag is set AND actual color count > 1
            // If only 1 color is selected, treat as normal (not full color)
            return actualColorCount > 1;
        },

        // Helper method to get full color value from master_service
        getFullColorValue(item) {
            if (!item.decoration || !item.decoration.master_service) {
                return 0;
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return 0;
                }
            }

            const masterService = decoration.master_service || {};
            // Check for full_color value in master_service
            const fullColorValue = parseFloat(masterService.full_color || 0);
            return fullColorValue;
        },

        // Get Run Charge Breakdown Data for Decoration Type 0, 1, and 2
        getRunChargeBreakdown(item) {
            // Handle decoration type 0 (PCNA)
            if (item.decoration_type == 0) {
                return this.getRunChargeBreakdownType0(item);
            }

            // Handle decoration type 1 (Screen Print) and 2 (Embroidery)
            if (item.decoration_type == 1 || item.decoration_type == 2) {
                return this.getRunChargeBreakdownType1And2(item);
            }

            return [];
        },

        // Get Run Charge Breakdown for Decoration Type 0 (PCNA)
        getRunChargeBreakdownType0(item) {
            if (!item.decoration || !item.decoration.master_service) {
                return [];
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error(
                        "Error parsing decoration in getRunChargeBreakdown:",
                        e
                    );
                    return [];
                }
            }

            const quantity = this.getTotalItemQuantity(item);
            const masterService = decoration.master_service || {};
            const location1stFee = parseFloat(masterService.location_1st || 0);
            const additionalLocationFee = parseFloat(
                masterService.additional_location || 0
            );
            const costPerColor1st = parseFloat(
                masterService.cost_per_color_1st || 0
            );
            const costPerColor2ndOrMore = parseFloat(
                masterService.cost_per_color_2ndormore || 0
            );

            const breakdown = [];

            if (
                item.imprint_locations &&
                Array.isArray(item.imprint_locations)
            ) {
                let locationIndex = 0;
                const fullColorValue = this.getFullColorValue(item);
                
                // Check if first location is full color (for additional location pricing logic)
                let isFirstLocationFullColor = false;
                const firstLocation = item.imprint_locations.find(
                    (loc) => loc.is_selected
                );
                if (firstLocation) {
                    isFirstLocationFullColor = this.isLocationFullColor(firstLocation);
                }
                
                item.imprint_locations.forEach((location) => {
                    if (location.is_selected) {
                        const isFullColor = this.isLocationFullColor(location);
                        const noOfColors = parseInt(location.no_of_color || 0);
                        const locationName =
                            location.location ||
                            `Location ${locationIndex + 1}`;

                        if (locationIndex === 0) {
                            // First Location
                            const location1stTotal = location1stFee * quantity;
                            breakdown.push({
                                type: "location",
                                name: `1st Location${
                                    locationName !== "1st Location"
                                        ? " (" + locationName + ")"
                                        : ""
                                }`,
                                qty: quantity,
                                amt:
                                    location1stFee === 0 ||
                                    location1stTotal === 0
                                        ? "INCL"
                                        : location1stFee,
                                total:
                                    location1stFee === 0 ||
                                    location1stTotal === 0
                                        ? "INCL"
                                        : location1stTotal
                            });

                            // Full Color or Regular Colors
                            if (isFullColor && fullColorValue > 0) {
                                // Full Color for first location
                                breakdown.push({
                                    type: "fullColor",
                                    name: "Full Color",
                                    qty: quantity,
                                    amt: fullColorValue,
                                    total: fullColorValue * quantity
                                });
                            } else {
                                // 1st Color
                                const color1stTotal =
                                    costPerColor1st * quantity;
                                breakdown.push({
                                    type: "color1",
                                    name: "1st Color",
                                    qty: quantity,
                                    amt:
                                        costPerColor1st === 0 ||
                                        color1stTotal === 0
                                            ? "INCL"
                                            : costPerColor1st,
                                    total:
                                        costPerColor1st === 0 ||
                                        color1stTotal === 0
                                            ? "INCL"
                                            : color1stTotal
                                });

                                // Additional Colors (if > 1)
                                if (noOfColors > 1) {
                                    const additionalColors = noOfColors - 1;
                                    breakdown.push({
                                        type: "addlColor",
                                        name: `Addl Color (${additionalColors})`,
                                        qty: quantity * additionalColors,
                                        amt: costPerColor2ndOrMore,
                                        total:
                                            costPerColor2ndOrMore *
                                            additionalColors *
                                            quantity
                                    });
                                }
                            }

                            // Color Upcharge (if any)
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                let totalUpcharge = 0;
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        totalUpcharge += parseFloat(
                                            color.color.decor_upcharge || 0
                                        );
                                    }
                                });
                                if (totalUpcharge > 0) {
                                    breakdown.push({
                                        type: "colorUpcharge",
                                        name: "Specialty Ink Fee",
                                        qty: quantity,
                                        amt: totalUpcharge,
                                        total: totalUpcharge * quantity
                                    });
                                }
                            }

                            // Name/Number Fees for first location (Front)
                            if (locationIndex === 0) {
                                const nameNumberFees =
                                    this.getNameNumberFeesFromItemPrices(
                                        item,
                                        "front"
                                    );
                                nameNumberFees.forEach((fee) => {
                                    if (fee.total > 0) {
                                        breakdown.push({
                                            type: "nameNumberFee",
                                            name: fee.name,
                                            qty: fee.qty,
                                            amt: fee.amt,
                                            total: fee.total
                                        });
                                    }
                                });
                            }
                        } else {
                            // Additional Location
                            breakdown.push({
                                type: "location",
                                name: `Additional Location (${locationName})`,
                                qty: quantity,
                                amt: additionalLocationFee,
                                total: additionalLocationFee * quantity
                            });

                            // Full Color or Regular Colors for additional location
                            if (isFullColor && fullColorValue > 0) {
                                // Full Color for additional location - use same value as first location
                                breakdown.push({
                                    type: "fullColor",
                                    name: "Full Color",
                                    qty: quantity,
                                    amt: fullColorValue,
                                    total: fullColorValue * quantity
                                });
                            } else if (noOfColors > 0) {
                                // 1st Color for additional location
                                // If first location is full color, use fullColorValue for additional location's 1st color
                                // Otherwise use cost_per_color_1st
                                const firstColorCost = isFirstLocationFullColor && fullColorValue > 0 
                                    ? fullColorValue 
                                    : costPerColor1st;
                                
                                if (firstColorCost > 0) {
                                    breakdown.push({
                                        type: "color1",
                                        name: "1st Color",
                                        qty: quantity,
                                        amt: firstColorCost,
                                        total: firstColorCost * quantity
                                    });
                                }

                                // Additional Colors (if > 1)
                                if (noOfColors > 1) {
                                    const additionalColors = noOfColors - 1;
                                    breakdown.push({
                                        type: "addlColor",
                                        name: `Addl Color (${additionalColors})`,
                                        qty: quantity * additionalColors,
                                        amt: costPerColor2ndOrMore,
                                        total:
                                            costPerColor2ndOrMore *
                                            additionalColors *
                                            quantity
                                    });
                                }
                            }

                            // Color Upcharge (if any)
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                let totalUpcharge = 0;
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        totalUpcharge += parseFloat(
                                            color.color.decor_upcharge || 0
                                        );
                                    }
                                });
                                if (totalUpcharge > 0) {
                                    breakdown.push({
                                        type: "colorUpcharge",
                                        name: "Specialty Ink Fee",
                                        qty: quantity,
                                        amt: totalUpcharge,
                                        total: totalUpcharge * quantity
                                    });
                                }
                            }

                            // Name/Number Fees for additional locations
                            const locationNameLower =
                                locationName.toLowerCase();
                            const nameNumberFees =
                                this.getNameNumberFeesFromItemPrices(
                                    item,
                                    locationNameLower
                                );
                            nameNumberFees.forEach((fee) => {
                                if (fee.total > 0) {
                                    breakdown.push({
                                        type: "nameNumberFee",
                                        name: fee.name,
                                        qty: fee.qty,
                                        amt: fee.amt,
                                        total: fee.total
                                    });
                                }
                            });
                        }

                        locationIndex++;
                    }
                });
            }

            return breakdown;
        },

        // Get Run Charge Breakdown for Decoration Type 1 (Screen Print) and 2 (Embroidery)
        getRunChargeBreakdownType1And2(item) {
            if (!item.decoration || !item.imprint_locations) {
                return [];
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error(
                        "Error parsing decoration in getRunChargeBreakdownType1And2:",
                        e
                    );
                    return [];
                }
            }

            // Parse imprint_locations if it's a string
            let imprintLocations = item.imprint_locations;
            if (typeof imprintLocations === "string") {
                try {
                    imprintLocations = JSON.parse(imprintLocations);
                } catch (e) {
                    console.error("Error parsing imprint_locations:", e);
                    return [];
                }
            }

            if (!imprintLocations || !Array.isArray(imprintLocations)) {
                return [];
            }

            // Get price_decoration_bulk from decoration or item
            let priceBulk =
                decoration.price_decoration_bulk || item.price_decoration_bulk;
            if (typeof priceBulk === "string") {
                try {
                    priceBulk = JSON.parse(priceBulk);
                } catch (e) {
                    console.error("Error parsing price_decoration_bulk:", e);
                    return [];
                }
            }

            if (!priceBulk) {
                return [];
            }

            const quantity = this.getTotalItemQuantity(item);
            const breakdown = [];

            // Get master service data for stitch cost (embroidery)
            const masterService = decoration.master_service || {};
            const stitchCost = parseFloat(masterService.emb_1000_over_10k || 0);
            const stitchCount = parseFloat(item.design_area_inches || 0); // Assuming design_area_inches contains stitch count

            // Find first selected location
            const firstLocation =
                imprintLocations.find((loc) => loc.is_selected) ||
                imprintLocations[0];
            if (!firstLocation) {
                return [];
            }

            const firstLocationName = firstLocation.location || "1st Location";
            const firstLocationColorCount = parseInt(
                firstLocation.no_of_color || 0
            );
            const isFirstLocationFullColor =
                this.isLocationFullColor(firstLocation);
            const fullColorValue = this.getFullColorValue(item);

            // 1st Location (INCL)
            breakdown.push({
                type: "location",
                name: `1st Location${
                    firstLocationName !== "1st Location"
                        ? " (" + firstLocationName + ")"
                        : ""
                }`,
                qty: quantity,
                amt: "INCL",
                total: "INCL",
                isIncluded: true
            });

            // Full Color or Regular Colors for first location
            if (isFirstLocationFullColor && fullColorValue > 0) {
                // Full Color for first location
                breakdown.push({
                    type: "fullColor",
                    name: "Full Color",
                    qty: quantity,
                    amt: fullColorValue,
                    total: fullColorValue * quantity,
                    isIncluded: false
                });
            } else {
                // 1st Color (INCL)
                breakdown.push({
                    type: "color1",
                    name: "1st Color",
                    qty: quantity,
                    amt: "INCL",
                    total: "INCL",
                    isIncluded: true
                });

                // Addl Color for 1st Location (only for type 1, if colors > 1)
                if (item.decoration_type == 1 && firstLocationColorCount > 1) {
                    const addlColors = firstLocationColorCount - 1;
                    const addlColorPrice = this.getFirstLocationAddlColorPrice(
                        item,
                        priceBulk,
                        quantity,
                        firstLocationColorCount
                    );
                    if (addlColorPrice > 0) {
                        breakdown.push({
                            type: "addlColor",
                            name: `Addl Color (${addlColors})`,
                            qty: quantity * addlColors,
                            amt: addlColorPrice,
                            total: addlColorPrice * addlColors * quantity,
                            isIncluded: false
                        });
                    }
                }
            }

            // Specialty Ink Fee (color upcharge) for 1st Location
            const firstLocationUpcharge = this.getLocationColorUpcharge(
                firstLocation,
                item
            );
            if (firstLocationUpcharge > 0) {
                breakdown.push({
                    type: "colorUpcharge",
                    name: "Specialty Ink Fee",
                    qty: quantity,
                    amt: firstLocationUpcharge,
                    total: firstLocationUpcharge * quantity,
                    isIncluded: false
                });
            }

            // Name/Number Fees for 1st Location (Front)
            const frontNameNumberFees = this.getNameNumberFeesFromItemPrices(
                item,
                "front"
            );
            frontNameNumberFees.forEach((fee) => {
                if (fee.total > 0) {
                    breakdown.push({
                        type: "nameNumberFee",
                        name: fee.name,
                        qty: fee.qty,
                        amt: fee.amt,
                        total: fee.total,
                        isIncluded: false
                    });
                }
            });

            // Additional Locations
            const firstSelectedIndex = imprintLocations.findIndex(
                (loc) => loc.is_selected
            );
            const additionalLocations = imprintLocations.filter((loc, idx) => {
                return loc.is_selected && idx !== firstSelectedIndex;
            });

            additionalLocations.forEach((location, idx) => {
                const locationName = location.location || `Location ${idx + 2}`;
                const colorCount = parseInt(location.no_of_color || 0);
                const isLocationFullColor = this.isLocationFullColor(location);

                if (colorCount <= 0 && !isLocationFullColor) return;

                // Additional Location
                // For decoration type 1, show "-" instead of "INCL" for amount and total
                breakdown.push({
                    type: "location",
                    name: `Additional Location${
                        locationName ? " (" + locationName + ")" : ""
                    }`,
                    qty: quantity,
                    amt: item.decoration_type == 1 ? "-" : "INCL",
                    total: item.decoration_type == 1 ? "-" : "INCL",
                    isIncluded: true
                });

                // Full Color or Addl Color for additional location
                if (isLocationFullColor && fullColorValue > 0) {
                    // Full Color for additional location - use same value as first location
                    breakdown.push({
                        type: "fullColor",
                        name: "Full Color",
                        qty: quantity,
                        amt: fullColorValue,
                        total: fullColorValue * quantity,
                        isIncluded: false
                    });
                } else if (colorCount > 0) {
                    // Addl Color for additional location
                    let addlColorPrice = 0;
                    if (item.decoration_type == 1) {
                        // Screen Print: use print_location2
                        addlColorPrice =
                            this.getAdditionalLocationAddlColorPrice(
                                item,
                                priceBulk,
                                quantity,
                                colorCount
                            );
                    } else if (item.decoration_type == 2) {
                        // Embroidery: use location2 from bulk
                        addlColorPrice = this.getEmbroideryLocationPrice(
                            item,
                            priceBulk,
                            quantity
                        );
                    }

                    if (addlColorPrice > 0) {
                        breakdown.push({
                            type: "addlColor",
                            name: `Addl Color (${colorCount})`,
                            qty: quantity * colorCount,
                            amt: addlColorPrice,
                            total: addlColorPrice * colorCount * quantity,
                            isIncluded: false
                        });
                    }
                }

                // Specialty Ink Fee for additional location
                const locationUpcharge = this.getLocationColorUpcharge(
                    location,
                    item
                );
                if (locationUpcharge > 0) {
                    breakdown.push({
                        type: "colorUpcharge",
                        name: "Specialty Ink Fee",
                        qty: quantity,
                        amt: locationUpcharge,
                        total: locationUpcharge * quantity,
                        isIncluded: false
                    });
                }

                // Name/Number Fees for additional location
                // Normalize location name to match item_prices structure (back, front, etc.)
                const locationNameLower = locationName.toLowerCase().trim();
                let nameNumberFees = this.getNameNumberFeesFromItemPrices(
                    item,
                    locationNameLower
                );

                // If location name doesn't match exactly, try common variations
                if (nameNumberFees.length === 0) {
                    // Check if it's a back location (could be "Back", "back", "BACK", etc.)
                    if (locationNameLower.includes("back")) {
                        nameNumberFees = this.getNameNumberFeesFromItemPrices(
                            item,
                            "back"
                        );
                    }
                }

                nameNumberFees.forEach((fee) => {
                    if (fee.total > 0) {
                        breakdown.push({
                            type: "nameNumberFee",
                            name: fee.name,
                            qty: fee.qty,
                            amt: fee.amt,
                            total: fee.total,
                            isIncluded: false
                        });
                    }
                });
            });

            // Also check for back location fees explicitly (in case back location is not in additional locations)
            // This ensures back name/number fees are always shown if they exist in item_prices
            const backNameNumberFees = this.getNameNumberFeesFromItemPrices(
                item,
                "back"
            );
            if (backNameNumberFees.length > 0) {
                // Check if back location is already processed in additional locations
                const backLocationProcessed = additionalLocations.some(
                    (loc) => {
                        const locName = (loc.location || "")
                            .toLowerCase()
                            .trim();
                        return locName.includes("back");
                    }
                );

                // If back location not processed yet, add the fees
                if (!backLocationProcessed) {
                    backNameNumberFees.forEach((fee) => {
                        if (fee.total > 0) {
                            breakdown.push({
                                type: "nameNumberFee",
                                name: fee.name,
                                qty: fee.qty,
                                amt: fee.amt,
                                total: fee.total,
                                isIncluded: false
                            });
                        }
                    });
                }
            }

            // Stitch Cost for Embroidery (if stitchCount > 10000)
            if (
                item.decoration_type == 2 &&
                stitchCount > 10000 &&
                stitchCost > 0
            ) {
                const remainingStitches = stitchCount - 10000;
                const costPer1000Stitches = stitchCost;
                const totalStitchCost =
                    Math.ceil(remainingStitches / 1000) * costPer1000Stitches;

                breakdown.push({
                    type: "stitchCost",
                    name: "Stitch Cost",
                    qty: quantity,
                    amt: totalStitchCost / quantity,
                    total: totalStitchCost * quantity,
                    isIncluded: false
                });
            }

            return breakdown;
        },

        // Get First Location Additional Color Price (for type 1)
        getFirstLocationAddlColorPrice(item, priceBulk, quantity, colorCount) {
            if (
                !priceBulk ||
                !priceBulk.print_location1 ||
                item.decoration_type != 1
            ) {
                return 0;
            }

            const priceData = priceBulk.print_location1;
            if (!Array.isArray(priceData)) {
                return 0;
            }

            // Find the price tier for current quantity
            let lastColorPrice = 0;
            let firstColorPrice = 0;

            for (let i = priceData.length - 1; i >= 0; i--) {
                const tier = priceData[i];
                if (
                    tier &&
                    tier.quantity &&
                    parseInt(tier.quantity) <= quantity
                ) {
                    lastColorPrice = parseFloat(
                        tier[`colour${colorCount}`] || 0
                    );
                    firstColorPrice = parseFloat(tier.colour1 || 0);
                    break;
                }
            }

            // If no tier found, use first tier
            if (lastColorPrice === 0 && priceData.length > 0) {
                const firstTier = priceData[0];
                lastColorPrice = parseFloat(
                    firstTier[`colour${colorCount}`] || 0
                );
                firstColorPrice = parseFloat(firstTier.colour1 || 0);
            }

            // Additional color price is the difference
            return Math.max(0, lastColorPrice - firstColorPrice);
        },

        // Get Additional Location Additional Color Price (for type 1)
        getAdditionalLocationAddlColorPrice(
            item,
            priceBulk,
            quantity,
            colorCount
        ) {
            if (
                !priceBulk ||
                !priceBulk.print_location2 ||
                item.decoration_type != 1
            ) {
                return 0;
            }

            const priceData = priceBulk.print_location2;
            if (!Array.isArray(priceData)) {
                return 0;
            }

            // Find the price tier for current quantity
            let directPrice = 0;

            for (let i = priceData.length - 1; i >= 0; i--) {
                const tier = priceData[i];
                if (
                    tier &&
                    tier.quantity &&
                    parseInt(tier.quantity) <= quantity
                ) {
                    directPrice = parseFloat(tier[`colour${colorCount}`] || 0);
                    break;
                }
            }

            // If no tier found, use first tier
            if (directPrice === 0 && priceData.length > 0) {
                const firstTier = priceData[0];
                directPrice = parseFloat(firstTier[`colour${colorCount}`] || 0);
            }

            return directPrice;
        },

        // Get Embroidery Location Price (for type 2)
        getEmbroideryLocationPrice(item, priceBulk, quantity) {
            if (!priceBulk || item.decoration_type != 2) {
                return 0;
            }

            // For embroidery, priceBulk is an array
            if (!Array.isArray(priceBulk)) {
                return 0;
            }

            // Find the price tier for current quantity
            let selectedRow = null;

            for (const row of priceBulk) {
                if (row.quantity1 && row.quantity2) {
                    if (
                        quantity >= parseInt(row.quantity1) &&
                        quantity <= parseInt(row.quantity2)
                    ) {
                        selectedRow = row;
                        break;
                    }
                } else if (
                    row.quantity1 &&
                    quantity >= parseInt(row.quantity1)
                ) {
                    selectedRow = row;
                    break;
                }
            }

            // If no tier found, use first tier
            if (!selectedRow && priceBulk.length > 0) {
                selectedRow = priceBulk[0];
            }

            if (selectedRow && selectedRow.location2 !== undefined) {
                return parseFloat(selectedRow.location2 || 0);
            }

            return 0;
        },

        // Get Location Color Upcharge
        getLocationColorUpcharge(location, item) {
            if (
                !location ||
                !location.colors ||
                !Array.isArray(location.colors)
            ) {
                return 0;
            }

            let totalUpcharge = 0;
            location.colors.forEach((colorObj) => {
                if (
                    colorObj &&
                    colorObj.color &&
                    colorObj.color.decor_upcharge
                ) {
                    totalUpcharge += parseFloat(
                        colorObj.color.decor_upcharge || 0
                    );
                }
            });

            return parseFloat(totalUpcharge.toFixed(2));
        },

        // Get Name/Number Fees from item_prices for a specific location
        getNameNumberFeesFromItemPrices(item, locationName) {
            const fees = [];

            if (!item.item_prices) {
                return fees;
            }

            // Parse item_prices if it's a string
            let itemPrices = item.item_prices;
            if (typeof itemPrices === "string") {
                try {
                    itemPrices = JSON.parse(itemPrices);
                } catch (e) {
                    console.error("Error parsing item_prices:", e);
                    return fees;
                }
            }

            if (!itemPrices.selected_name_number) {
                return fees;
            }

            const selectedNameNumber = itemPrices.selected_name_number;
            const location = locationName.toLowerCase();

            // Front location
            if (location === "front" && selectedNameNumber.front) {
                const front = selectedNameNumber.front;

                // Front Number Fee
                if (
                    front.number &&
                    front.number.front_number_fees &&
                    front.number.front_number_fees > 0
                ) {
                    const count = parseInt(
                        front.number.front_number_count || 0
                    );
                    const totalFee = parseFloat(
                        front.number.front_number_fees || 0
                    );
                    const perPrice = parseFloat(
                        front.number.front_number_per_price || 0
                    );

                    fees.push({
                        name: "Front Number Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }

                // Front Number Decor Up Fee
                if (
                    front.number &&
                    front.number.front_number_decor_up_fees &&
                    front.number.front_number_decor_up_fees > 0
                ) {
                    const count = parseInt(
                        front.number.front_number_count || 0
                    );
                    const totalFee = parseFloat(
                        front.number.front_number_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        front.number.front_number_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Front Number Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }
            }

            // Back location
            if (location === "back" && selectedNameNumber.back) {
                const back = selectedNameNumber.back;

                // Back Name Fee
                if (
                    back.name &&
                    back.name.back_name_fees &&
                    back.name.back_name_fees > 0
                ) {
                    const count = parseInt(back.name.back_name_count || 0);
                    const totalFee = parseFloat(back.name.back_name_fees || 0);
                    const perPrice = parseFloat(
                        back.name.back_name_per_price || 0
                    );

                    fees.push({
                        name: "Back Name Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }

                // Back Name Decor Up Fee
                if (
                    back.name &&
                    back.name.back_name_decor_up_fees &&
                    back.name.back_name_decor_up_fees > 0
                ) {
                    const count = parseInt(back.name.back_name_count || 0);
                    const totalFee = parseFloat(
                        back.name.back_name_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        back.name.back_name_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Back Name Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }

                // Back Number Fee
                if (
                    back.number &&
                    back.number.back_number_fees &&
                    back.number.back_number_fees > 0
                ) {
                    const count = parseInt(back.number.back_number_count || 0);
                    const totalFee = parseFloat(
                        back.number.back_number_fees || 0
                    );
                    const perPrice = parseFloat(
                        back.number.back_number_per_price || 0
                    );

                    fees.push({
                        name: "Back Number Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }

                // Back Number Decor Up Fee
                if (
                    back.number &&
                    back.number.back_number_decor_up_fees &&
                    back.number.back_number_decor_up_fees > 0
                ) {
                    const count = parseInt(back.number.back_number_count || 0);
                    const totalFee = parseFloat(
                        back.number.back_number_decor_up_fees || 0
                    );
                    const perPrice = parseFloat(
                        back.number.back_number_decor_up_per_price || 0
                    );

                    fees.push({
                        name: "Back Number Decor Up Fee",
                        qty: count,
                        amt: perPrice,
                        total: totalFee
                    });
                }
            }

            return fees;
        },

        // Get Custom Color Fee Data for Decoration Type 0, 1, and 2
        getColorMixFeeData(item) {
            if (
                (item.decoration_type != 0 &&
                    item.decoration_type != 1 &&
                    item.decoration_type != 2) ||
                !item.decoration
            ) {
                return null;
            }

            // Parse decoration if it's a string
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    console.error("Error parsing decoration:", e);
                    return null;
                }
            }

            // For PCNA (decoration_type 0), check if service name contains "print" or "embroidery"
            if (item.decoration_type == 0) {
                const masterService = decoration.master_service || {};
                // Check both 'name' and 'service_name' fields (service name might be in either)
                const serviceName = (
                    masterService.name ||
                    masterService.service_name ||
                    ""
                ).toLowerCase();
                const isEmbroidery =
                    serviceName.includes("embroidery") ||
                    serviceName.includes("emb");
                const isPrint = serviceName.includes("print");

                // If service name doesn't contain "print" or "embroidery", no color mix fee
                if (!isEmbroidery && !isPrint) {
                    return null;
                }
            }

            // Get fee per color from decoration (added in activeServiceData)
            // This should be per-service, so each item with different service will have different fee
            let feePerColor = parseFloat(decoration.color_mix_fee || 0);

            // If fee is not in decoration, try to get from VendorFees or adminOptions
            if (!feePerColor || feePerColor <= 0) {
                // Try to get from VendorFees (if available in main_new_product)
                if (
                    item.main_new_product &&
                    item.main_new_product.VendorFees &&
                    Array.isArray(item.main_new_product.VendorFees)
                ) {
                    const vendorFees = item.main_new_product.VendorFees;
                    const masterService = decoration.master_service || {};
                    const serviceName = (
                        masterService.name ||
                        masterService.service_name ||
                        ""
                    ).toLowerCase();

                    let targetService = null;

                    if (item.decoration_type == 2) {
                        // Decoration type 2 = Embroidery = Thread Mix Fee
                        targetService = vendorFees.find(
                            (service) =>
                                service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("thread mix fee"))
                        );
                    } else if (item.decoration_type == 1) {
                        // Decoration type 1 = Screen Print = Ink Mix Fee
                        targetService = vendorFees.find(
                            (service) =>
                                service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("ink mix fee"))
                        );
                    } else if (item.decoration_type == 0) {
                        // Decoration type 0 = PCNA - check service name
                        const isEmbroidery =
                            serviceName.includes("embroidery") ||
                            serviceName.includes("emb");
                        const isPrint = serviceName.includes("print");

                        if (isEmbroidery) {
                            targetService = vendorFees.find(
                                (service) =>
                                    service.type === "thread_fee" ||
                                    (service.ecomm_display &&
                                        service.ecomm_display
                                            .toLowerCase()
                                            .includes("thread mix fee"))
                            );
                        } else if (isPrint) {
                            targetService = vendorFees.find(
                                (service) =>
                                    service.type === "custom_ink_mix" ||
                                    (service.ecomm_display &&
                                        service.ecomm_display
                                            .toLowerCase()
                                            .includes("ink mix fee"))
                            );
                        }
                    }

                    if (targetService && targetService.retail_cost) {
                        feePerColor =
                            parseFloat(targetService.retail_cost) || 0;
                    }
                }

                // If still no fee, fallback to adminOptions
                if (!feePerColor || feePerColor <= 0) {
                    let non_standard_fees_obj = null;

                    if (item.decoration_type == 1) {
                        // Screen Print
                        non_standard_fees_obj = this.adminOptions.find(
                            (option) =>
                                option.option_key == "non_standard_color_fees"
                        );
                    } else if (item.decoration_type == 2) {
                        // Embroidery
                        non_standard_fees_obj = this.adminOptions.find(
                            (option) =>
                                option.option_key ==
                                "non_standard_color_fees_emb"
                        );
                    } else if (item.decoration_type == 0) {
                        // PCNA - check service name
                        const masterService = decoration.master_service || {};
                        const serviceName = (
                            masterService.name ||
                            masterService.service_name ||
                            ""
                        ).toLowerCase();
                        const isEmbroidery =
                            serviceName.includes("embroidery") ||
                            serviceName.includes("emb");
                        const isPrint = serviceName.includes("print");

                        if (isEmbroidery) {
                            non_standard_fees_obj = this.adminOptions.find(
                                (option) =>
                                    option.option_key ==
                                    "non_standard_color_fees_emb"
                            );
                        } else if (isPrint) {
                            non_standard_fees_obj = this.adminOptions.find(
                                (option) =>
                                    option.option_key ==
                                    "non_standard_color_fees"
                            );
                        }
                    }

                    if (
                        non_standard_fees_obj &&
                        non_standard_fees_obj.option_value
                    ) {
                        feePerColor =
                            parseFloat(non_standard_fees_obj.option_value) || 0;
                    }
                }
            }

            // Get unique non-standard color count (color_id == 0)
            // This should be per-item, so each item with different colors will have different count
            const mixColorCount = this.getUniqueNonStandardColors(item);

            // Return null only if fee is missing/zero (colors can be 0, but fee must exist)
            if (!feePerColor || feePerColor <= 0) {
                return null;
            }

            // Calculate total (unique count × fee per color, NO quantity multiplication)
            const total = mixColorCount * feePerColor;

            // Determine fee label based on decoration type and service name
            let feeLabel = "Color Ink Mix Fee"; // Default

            if (item.decoration_type == 2) {
                // Decoration type 2 = Embroidery = Thread Mix Fee
                feeLabel = "Color Thread Mix Fee";
            } else if (item.decoration_type == 1) {
                // Decoration type 1 = Screen Print = Ink Mix Fee
                feeLabel = "Color Ink Mix Fee";
            } else if (item.decoration_type == 0) {
                // Decoration type 0 = PCNA - check service name (already validated earlier)
                const masterService = decoration.master_service || {};
                // Check both 'name' and 'service_name' fields (service name might be in either)
                const serviceName = (
                    masterService.name ||
                    masterService.service_name ||
                    ""
                ).toLowerCase();
                const isEmbroidery =
                    serviceName.includes("embroidery") ||
                    serviceName.includes("emb");
                const isPrint = serviceName.includes("print");

                if (isEmbroidery) {
                    feeLabel = "Color Thread Mix Fee";
                } else if (isPrint) {
                    feeLabel = "Color Ink Mix Fee";
                }
                // If neither embroidery nor print, would have returned null earlier
            }

            return {
                label: feeLabel,
                mixColorCount: mixColorCount,
                unitPrice: feePerColor,
                total: total
            };
        },

        // Get unique non-standard colors from imprint_locations (for type 0) or non_standard_colors (for type 1 and 2)
        getUniqueNonStandardColors(item) {
            const uniqueColors = new Set();

            // For decoration type 1 and 2, use non_standard_colors array
            if (item.decoration_type == 1 || item.decoration_type == 2) {
                let nonStandardColors = item.non_standard_colors;
                if (typeof nonStandardColors === "string") {
                    try {
                        nonStandardColors = JSON.parse(nonStandardColors);
                    } catch (e) {
                        console.error("Error parsing non_standard_colors:", e);
                        return 0;
                    }
                }

                if (nonStandardColors && Array.isArray(nonStandardColors)) {
                    nonStandardColors.forEach((colorHex) => {
                        if (colorHex && typeof colorHex === "string") {
                            const colorKey = colorHex.toLowerCase();
                            if (
                                colorKey &&
                                colorKey !== "#gggggg" &&
                                colorKey !== ""
                            ) {
                                uniqueColors.add(colorKey);
                            }
                        }
                    });
                }

                return uniqueColors.size;
            }

            // For decoration type 0, use imprint_locations
            // Parse imprint_locations if it's a string
            let imprintLocations = item.imprint_locations;
            if (typeof imprintLocations === "string") {
                try {
                    imprintLocations = JSON.parse(imprintLocations);
                } catch (e) {
                    console.error("Error parsing imprint_locations:", e);
                    return 0;
                }
            }

            if (!imprintLocations || !Array.isArray(imprintLocations)) {
                return 0;
            }

            imprintLocations.forEach((location) => {
                if (
                    location &&
                    location.is_selected &&
                    location.colors &&
                    Array.isArray(location.colors)
                ) {
                    location.colors.forEach((colorObj) => {
                        if (colorObj && colorObj.color) {
                            const color = colorObj.color;
                            const colorId = parseInt(color.color_id || 0);

                            // Check if it's a non-standard color (color_id == 0)
                            if (colorId === 0) {
                                // Use color_value or hex as unique identifier
                                const colorKey = (
                                    color.color_value ||
                                    color.hex ||
                                    ""
                                ).toLowerCase();
                                if (
                                    colorKey &&
                                    colorKey !== "#gggggg" &&
                                    colorKey !== ""
                                ) {
                                    uniqueColors.add(colorKey);
                                }
                            }
                        }
                    });
                }
            });

            return uniqueColors.size;
        },

        // Get Color Mix Fee Total
        getColorMixFeeTotal(item) {
            let total = 0;
            const mixFeeData = this.getColorMixFeeData(item);
            if (mixFeeData && mixFeeData.total > 0) {
                total += parseFloat(mixFeeData.total);
            }
            
            // Add services with rollup_fee_id = 13 (Color Mix Fee services) - include all services regardless of show_service
            const colorMixFeeServices = this.getColorMixFeeServices(item);
            if (colorMixFeeServices && colorMixFeeServices.length > 0) {
                const quantity = this.getTotalItemQuantity(item);
                colorMixFeeServices.forEach(service => {
                    const servicePrice = service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === 'Per Item') {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }
            
            return parseFloat(total.toFixed(2));
        },

        // Check if item is part of a grouped decoration type 0, 1, or 2
        // For type 0: same item_id + same service
        // For type 1 and 2: same item_id + same decoration_type + same decoration_price_template
        isGroupedDecorationType0(item) {
            // Only for decoration type 0, 1, and 2
            if (
                item.decoration_type !== 0 &&
                item.decoration_type !== 1 &&
                item.decoration_type !== 2
            ) {
                return false;
            }

            // Check if this item has subItems
            if (!item.subItems || item.subItems.length === 0) {
                return false;
            }

            // For decoration type 0, check service
            if (item.decoration_type === 0) {
                // Parse decoration to get service ID
                let decoration = item.decoration;
                if (typeof decoration === "string") {
                    try {
                        decoration = JSON.parse(decoration);
                    } catch (e) {
                        return false;
                    }
                }

                const itemServiceId =
                    decoration.master_service && decoration.master_service.id
                    ? decoration.master_service.id
                    : null;

                // Check if all subItems have same item_id, decoration_type, and service
                return item.subItems.some((subItem) => {
                    if (
                        subItem.item_id !== item.item_id ||
                        subItem.decoration_type !== 0
                    ) {
                        return false;
                    }

                    let subDecoration = subItem.decoration;
                    if (typeof subDecoration === "string") {
                        try {
                            subDecoration = JSON.parse(subDecoration);
                        } catch (e) {
                            return false;
                        }
                    }

                    const subServiceId =
                        subDecoration.master_service &&
                        subDecoration.master_service.id
                        ? subDecoration.master_service.id
                        : null;

                    return itemServiceId === subServiceId;
                });
            }

            // For decoration type 1 and 2, check item_id, decoration_type, and decoration_price_template
            if (item.decoration_type === 1 || item.decoration_type === 2) {
                return item.subItems.some((subItem) => {
                    return (
                        subItem.item_id === item.item_id &&
                        subItem.decoration_type === item.decoration_type &&
                        subItem.decoration_price_template ===
                            item.decoration_price_template
                    );
                });
            }

            return false;
        },

        // Get all items in a group (parent + subItems) for decoration type 0, 1, and 2
        getGroupedItems(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return [item];
            }

            return [item, ...item.subItems];
        },

        // Get combined unique non-standard colors across all items in a group
        getCombinedUniqueNonStandardColors(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return this.getUniqueNonStandardColors(item);
            }

            const groupedItems = this.getGroupedItems(item);
            const uniqueColors = new Set();

            groupedItems.forEach((groupItem) => {
                // For decoration type 1 and 2, use non_standard_colors array
                if (
                    groupItem.decoration_type === 1 ||
                    groupItem.decoration_type === 2
                ) {
                    let nonStandardColors = groupItem.non_standard_colors;
                    if (typeof nonStandardColors === "string") {
                        try {
                            nonStandardColors = JSON.parse(nonStandardColors);
                        } catch (e) {
                            return;
                        }
                    }

                    if (nonStandardColors && Array.isArray(nonStandardColors)) {
                        nonStandardColors.forEach((colorHex) => {
                            if (colorHex && typeof colorHex === "string") {
                                const colorKey = colorHex.toLowerCase();
                                if (
                                    colorKey &&
                                    colorKey !== "#gggggg" &&
                                    colorKey !== ""
                                ) {
                                    uniqueColors.add(colorKey);
                                }
                            }
                        });
                    }
                } else if (groupItem.decoration_type === 0) {
                    // For decoration type 0, use imprint_locations
                    let imprintLocations = groupItem.imprint_locations;
                    if (typeof imprintLocations === "string") {
                        try {
                            imprintLocations = JSON.parse(imprintLocations);
                        } catch (e) {
                            return;
                        }
                    }

                    if (!imprintLocations || !Array.isArray(imprintLocations)) {
                        return;
                    }

                    imprintLocations.forEach((location) => {
                        if (
                            location &&
                            location.is_selected &&
                            location.colors &&
                            Array.isArray(location.colors)
                        ) {
                            location.colors.forEach((colorObj) => {
                                if (colorObj && colorObj.color) {
                                    const color = colorObj.color;
                                    const colorId = parseInt(
                                        color.color_id || 0
                                    );

                                    // Check if it's a non-standard color (color_id == 0)
                                    if (colorId === 0) {
                                        // Use color_value or hex as unique identifier
                                        const colorKey = (
                                            color.color_value ||
                                            color.hex ||
                                            ""
                                        ).toLowerCase();
                                        if (
                                            colorKey &&
                                            colorKey !== "#gggggg" &&
                                            colorKey !== ""
                                        ) {
                                            uniqueColors.add(colorKey);
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            });

            return uniqueColors.size;
        },

        // Get combined color mix fee data for grouped items (type 0, 1, and 2)
        getCombinedColorMixFeeData(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return null;
            }

            // Get fee per color from first item (should be same for all items in group)
            let decoration = item.decoration;
            if (typeof decoration === "string") {
                try {
                    decoration = JSON.parse(decoration);
                } catch (e) {
                    return null;
                }
            }

            // For PCNA (decoration_type 0), check if service name contains "print" or "embroidery"
            if (item.decoration_type == 0) {
                const masterService = decoration.master_service || {};
                // Check both 'name' and 'service_name' fields (service name might be in either)
                const serviceName = (
                    masterService.name ||
                    masterService.service_name ||
                    ""
                ).toLowerCase();
                const isEmbroidery =
                    serviceName.includes("embroidery") ||
                    serviceName.includes("emb");
                const isPrint = serviceName.includes("print");

                // If service name doesn't contain "print" or "embroidery", no color mix fee
                if (!isEmbroidery && !isPrint) {
                    return null;
                }
            }

            let feePerColor = parseFloat(decoration.color_mix_fee || 0);

            // If fee is not in decoration, try to get from VendorFees or adminOptions
            if (!feePerColor || feePerColor <= 0) {
                // Try to get from VendorFees (if available in main_new_product)
                if (
                    item.main_new_product &&
                    item.main_new_product.VendorFees &&
                    Array.isArray(item.main_new_product.VendorFees)
                ) {
                    const vendorFees = item.main_new_product.VendorFees;
                    const masterService = decoration.master_service || {};
                    const serviceName = (
                        masterService.name ||
                        masterService.service_name ||
                        ""
                    ).toLowerCase();

                    let targetService = null;

                    if (item.decoration_type == 2) {
                        // Decoration type 2 = Embroidery = Thread Mix Fee
                        targetService = vendorFees.find(
                            (service) =>
                                service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("thread mix fee"))
                        );
                    } else if (item.decoration_type == 1) {
                        // Decoration type 1 = Screen Print = Ink Mix Fee
                        targetService = vendorFees.find(
                            (service) =>
                                service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display
                                        .toLowerCase()
                                        .includes("ink mix fee"))
                        );
                    } else if (item.decoration_type == 0) {
                        // Decoration type 0 = PCNA - check service name
                        const isEmbroidery =
                            serviceName.includes("embroidery") ||
                            serviceName.includes("emb");
                        const isPrint = serviceName.includes("print");

                        if (isEmbroidery) {
                            targetService = vendorFees.find(
                                (service) =>
                                    service.type === "thread_fee" ||
                                    (service.ecomm_display &&
                                        service.ecomm_display
                                            .toLowerCase()
                                            .includes("thread mix fee"))
                            );
                        } else if (isPrint) {
                            targetService = vendorFees.find(
                                (service) =>
                                    service.type === "custom_ink_mix" ||
                                    (service.ecomm_display &&
                                        service.ecomm_display
                                            .toLowerCase()
                                            .includes("ink mix fee"))
                            );
                        }
                    }

                    if (targetService && targetService.retail_cost) {
                        feePerColor =
                            parseFloat(targetService.retail_cost) || 0;
                    }
                }

                // If still no fee, fallback to adminOptions
                if (!feePerColor || feePerColor <= 0) {
                    let non_standard_fees_obj = null;

                    if (item.decoration_type == 1) {
                        // Screen Print
                        non_standard_fees_obj = this.adminOptions.find(
                            (option) =>
                                option.option_key == "non_standard_color_fees"
                        );
                    } else if (item.decoration_type == 2) {
                        // Embroidery
                        non_standard_fees_obj = this.adminOptions.find(
                            (option) =>
                                option.option_key ==
                                "non_standard_color_fees_emb"
                        );
                    } else if (item.decoration_type == 0) {
                        // PCNA - check service name
                        const masterService = decoration.master_service || {};
                        const serviceName = (
                            masterService.name ||
                            masterService.service_name ||
                            ""
                        ).toLowerCase();
                        const isEmbroidery =
                            serviceName.includes("embroidery") ||
                            serviceName.includes("emb");
                        const isPrint = serviceName.includes("print");

                        if (isEmbroidery) {
                            non_standard_fees_obj = this.adminOptions.find(
                                (option) =>
                                    option.option_key ==
                                    "non_standard_color_fees_emb"
                            );
                        } else if (isPrint) {
                            non_standard_fees_obj = this.adminOptions.find(
                                (option) =>
                                    option.option_key ==
                                    "non_standard_color_fees"
                            );
                        }
                    }

                    if (
                        non_standard_fees_obj &&
                        non_standard_fees_obj.option_value
                    ) {
                        feePerColor =
                            parseFloat(non_standard_fees_obj.option_value) || 0;
                    }
                }
            }

            if (!feePerColor || feePerColor <= 0) {
                return null;
            }

            // Get combined unique color count
            const mixColorCount = this.getCombinedUniqueNonStandardColors(item);

            // Calculate total
            const total = mixColorCount * feePerColor;

            // Simple label for outside display
            let feeLabel = "Color Mix Fee";

            // Detailed label for breakdown table (Color Ink Mix Fee or Color Thread Mix Fee)
            let breakdownLabel = "Color Ink Mix Fee";

            if (item.decoration_type === 2) {
                // Decoration type 2 = Embroidery = Thread Mix Fee
                breakdownLabel = "Color Thread Mix Fee";
            } else if (item.decoration_type === 1) {
                // Decoration type 1 = Screen Print = Ink Mix Fee
                breakdownLabel = "Color Ink Mix Fee";
            } else if (item.decoration_type === 0) {
                // Decoration type 0 = PCNA - check service name
                const masterService = decoration.master_service || {};
                // Check both 'name' and 'service_name' fields (service name might be in either)
                const serviceName = (
                    masterService.name ||
                    masterService.service_name ||
                    ""
                ).toLowerCase();
                const isEmbroidery =
                    serviceName.includes("embroidery") ||
                    serviceName.includes("emb");
                const isPrint = serviceName.includes("print");

                if (isEmbroidery) {
                    breakdownLabel = "Color Thread Mix Fee";
                } else if (isPrint) {
                    breakdownLabel = "Color Ink Mix Fee";
                } else {
                    // If neither embroidery nor print, should not show fee (but this function doesn't validate)
                    breakdownLabel = "Color Mix Fee";
                }
            }

            return {
                label: feeLabel, // Simple label for outside
                breakdownLabel: breakdownLabel, // Detailed label for breakdown table
                mixColorCount: mixColorCount,
                unitPrice: feePerColor,
                total: total
            };
        },

        // Get combined color mix fee total for grouped items
        getCombinedColorMixFeeTotal(item) {
            let total = 0;
            const mixFeeData = this.getCombinedColorMixFeeData(item);
            if (mixFeeData && mixFeeData.total > 0) {
                total += parseFloat(mixFeeData.total);
            }
            
            // Add services with rollup_fee_id = 13 (Color Mix Fee services) from all subItems
            if (item.subItems && item.subItems.length > 0) {
                item.subItems.forEach(subItem => {
                    const colorMixFeeServices = this.getColorMixFeeServices(subItem);
                    if (colorMixFeeServices && colorMixFeeServices.length > 0) {
                        const quantity = this.getTotalItemQuantity(subItem);
                        colorMixFeeServices.forEach(service => {
                            const servicePrice = service.retail_cost || service.net_cost || 0;
                            if (service.fee_structure === 'Per Item') {
                                total += parseFloat(servicePrice) * quantity;
                            } else {
                                total += parseFloat(servicePrice);
                            }
                        });
                    }
                });
            }
            
            return parseFloat(total.toFixed(2));
        },
        // Check if grouped items have rollup_fee_id = 13 services
        hasCombinedColorMixFeeServices(item) {
            if (!item.subItems || item.subItems.length === 0) {
                return false;
            }
            return item.subItems.some(subItem => {
                const services = this.getColorMixFeeServices(subItem);
                return services && services.length > 0;
            });
        },
        // Get combined rollup_fee_id = 13 services from all subItems
        getCombinedColorMixFeeServices(item) {
            if (!item.subItems || item.subItems.length === 0) {
                return [];
            }
            const allServices = [];
            item.subItems.forEach(subItem => {
                const services = this.getColorMixFeeServices(subItem);
                if (services && services.length > 0) {
                    const subItemQuantity = this.getTotalItemQuantity(subItem);
                    services.forEach(service => {
                        // Create a copy of the service with calculated total based on subItem quantity
                        const serviceCopy = { ...service };
                        const servicePrice = service.retail_cost || service.net_cost || 0;
                        if (service.fee_structure === 'Per Item') {
                            serviceCopy._calculatedTotal = parseFloat(servicePrice) * subItemQuantity;
                            serviceCopy._quantity = subItemQuantity;
                        } else {
                            serviceCopy._calculatedTotal = parseFloat(servicePrice);
                            serviceCopy._quantity = 1;
                        }
                        allServices.push(serviceCopy);
                    });
                }
            });
            return allServices;
        },

        // Get item subtotal excluding color mix fee (for grouped items)
        getItemSubTotalExcludingColorMixFee(item) {
            let total = 0;

            // Base Fee Total
            total += this.getBaseFeeTotal(item);

            // Run Charge (includes name/number fees for all decoration types)
            total += this.getRunChargeTotalFromBreakdown(item);

            // Setup Fee
            if (item.setup_fees_details) {
                total += this.getSetupFeeTotal(item);
            } else {
                total +=
                    parseFloat(item.sp_setup_fee || 0) +
                    parseFloat(item.emb_setup_fee || 0);
            }

            // Name/Number fees (only for decoration type 1 and 2, as type 0 includes them in run charge)
            if (item.decoration_type != 0) {
                const itemPrices = item.item_prices || {};
                total +=
                    parseFloat(itemPrices.front_number_fees || 0) +
                    parseFloat(itemPrices.back_name_fees || 0) +
                    parseFloat(itemPrices.back_number_fees || 0) +
                    parseFloat(itemPrices.front_name_fees || 0);
            }

            return total;
        },

        // Get group subtotal (all items + combined color mix fee)
        getGroupSubTotal(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return this.getItemSubTotal(item);
            }

            let total = 0;
            const groupedItems = this.getGroupedItems(item);

            // Add subtotal for each item (excluding individual color mix fees)
            groupedItems.forEach((groupItem) => {
                total += this.getItemSubTotalExcludingColorMixFee(groupItem);
            });

            // Add combined color mix fee
            total += this.getCombinedColorMixFeeTotal(item);

            return total;
        },

        // Get Item Sub Total for grouped parent item (includes combined color mix fee)
        getItemSubTotalForGroupedParent(item) {
            if (!this.isGroupedDecorationType0(item)) {
                return this.getItemSubTotal(item);
            }

            // Get parent's item subtotal excluding color mix fee
            let total = this.getItemSubTotalExcludingColorMixFee(item);

            // Add combined color mix fee
            total += this.getCombinedColorMixFeeTotal(item);

            return total;
        },

        // Get Run Charge Total from Breakdown (for decoration type 0, 1, and 2)
        getRunChargeTotalFromBreakdown(item) {
            let total = 0;
            
            // Get breakdown for all types
            const breakdown = this.getRunChargeBreakdown(item);
            if (breakdown && breakdown.length > 0) {
                total = breakdown.reduce((sum, row) => {
                    // Skip INCL and "-" rows
                    if (
                        row.isIncluded ||
                        row.total === "INCL" ||
                        row.total === "-" ||
                        row.amt === "INCL" ||
                        row.amt === "-"
                    ) {
                        return sum;
                    }
                    return sum + parseFloat(row.total || 0);
                }, 0);
            }
            
            // Add services with rollup_fee_id = 12 (Run Charge services) - include all services regardless of show_service
            const runChargeServices = this.getRunChargeServices(item);
            if (runChargeServices && runChargeServices.length > 0) {
                const quantity = this.getTotalItemQuantity(item);
                runChargeServices.forEach(service => {
                    const servicePrice = service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === 'Per Item') {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }
            
            // If breakdown was empty, continue with fallback logic
            if (!breakdown || breakdown.length === 0) {
                // Fallback for type 0 only
                if (item.decoration_type == 0) {
                if (!item.decoration || !item.decoration.master_service) {
                    return 0;
                }

                // Fallback: calculate directly if breakdown is empty (type 0 only)
                const quantity = this.getTotalItemQuantity(item);
                const masterService = item.decoration.master_service;
                const location1stFee = parseFloat(
                    masterService.location_1st || 0
                );
                const additionalLocationFee = parseFloat(
                    masterService.additional_location || 0
                );
                const costPerColor1st = parseFloat(
                    masterService.cost_per_color_1st || 0
                );
                const costPerColor2ndOrMore = parseFloat(
                    masterService.cost_per_color_2ndormore || 0
                );

                let runCharge = 0;

                if (
                    item.imprint_locations &&
                    Array.isArray(item.imprint_locations)
                ) {
                    let locationIndex = 0;
                    item.imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            const noOfColors = parseInt(
                                location.no_of_color || 0
                            );

                            if (locationIndex === 0) {
                                // First location: location1stFee + all colors × costPerColor1st
                                runCharge +=
                                    (location1stFee +
                                        noOfColors * costPerColor1st) *
                                    quantity;
                            } else {
                                // Additional locations: additionalLocationFee + 1st color × costPerColor1st + additional colors × costPerColor2ndOrMore
                                const firstColorCost = costPerColor1st;
                                const additionalColorsCost =
                                    noOfColors > 1
                                        ? (noOfColors - 1) *
                                          costPerColor2ndOrMore
                                        : 0;
                                runCharge +=
                                    (additionalLocationFee +
                                        firstColorCost +
                                        additionalColorsCost) *
                                    quantity;
                            }

                            // Add decor upcharge from colors
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        runCharge +=
                                            parseFloat(
                                                color.color.decor_upcharge || 0
                                            ) * quantity;
                                    }
                                });
                            }

                            locationIndex++;
                        }
                    });
                }

                // Add Name/Number fees to run charge
                const frontFees = this.getNameNumberFeesFromItemPrices(
                    item,
                    "front"
                );
                const backFees = this.getNameNumberFeesFromItemPrices(
                    item,
                    "back"
                );
                [...frontFees, ...backFees].forEach((fee) => {
                    runCharge += parseFloat(fee.total || 0);
                });

                total += runCharge;
                }
            }

            // Return total (includes breakdown + rollup_fee_id = 12 services + fallback if needed)
            return parseFloat(total.toFixed(2));
        },

        // Get Item Sub Total (Base Fee + Run Charge + Color Mix Fee + Setup Fee + Name/Number fees)
        getItemSubTotal(item, parentItem = null) {
            // For grouped decoration type 0, 1, and 2 items, exclude individual color mix fee (will be shown separately)
            if (
                item.decoration_type === 0 ||
                item.decoration_type === 1 ||
                item.decoration_type === 2
            ) {
                // Check if parent is grouped (for subItems)
                if (parentItem && this.isGroupedDecorationType0(parentItem)) {
                    return this.getItemSubTotalExcludingColorMixFee(item);
                }
                // Check if item itself is grouped (for parent items)
                if (this.isGroupedDecorationType0(item)) {
                    return this.getItemSubTotalExcludingColorMixFee(item);
                }
            }

            let total = 0;

            // Base Fee Total
            total += this.getBaseFeeTotal(item);

            // Run Charge (includes name/number fees for all decoration types)
            total += this.getRunChargeTotalFromBreakdown(item);

            // Color Mix Fee (for decoration type 0, 1, and 2)
            if (
                item.decoration_type == 0 ||
                item.decoration_type == 1 ||
                item.decoration_type == 2
            ) {
                total += this.getColorMixFeeTotal(item);
            }

            // Setup Fee
            if (item.setup_fees_details) {
                total += this.getSetupFeeTotal(item);
            } else {
                total +=
                    parseFloat(item.sp_setup_fee || 0) +
                    parseFloat(item.emb_setup_fee || 0);
            }

            // Name/Number fees (only for decoration type 1 and 2, as type 0 includes them in run charge)
            if (item.decoration_type != 0) {
                const itemPrices = item.item_prices || {};
                total +=
                    parseFloat(itemPrices.front_number_fees || 0) +
                    parseFloat(itemPrices.back_name_fees || 0) +
                    parseFloat(itemPrices.back_number_fees || 0) +
                    parseFloat(itemPrices.front_number_decor_up_fees || 0) +
                    parseFloat(itemPrices.back_name_decor_up_fees || 0) +
                    parseFloat(itemPrices.back_number_decor_up_fees || 0);
            }

            return total;
        },

        // Get Run Charge base price (sum of decoration colors prices)
        getRunChargeBasePrice(item) {
            const quantity = this.getTotalItemQuantity(item);
            let runCharge = 0;

            // Decoration type 0 - PCNA
            if (item.decoration_type == 0) {
                if (!item.decoration || !item.decoration.master_service) {
                    return 0;
                }

                const masterService = item.decoration.master_service;
                const location1stFee = parseFloat(
                    masterService.location_1st || 0
                );
                const additionalLocationFee = parseFloat(
                    masterService.additional_location || 0
                );
                const costPerColor1st = parseFloat(
                    masterService.cost_per_color_1st || 0
                );
                const costPerColor2ndOrMore = parseFloat(
                    masterService.cost_per_color_2ndormore || 0
                );
                const fullColorValue = this.getFullColorValue(item);

                if (
                    item.imprint_locations &&
                    Array.isArray(item.imprint_locations)
                ) {
                    let locationIndex = 0;
                    item.imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            const isFullColor =
                                this.isLocationFullColor(location);
                            const noOfColors = parseInt(
                                location.no_of_color || 0
                            );

                            if (locationIndex === 0) {
                                // First location
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: location1stFee + fullColorValue
                                    runCharge +=
                                        (location1stFee + fullColorValue) *
                                        quantity;
                                } else {
                                    // Regular: location1stFee + all colors × costPerColor1st
                                    runCharge +=
                                        (location1stFee +
                                            noOfColors * costPerColor1st) *
                                        quantity;
                                }
                            } else {
                                // Additional locations
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: additionalLocationFee + fullColorValue
                                    runCharge +=
                                        (additionalLocationFee +
                                            fullColorValue) *
                                        quantity;
                                } else {
                                    // Regular: additionalLocationFee + 1st color × costPerColor1st + additional colors × costPerColor2ndOrMore
                                    const firstColorCost = costPerColor1st;
                                    const additionalColorsCost =
                                        noOfColors > 1
                                            ? (noOfColors - 1) *
                                              costPerColor2ndOrMore
                                            : 0;
                                    runCharge +=
                                        (additionalLocationFee +
                                            firstColorCost +
                                            additionalColorsCost) *
                                        quantity;
                                }
                            }

                            // Add decor upcharge from colors
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        runCharge +=
                                            parseFloat(
                                                color.color.decor_upcharge || 0
                                            ) * quantity;
                                    }
                                });
                            }

                            locationIndex++;
                        }
                    });
                }

                return runCharge;
            }

            // Decoration type 1 - Screen Print
            if (item.decoration_type == 1) {
                const fullColorValue = this.getFullColorValue(item);
                
                if (
                    item.sp_imprint_locations &&
                    Array.isArray(item.sp_imprint_locations)
                ) {
                    let locationIndex = 0;
                    item.sp_imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            const isFullColor =
                                this.isLocationFullColor(location);
                            const noOfColors = parseInt(
                                location.no_of_color || 0
                            );

                            if (locationIndex === 0) {
                                // First location
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: use fullColorValue
                                    runCharge += fullColorValue * quantity;
                                } else if (noOfColors > 1) {
                                    // Additional colors (if > 1)
                                    const secondColorPrice =
                                        this.getDecorationPrice(
                                            item,
                                            quantity,
                                            1,
                                            undefined,
                                            false
                                        );
                                    const firstColorPrice =
                                        this.getDecorationPrice(
                                            item,
                                            quantity,
                                            0,
                                            undefined,
                                            false
                                        );
                                    const additionalColorPrice =
                                        secondColorPrice - firstColorPrice;
                                    runCharge +=
                                        additionalColorPrice *
                                        (noOfColors - 1) *
                                        quantity;
                                }
                            } else {
                                // Additional locations
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: use same value as first location
                                    runCharge += fullColorValue * quantity;
                                } else if (noOfColors > 0) {
                                    // Regular: all colors
                                    const locationPrice =
                                        this.getDecorationPrice(
                                            item,
                                            quantity,
                                            0,
                                            undefined,
                                            true
                                        );
                                    runCharge +=
                                        locationPrice * noOfColors * quantity;
                                }
                            }

                            // Add decor upcharge from colors
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        runCharge +=
                                            parseFloat(
                                                color.color.decor_upcharge || 0
                                            ) * quantity;
                                    }
                                });
                            }

                            locationIndex++;
                        }
                    });
                }
            }
            // Decoration type 2 - Embroidery
            else if (item.decoration_type == 2) {
                const fullColorValue = this.getFullColorValue(item);
                
                if (
                    item.emb_imprint_locations &&
                    Array.isArray(item.emb_imprint_locations)
                ) {
                    let locationIndex = 0;
                    item.emb_imprint_locations.forEach((location) => {
                        if (location.is_selected) {
                            const isFullColor =
                                this.isLocationFullColor(location);
                            const noOfColors = parseInt(
                                location.no_of_color || 0
                            );

                            if (locationIndex === 0) {
                                // First location
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: use fullColorValue
                                    runCharge += fullColorValue * quantity;
                                }
                                // Otherwise first location is free
                            } else {
                                // Additional locations
                                if (isFullColor && fullColorValue > 0) {
                                    // Full color: use same value as first location
                                    runCharge += fullColorValue * quantity;
                                } else if (noOfColors > 0) {
                                    // Regular: all colors
                                    const locationPrice =
                                        this.getDecorationPrice(
                                            item,
                                            quantity,
                                            0,
                                            locationIndex
                                        );
                                    runCharge +=
                                        locationPrice * noOfColors * quantity;
                                }
                            }

                            // Add decor upcharge from colors
                            if (
                                location.colors &&
                                Array.isArray(location.colors)
                            ) {
                                location.colors.forEach((color) => {
                                    if (
                                        color.color &&
                                        color.color.decor_upcharge
                                    ) {
                                        runCharge +=
                                            parseFloat(
                                                color.color.decor_upcharge || 0
                                            ) * quantity;
                                    }
                                });
                            }

                            locationIndex++;
                        }
                    });
                }
            }

            return runCharge;
        },

        // Get Setup Fee base price
        getSetupFeeBasePrice(item) {
            return (
                parseFloat(item.sp_setup_fee || 0) +
                parseFloat(item.emb_setup_fee || 0)
            );
        },

        // Get Setup Fee Total from setup_fees_details
        getSetupFeeTotal(item) {
            let total = 0;
            
            if (item.setup_fees_details) {
                // Use total from setup_fees_details if available and > 0
                if (
                    item.setup_fees_details.total &&
                    parseFloat(item.setup_fees_details.total) > 0
                ) {
                    total = parseFloat(item.setup_fees_details.total);
                } else if (
                    item.setup_fees_details.locations &&
                    item.setup_fees_details.locations.length > 0
                ) {
                    total = item.setup_fees_details.locations.reduce(
                        (sum, location) => {
                            return sum + parseFloat(location.total || 0);
                        },
                        0
                    );
                }
            }
            
            // Add services with rollup_fee_id = 2 (Setup Fee services) - include all services regardless of show_service
            const setupFeeServices = this.getSetupFeeServices(item);
            if (setupFeeServices && setupFeeServices.length > 0) {
                const quantity = this.getTotalItemQuantity(item);
                setupFeeServices.forEach(service => {
                    const servicePrice = service.retail_cost || service.net_cost || 0;
                    if (service.fee_structure === 'Per Item') {
                        total += parseFloat(servicePrice) * quantity;
                    } else {
                        total += parseFloat(servicePrice);
                    }
                });
            }

            return parseFloat(total.toFixed(2));
        },

        // Get active product discount for an item
        getActiveProductDiscount(item) {
            if (
                !item.main_new_product ||
                !item.main_new_product.MainNewProductDiscount
            ) {
                return null;
            }

            const discount = item.main_new_product.MainNewProductDiscount;

            // Return null if discount doesn't exist
            if (!discount) {
                return null;
            }

            // Check status if it exists (optional field)
            if (discount.status !== undefined && !discount.status) {
                return null;
            }

            // Check dates if they exist (optional fields)
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            // Check start date if exists
            if (discount.start_date) {
                const startDate = new Date(discount.start_date);
                startDate.setHours(0, 0, 0, 0);
                if (today < startDate) {
                    return null; // Not started yet
                }
            }

            // Check end date if exists
            if (discount.end_date) {
                const endDate = new Date(discount.end_date);
                endDate.setHours(0, 0, 0, 0);
                if (today > endDate) {
                    return null; // Expired
                }
            }

            // Validate discount_type and discount_value
            if (!discount.discount_type || !discount.discount_value) {
                return null;
            }

            return discount;
        },

        // Calculate discount amount for an item
        // For grouped items (same item_id + service_id): discount is calculated ONCE on Group Sub Total only
        // For single items: discount is calculated on Item Sub Total
        // Note: This method should only be called for parent items, not subItems
        getItemDiscount(item) {
            const activeDiscount = this.getActiveProductDiscount(item);
            if (!activeDiscount) {
                return 0;
            }

            // For grouped items (same item_id + service_id), calculate discount on Group Sub Total (all items combined)
            // This ensures discount is applied only ONCE for the entire group, not per item
            let preDiscountTotal = 0;
            if (this.isGroupedDecorationType0(item)) {
                preDiscountTotal = this.getGroupSubTotal(item);
            } else {
                // For single items, calculate discount on Item Sub Total
                preDiscountTotal = this.getItemSubTotal(item);
            }

            if (preDiscountTotal <= 0) {
                return 0;
            }

            const discountType = activeDiscount.discount_type;
            const discountValue = parseFloat(
                activeDiscount.discount_value || 0
            );

            if (discountType === "Percent") {
                return parseFloat(
                    ((preDiscountTotal * discountValue) / 100).toFixed(2)
                );
            } else {
                // Fixed amount
                return parseFloat(
                    Math.min(preDiscountTotal, discountValue).toFixed(2)
                );
            }
        }
    }
};
</script>

<style>
.accordion_action {
    vertical-align: top !important;
    text-align: right !important;
    min-width: 90px !important;
}

.cart_icon_image {
    display: flex !important;
    align-items: center;
}

.cart_icon_image img {
    width: 16px;
    height: 16px;
}

.cart_table .table tbody tr td .cart_image .hover_search {
    right: 85px !important;
}

.delete_block {
    display: flex;
    justify-content: space-between;
}

.cart_page_vthree .item-image .standard_colors {
    margin-top: 2px !important;
    justify-content: left !important;
}

.cart_table .table tbody tr td .cart_image {
    margin-bottom: 20px !important;
}

.cart_page_vthree .cart_table {
    overflow: inherit;
}

/* .cart_page_vthree .cost-label {
        min-width: 80px;
    } */

.cart_page_vthree .cost-breakdown {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.cart_page_vthree .cost-item {
    gap: 275px;
}

.cart_page_vthree .cost-separator {
    width: 100%;
}

.cart_page_vthree .cart_table .table tbody tr td.price_data_block {
    padding: 16px 12px !important;
}

.cart_page_vthree .discount-value {
    color: #dc3545 !important;
}
.cart_page_vthree .cost-item.cost-total {
    margin: 0px !important;
}
.cart_page_vthree .cost-disocunt-row {
    padding-bottom: 10px !important;
    padding-top: 10px !important;
}
</style>

<!-- All cart_page_vthree styles have been moved to /public/maincss/scss/components/_cart.scss --> 